/*
===================================================================================================
This module declares top-level methods and instantiates the AE object. It must be loaded first.
===================================================================================================
*/


/*
The AE object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the APP.ui object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
;
var AE = AE || (function() {
    /* This is where we set variables and things that will only live inside the closure. */
    var APP = {
        resizeTasks: [],
        scrollTasks: [],
        transitionTasks: [],
        displayObjects: {
            /*
            This is just a container for any custom modules that go along with Mura display objects. There
            isn't an init function for this. It's more of a library for other submodules.

            Nothing will be added in this file. Display objects will add themselves to it, and will live
            within the AE object.

            It's important to know that display objects could load before this file. To prevent that, they
            are written to only run when a global Deferred Object is resolved by this controller module,
            and to add themselves to the displayObjects property at that time.
            */
        },
        components: {
            // A container for custom components in Mura. They'll be added in a way that's similar to display objects.
        },
        init: function() {
            APP.props = {
                $bodyElement: $('body'),
                $scrollContainer: $('#scroll-container'),
                $scrollContent: $('#scroll-content'),
                $stickyWrapper: $('#sticky-wrapper'),
                $siteContainer: $('#site-container'),
                $mainFooter: $('#main-footer'),
                $mainFooterContent: $('#main-footer__content'),
                $mainNav: $('#mainnav'),
                $masthead: $('#masthead'),
                $mainNavLink: $('#mainnav__link'),
                $mainNavFull: $('#mainnav').add('#mainnav__link'),
                isLegacy: ($('html').hasClass('ua-ie-9')), // If the user is browsing with IE 9, No longer support 8.
                isIE: false,
                googleMapsAPIKey: '',
                isAUNZ: false
            };

            if (oSite) {
                if (_.isObject(oSite)) { $.extend(true, APP.props, oSite); }
            }
            if (AE.props.chaosSystem) { APP.props.isAUNZ = (AE.props.chaosSystem === 'AU' || AE.props.chaosSystem === 'NZ') ? true : false; }
            APP.buildURLObject();

            /*
            The transition event is different across browsers, so this function will loop through them
            until it gets a hit. Once done, event handlers can be registered to the variable. This is
            currently used in the matrix, with a fallback to jQuery animate for legacy browsers. - bcribb
            */
            APP.props.transEnd = (function() {
                var t;
                var el = document.createElement('fakeelement');
                var transitions = {
                    'transition': 'transitionend',
                    'OTransition': 'oTransitionEnd',
                    'MozTransition': 'transitionend',
                    'WebkitTransition': 'webkitTransitionEnd'
                };

                for (t in transitions) {
                    if (el.style[t] !== undefined) {
                        return transitions[t];
                    }
                }
            })();
			
			/* getSiteViewType() references the props object, so this can't just be tossed into props. */
			APP.windowSize = APP.getSiteViewType();
			
			// Set the Criteo Tag view type to the data layer object
			aeDataLayer.push({"criteoSiteType":APP.getCriteoTagSiteViewType()});
			
			/*
				This will be used to compare window width before and after a resize. This way, we only resize
				when the window WIDTH changes, and not when the height changes. Starts as null because
				manageResize needs to fail the first test so it can run once on page load.
			*/
			APP.width = null;
			
			if (AE.privateBrowsing) {
				AE.privateBrowsing.init();
			}
			if (AE.nav) {
				AE.nav.init();
			}
			/* Legacy and Utils are used by Autocomplete. */
			if (AE.legacy) {
				AE.legacy.init();
				APP.props.isIE = AE.legacy.grief.isIE;
			}
			if (AE.utils) {
				AE.utils.init();
			}
			if (AE.ui) {
				AE.ui.init(); /* This init will run init functions for its sub-modules. */
			}
			if (AE.ga && AECookie.read('iosTrackingDisabled') !== 'true') { /*Google Analytics*/
				AE.ga.init();
			}
			if (AE.cd && AECookie.read('iosTrackingDisabled') !== 'true') {/* Tracking Dimensions */
				window.addEventListener('load', checkAEcd);
			}
			if (AE.forms) {
				AE.forms.init();
			}
            if (AE.maps) {
                AE.maps.init();
            }
			if (AE.account) {
				AE.account.init();
			}
            if (AE.modal) {
                AE.modal.init();
            }
			if (AE.mura) { 
				window.addEventListener('load', checkMura);
			}
			if (AE.newsletter) {
				AE.newsletter.init();
			}
             if (AE.feeds) {
                AE.feeds.init();
            }
            if (AE.booking && $('#aebooking,#aemodify,#peugeot-buy-back')[0]) {
                AE.booking.init(); /* This init will run init functions for its sub-modules. */
            }
			// White label iFrame pages
			if ($('.whitelabel-if')[0]) {
				window.addEventListener('load', checkWlIframeResizer);
			}
            
            // Preventing persistent button loading states
            // WEBAE3-5945 - Reset any disabled elements on initial page show (to fix back/forward navigation issues)
            window.addEventListener('pageshow', resetLoadingBtns);

            function resetLoadingBtns()
            {
                $('.ui--btn-submit-wait').removeAttr('disabled').removeClass('btn--no-icon').find('i.fa-cog').remove();
                $('.rateFinger__button').removeAttr('disabled').removeClass('btn--no-icon');
                $('.insurance__options.last td.btn-disabled i.fa-cog, #insuranceUI .package-btn-wrapper.btn-disabled i.fa-cog').remove();
                $('.insurance__options.last td.btn-disabled, #insuranceUI .package-btn-wrapper.btn-disabled').removeClass('btn-disabled');
                $('#carUpgradeY, #carUpgradeN').removeAttr('disabled');
                $('.fingerCancelLink').css('pointer-events', 'all');
                
                // iPhone Safari only:
                if($('body').attr('id') == 'results' && $('html').hasClass('ios') && $('html').hasClass('mobile') && $('html').hasClass('ua-safari') && $('.ui--btn-submit-wait').length) {
                    AE.ui.init();
                    AE.booking.matrix.init();
                    AE.ui.search.init();
                }
                
                $('.ui--btn-submit-wait').removeClass('ui--btn-submit-wait');
            }
            
			// White label page within an iFrame window
			function checkWlIframeResizer() {
				if ('parentIFrame' in window) {
					// AE PAGE URLs: /, /search/, /results/, /options/, /upgrade/, /checkout/, /confirmation/
					var wlIframePagesNotToScrollToTheTop = ["", "/", "/search/", "/foo/", "/bar/"]; //zero-based
					if (wlIframePagesNotToScrollToTheTop.indexOf(oSite.path_info) < 0) {
						// if we do not find a page in the list, that means we want to shift the parent page
						var amountOfParentWindowToShow = 50; //in pixels
						window.parentIFrame.getPageInfo(function(parentPageInfo) { 
							var distanceFromParentTopToIframe = parentPageInfo.offsetTop;
							var amountToScrollParentWindow = distanceFromParentTopToIframe - amountOfParentWindowToShow;
							window.parentIFrame.scrollTo(0, amountToScrollParentWindow); //scroll the parent page
							window.parentIFrame.getPageInfo(false); //stop trying to auto-scroll
						});
					} else if (wlIframePagesNotToScrollToTheTop.indexOf(oSite.path_info) == 0 || wlIframePagesNotToScrollToTheTop.indexOf(oSite.path_info) == 1) {
						// This is the homepage (array is zero-based)
						/*
						window.parentIFrame.scrollTo(0,0); //scroll the parent page to it's top
						window.parentIFrame.getPageInfo(false); //stop trying to auto-scroll
						*/
					}
					
					window.removeEventListener('load', checkWlIframeResizer);
					return;
				}
				setTimeout(function(){
					return checkWlIframeResizer();
				},100); // wait 1/10th of a second
			}
			
			function checkAEcd() {
				if ('AECustomDimension' in window) {
					AE.cd.init();
					window.removeEventListener('load', checkAEcd);
					return;
				}
				return checkAEcd();
			}
			
			function checkMura() {
				if ('mura' in window) {
					AE.mura.init();
					window.removeEventListener('load', checkMura);
					return;
				}
				return checkMura();
			}
			
            /*
            Setup debouncing for resize tasks. Run the manageResize function once upon init. This part relies upon having UnderscoreJS
            loaded along with jQuery. It runs all resize tasks at the end of a resize. DO NOT CHANGE THIS TO A THROTTLE. It lowers our
            performance considerably and the manageResize task will error out.
            http://underscorejs.org/
            */
            var debounced = _.debounce(APP.manageResize, 250);
            $(window).on('resize', debounced);

            var debounceScroll = _.debounce(APP.manageScroll, 0, true);
            $('#scroll-content').on('scroll', debounceScroll);

            /* Initial resize tasks */
            var initTasks = {
                func: function() {
                    /* These lines of code will be run during resize, but they'll be throttled. */

                    var siteSize = APP.getSiteViewType();

                    /* Support for CSS break-points */
                    if (siteSize === 'desk' || siteSize === 'desk-wide') {
                        // Add or remove classes if the window is big.
                    } else {
                        // Add or remove classesif the window is small.
                    }

                    /* Some tasks need to be run only when transitioning to or from the palm size. */

                    /* If the current size doesn't match the last known size. */
                    if (APP.windowSize !== siteSize) {

                        if (APP.windowSize === 'palm') {
                            /* Starting size was palm, which means that we're getting larger. Moving up. */
                            APP.palmTransition(false);
                        } else {
                            /*
                            Started at a larger size, so we only want to do something if we're going to palm. We don't want
                            to change anything if we're just going from 'desk' to 'lap', for example.
                            */
                            if (siteSize === 'palm') {
                                APP.palmTransition(true);
                            }
                        }
                        /* After sorting out what to do, set the new props size. */
                        APP.windowSize = siteSize;

                    } else {
                        /* Sizes match, so there's no need to do anything. */

                    }
                },
                args: [] // No arguments, so it's an empty array.
            };
            initTasks.func(initTasks.args); // Initial call of initial resize task.
            APP.addResizeTask(initTasks);
            APP.manageResize();
            
            /* Uncomment this block of code to see when the palmTransition() function fires, and to see the arguments array.
            var myFunction = function() {
            console.log('myfunction: ' + arguments[0]);
            console.log(arguments);
            }
            var myTask = {func:myFunction, args:['arg1','arg2']}
            APP.addTransitionTask(myTask);
            */
            dfd_ready.resolve();
            if (AE.forms) AE.forms.postAutoForm();
        },
        _augmentPrivateBrowsingLocalStorage: function() {
            // See gist.github.com/jarrodirwin/
            // Refer to gist.github.com/remy/350433
            var Storage = function(type) {
                function createCookie(name, value, days) {
                    var date, expires;

                    if (days) {
                        date = new Date();
                        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                        expires = "; expires=" + date.toGMTString();
                    } else {
                        expires = "";
                    }
                    document.cookie = name + "=" + value + expires + "; path=/";
                }

                function readCookie(name) {
                    var nameEQ = name + "=",
                        ca = document.cookie.split(';'),
                        i, c;

                    for (i = 0; i < ca.length; i++) {
                        c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1, c.length);
                        }
                        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                    }
                    return null;
                }

                function setData(data) {
                    data = encodeURIComponent(JSON.stringify(data));
                    return (type == 'session') ? createCookie(getSessionName(), data, 365) : createCookie('localStorage', data, 365);
                }

                function clearData() {
                    return (type == 'session') ? createCookie(getSessionName(), '', 365) : createCookie('localStorage', '', 365);
                }

                function getData() {
                    var data = type == 'session' ? readCookie(getSessionName()) : readCookie('localStorage');
                    return data ? JSON.parse(decodeURIComponent(data)) : {};
                }

                function getSessionName() {
                    if (!window.name) window.name = new Date().getTime();
                    return 'sessionStorage' + window.name;
                }

                var data = getData();

                return {
                    length: 0,
                    clear: function() {
                        data = {};
                        this.length = 0;
                        clearData();
                    },
                    getItem: function(key) {
                        return data[key] === undefined ? null : data[key];
                    },
                    key: function(i) {
                        // not perfect, but works
                        var ctr = 0;
                        for (var k in data) {
                            if (ctr == i) return k;
                            else ctr++;
                        }
                        return null;
                    },
                    removeItem: function(key) {
                        delete data[key];
                        this.length--;
                        setData(data);
                    },
                    setItem: function(key, value) {
                        data[key] = value + '';
                        this.length++;
                        setData(data);
                    }
                };
            };

            // Replace window.localStorage and window.sessionStorage with out custom implementation.
            var localStorage = new Storage('local');
            var sessionStorage = new Storage('session');

            window.localStorage = localStorage;
            window.sessionStorage = sessionStorage;
            // For Safari private browsing need to also set the proto value.
            if (window.localStorage) {
                window.localStorage.__proto__ = localStorage;
                window.sessionStorage.__proto__ = sessionStorage;
            }
        },
        addResizeTask: function(task) {
            /*

            Adds and object with a "func" property and an "args" property. This is VERY important, because we use the apply() method
            in manageResize(). All tasks in the queue will be run during resize. We throttle resizing to keep things from getting too crazy.

            Basic syntax:
            myTask = {func:myFunction, args:[arg1,arg2]}

            Example of adding a task:
            var myTask = { func: function(){console.log("I'm resizing!")} }
            APP.addResizeTask(myTask);

            Or you could be fancy and do this:
            APP.addResizeTask( { func: function(){console.log("I'm resizing!")} } );
            */

            task.args = task.args || [];
            APP.resizeTasks.push(task);
        },
        addScrollTask: function(task) {
            task.args = task.args || [];
            APP.scrollTasks.push(task);
        },
        addTransitionTask: function(task) {
            /*
            Same as addResizeTask() but meant for the transition between the "palm" size and anything larger.

            IMPORTANT NOTE: Syntax is the same as above, but the first argument will always be the direction of the transition. So if you
            send in the following:
            -- var myTask = {func:myFunction, args:[arg1,arg2]}
            -- APP.addTransitionTask(myTask);

            It would be executed like this:
            -- myFunction(direction,arg1,arg2);

            */

            task.args = task.args || [];

            /*
            Insert a false value in the beginning of the args array. This is a placeholder for the "toPalm" variable and will be updated
            each time the palmTransition() function is run.
            */
            task.args.unshift(false);
            APP.transitionTasks.push(task);
        },
        manageResize: function() {
            var newWidth = APP.props.$bodyElement.outerWidth(true);


            // Correct footer height
            if (APP.props.$bodyElement.hasClass('searchwait') || APP.props.$bodyElement.hasClass('sticky-active')) {

                // The CSS kills the absolute positioning on the footer, so we don't need to compensate by addign padding to the container.
                var footerHeight = (APP.getSiteViewType() === 'palm') ? 0 : $('#main-footer__content').outerHeight(true);

                APP.props.$mainFooter.height(footerHeight); //.addClass('sticky');
                APP.props.$stickyWrapper.css('padding-bottom', footerHeight);
            }


            // If the width has changed, then run resize tasks. Forget the window height.
            if (APP.width !== newWidth) {

                // Set width to the new window width
                APP.width = newWidth;

                // Cycle through resize tasks.
                for (var i = 0; i < APP.resizeTasks.length; i++) {
                    var task = APP.resizeTasks[i];
                    task.func.apply(this, task.args);
                }
            }
        },
        manageScroll: function() {
            // Cycle through scroll tasks.
            for (var i = 0; i < APP.scrollTasks.length; i++) {
                var task = APP.scrollTasks[i];
                task.func.apply(this, task.args);
            }
        },
        heightAdjust: function() {
            var eleHeight = 0;

            $(arguments[0]).each(function() {
                $(this).height(''); // set to auto height
            });
            $(arguments[0]).each(function() {
                eleHeight = ($(this).height() > eleHeight) ? $(this).height() : eleHeight; // find tallest element
            });
            $(arguments[0]).each(function() {
                $(this).height(eleHeight); // set height of the tallest element
            });

            return eleHeight;
        },
        palmTransition: function(toPalm) {
            /*
            NOTE: This function is called by initTasks(), which is the first task function added to manageResize() above. Every resize,
            the window size is checked to see if this function should be run.

            Once run, we cycle through the palm transition tasks. "toPalm" is true when arriving at palm from a larger size, false when moving up from
            palm to a larger size. We initialize the variable to false in case it isn't passed in for some reason.
            */
            toPalm = toPalm || false;
            for (var i = 0; i < APP.transitionTasks.length; i++) {
                var task = APP.transitionTasks[i];
                /* The first argument is inserted by addTransitionTask() as a placeholder for the "toPalm" variable. */
                task.args[0] = toPalm;
                task.func.apply(this, task.args);
            }
        },
        getSiteViewType: function() {
            var sizes = {
                /*
                Support for CSS break-points. If you change them in the variables Sass file, then
                you need to change them here as well. This function should be used in harmony with CSS.
                */
                lapStart: 701,
                deskStart: 1024,
                deskWideStart: 1200
            };
            currentSize = APP.props.$bodyElement.outerWidth(true);
            sizeType = "palm";

            if (currentSize >= sizes.lapStart) {
                sizeType = "lap";
            }
            if (currentSize >= sizes.deskStart) {
                sizeType = "desk";
            }
            if (currentSize >= sizes.deskWideStart) {
                sizeType = "desk-wide";
            }
            return sizeType;
        },
		getCriteoTagSiteViewType: function() {
			switch (AE.getSiteViewType()) {
				case 'palm':
					sizeType = 'm';
					break;
				case 'lap':
					sizeType = 't';
					break;
				case 'desk':
				case 'desk-wide':
					sizeType = 'd';
					break;
				default:
					sizeType = 'd';
					break;
			}
	
			return(sizeType);
		},
        buildURLObject: function() {
            APP.url = APP.url || {};
            APP.url.props = APP.url.props || {};
            APP.url.props.host = window.location.hostname;
            APP.url.props.path = window.location.pathname;
            APP.url.props.protcol = window.location.protocol;
            APP.url.props.query = window.location.search;
            APP.url.props.href = window.location.href;
            var qString = (APP.url.props.query.length && APP.url.props.query.substring(0, 1) === '?') ? APP.url.props.query.substring(1) : APP.url.props.query;
            var aPairs = qString.split('&');
            for (var i = 0; i < aPairs.length; i++) {
                var aKeyVal = aPairs[i].split('=');
                if (aKeyVal[0].trim().length) APP.url[aKeyVal[0].trim()] = (aKeyVal[1]) ? aKeyVal[1].trim() : true;
            }
        }
    };
    return APP;
})();

/*
The comments below will tell the Prepros app to append the listed JavaScript files, resulting in one big JavaScript file.
Our third-party service will then minify this in Production.
http://discuss.prepros.io/t/concatenate-and-minify-javascript/19
*/
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist.  */

AE.account = AE.account || (function () {
	/*
	DEPENDENCIES: AE
	*/
	var APP = {
		init: function () {
			$('.arrow').show();
			var resetInput = document.getElementById('member_reset_email');
			var resetBttn = document.getElementById('account_lookup_button');

			 APP.props = {
                $resetInput: document.getElementById('member_reset_email'),
                $resetBttn: $("form.validate"),
                $isInCheckout: window.location.pathname.split('/')[1] == 'checkout',
 				$isInMemberAccount: window.location.pathname.split('/')[1] == 'member-accounts',
                $accountLoginForm: $("form#account_login_form:visible"),
                $isInLogin:($("form#account_login_form:visible").length !=0) ? true :false,
                $isLoggedIn: (window.jsloginStatus == 'true' || window.jsloginStatus)? true :false, 
                $memberDefaultSection: $('#member_account_information_block'),    
                $ObjMember: '/plugins/ae3/lib/Member3.cfc' ,
                $ObjAff: '/plugins/ae3/lib/Affiliate3.cfc'                           
         	};         	

			if(APP.props.$resetInput){
				APP.props.$resetInput.addEventListener('keydown',function(e){
					if(e.which == 13){
						e.preventDefault();
						APP.props.$resetBttn.click();
					}
				});
			}

			//Added for WEBAE3-4802 - VM

			let countryStates = ['US', 'AU', 'CA', 'BR', 'ZA'];

			//Patch to avoid breaking search form - BIll 19 Jan 26
			$(window).on('load', function () {
				try {
					var selectedName = $('.country--select').find(':selected').val();

					if (Array.isArray(countryStates) && countryStates.includes(selectedName)) {
						$('.state-container').show();
					} else {
						$('.state-container').removeAttr('style').hide();
					}
				} catch (e) {
					//console.error('Error handling country/state selection:', e);
				}
			});

			
			//Added for WEBAE3-4802 - VM
			
			$('.country--select').change(function(){
				var chosenCountry = $(this).val();			
				if(countryStates.includes(chosenCountry)){ 
					$('.state-container').show();
				}
				else {
					$('.state-container').removeAttr("style").hide();
				}
			});

			$('#account_update').on('focus', '.state--select,.country--select', function(){				
			 	var isValid = $(this).parent().hasClass('ui-state-valid'); 
			 	var isInValid = $(this).parent().hasClass('ui-state-invalid'); 
			 	if(!isValid && !isInValid){$(this).parent().css("border", "2px solid #3089e0");}
			});

			$('#account_update').on('blur', '.state--select,.country--select', function(){				
			 	$(this).parent().css("border", "2px solid #5fba35");
			});

			$('div.member_accounts [data-pattern="notblank"],div.member_accounts [data-pattern="email"]').on('keyup blur', function(ele) {
				var $formId = $(this).parents('form').attr('id');
				var $fld = $(this).attr('name');
				APP.clearServerError($formId,$fld);					
			});

		
			// only initilize load member information for acount logged in page
			//isInMemberAccount = window.location.pathname.split('/')[1] == 'member-accounts';
		
			$('input.validateEmail').on('keyup blur', function(ele) {
				var $formId = $(this).parents('form').attr('id');
				var $match = $(this).attr('data-match');
				var $checkOther = $('#' + $formId +  ' input[name=' + $match + ']');
				APP.initCustomMatchVerification(this);
				APP.initCustomMatchVerification($checkOther);				
			});

		
			$('input.validateRemail').on('keyup blur', function(ele) {
				APP.initCustomMatchVerification(this);	
			});

			$('input.validateRemail').on('paste', function(ele) {
				var $formId = $(this).parents('form').attr('id');
				APP.removeGuardianError($formId,$(this).attr('name'));
			});


		    $('input#member_reemail').on('blur keyup', function(ele) {
				APP.initCustomMatchVerification(this);
			});
	
		   $('input.validateRepass').on('focus blur keyup', function() {
		   		var $result = APP.initCustomMatchVerification(this);
			});

			$('input.validatePassword').on('focus keyup blur', function(ele) {

				var $formId = $(this).parents('form').attr('id');

				var $match = $(this).attr('data-match');
				var $checkOther = $('#' + $formId +  ' input[name=' + $match + ']');
				if($(this).hasClass('legacy')){
					APP.checkPasswordLegacy($formId);
				}
				else{
					APP.checkPassword($formId);
					APP.initCustomMatchVerification($checkOther);
				}						
			});

		  $('input#current_password').on('blur', function(ele) {
				var $formId = $(this).parents('form').attr('id');
			    var $error_ele = APP.getErrorEle($formId,$(this).attr('name'));
				APP.removeGuardianError($formId,$(this).attr('name'));
				$($error_ele ).html('');	
			});


	       $('input.current_pwd').on('blur', function(ele) {
				var $formId = $(this).parents('form').attr('id');
			    var $error_ele = APP.getErrorEle($formId,$(this).attr('name'));
				//APP.removeGuardianError($formId,$(this).attr('name'));
				$($error_ele ).html('');	
			});

		    $('input#member_email').on('blur', function(ele) {
		  	     var $formId = $(this).parents('form').attr('id');
		  	     var $error_ele = APP.getErrorEle($formId,'member_email');
				$($error_ele).html('');	
			});

			if (APP.props.$isInMemberAccount && !APP.props.$isInLogin) {

				 $('#member_signup #country,#state').on('blur', function() {
					$(this).parent().css("border", "2px solid #5fba35");					
				 });

				 $('#member_signup #country,#state').on('focus', function() {
				 	var isValid = $(this).parent().hasClass('ui-state-valid'); 
				 	var isInValid = $(this).parent().hasClass('ui-state-invalid'); 
				 	if(!isValid && !isInValid){$(this).parent().css("border", "2px solid #3089e0");}					
				 });

				//jsloginStatus status appears to be not a true boolean
				if (APP.props.$isLoggedIn  && APP.props.$memberDefaultSection.length != 0) {
					/* Member Account page */
					$('#account_update_button').attr('disabled', false);
					APP.loadAccountInformation(false);
					//WEBAE3-4930 fire ajax call if opening payment section via nav link, only run
					//this if we have correct div
					if(document.getElementById('member_payment_information_block')){
						APP.getPayOptions();
					}
					// If we are getting to the member account page via link, determine which section to show
					if ( localStorage.getItem('memberAccountSection') && _.isString(localStorage.getItem('memberAccountSection')) && localStorage.getItem('memberAccountSection') != '') {
						APP.navigateMemberPageLocalStorage();
					 }
				}
		}

		AE.ui.addBodyClickTask({
			func: APP.onBodyClick
		});

	},

	/* Body Click Watch Tasks */
	onBodyClick: function (event, $target) {		

		// Prevent the 'Enter Key' from submitting forms
		if (event.which !== 13) {
			var elemID, thisForm;
			// only initilize load member information for acount logged in page
			//var isInMemberAccount = window.location.pathname.split('/')[1] == 'member-accounts';
			if($target.hasClass('member_login_portable') || $target.parent().hasClass('member_login_portable')) {
			
				AE.ui.dialog.launch({
					selector:'#memberloginNav',
					dialogClass:'account-signinform account-signinform--portable',
					titleBar: false
				});
			}
			/* NAVBAR MEMBER LINKS */
			if($target.hasClass('my-account-dropdown') && APP.props.$isInMemberAccount) {
				event.preventDefault();
			}
			if ($target.is('#member_my_reservations_link')) {
				localStorage.setItem('memberAccountSection', 'my_reservations');
			}
			if ($target.is('#member_account_information_link')) {
				APP.loadAccountInformation(false);
				localStorage.setItem('memberAccountSection', 'account_information');
			}
			if ($target.is('#member_payment_information_link')) {
				localStorage.setItem('memberAccountSection', 'payment_information');
			}
			if ($target.is('#member_promotions_link')) {
				localStorage.setItem('memberAccountSection', 'promotions');
			}
			if ($target.is('#member_customer_support_link')) {
				localStorage.setItem('memberAccountSection', 'customer_support');
			}
			if(!APP.props.$isInMemberAccount &&  $target.hasClass('member_link')){
				window.location.replace('/member-accounts');
			}
			if(APP.props.$isInMemberAccount &&  $target.hasClass('member_link') && APP.props.$isInLogin && window.jsloginStatus == 'true'){
				window.location.replace('/member-accounts');
			}
			if($target.parent().parent().is('#member_account_information_block')){APP.loadAccountInformation(false);}

			if ($target.closest('div.menu-dropdown').hasClass('account-signinform') &&  $target.hasClass('ui-dialog-titlebar-close')){
			 	var resetHidden= $("#memberPasswordResetNav").hasClass('visuallyhidden');
				if(!resetHidden){
					APP.setHTML('member-response-left', ''); 
					APP.hideEle('memberPasswordResetNav');
					APP.showEle('memberloginNav');
					$("#member_reset_password_nav").find("input[type=text], input[type=password], input[type=email]").val("");
				}
			 }

			if($target.hasClass('account_post') &&  APP.props.$isInMemberAccount && !$target.hasClass('memberLogout') && !APP.props.$isInLogin){
				APP.navigateMemberPageLocalStorage();
			}
	
			if ($target.is('#submitForm') &&  $(event.target).attr('data-value') == 'btt-submit_booking') {
				var frm_selector =  'form#ae-checkout';
				var $forms = $(frm_selector);
				AE.forms.applyGuardian($forms);
				AE.forms.addSpinGear($target);

				$("form#ae-checkout").submit();

				var eleInvalid = $(frm_selector + " .ui-state-invalid")[0];	
				if (eleInvalid){
				    AE.forms.removeSpinGear($target);
				} 
			}

			if ($target.is('#acct__pswd__submit')) {
				 var $thisForm = $target.closest('form')[0];
				 var $matchEle = $("form#" + $thisForm.id + " input.validateRepass");				
				 $("span.custom_msg").html('');
				 $($thisForm).submit();									
			}

			/************************ Aff ACCOUNT BUTTONS   **********************/			

			if ($target.is('#bttn_aff_pass_lookup')) {
				AE.forms.addSpinGear($target);
				APP.sendResetAff($target);								
			}

			if ($target.is('#btn_aff_pass_reset')) {
				APP.submitAndCheckresetPasswordAff($target);						
			}

			if ($target.is('#btn_aff_login')) {
				AE.forms.addSpinGear($target);						
			}

			if ($target.is('#submitForm') &&  $(event.target).attr('data-value') == 'btn_aff_signup') {
				var $thisForm = $target.closest('form')[0];
			    $("form#" + $thisForm.id + " span.custom_msg").html('');
			}

			if($target.hasClass('bttn_aff_pass_update--cancel')){
				$("div.frm_aff_update").removeClass('visuallyhidden'); 
				$( "div#aff_pass_result" ).remove();
				$( "button.bttn_aff_pass_update--cancel" ).remove();
				$('div.secnav')[0].scrollIntoView({behavior:'smooth',block: 'start'});
			}

			if($target.hasClass('btn--affOp')) {
				$("div.aff_frm_result").html('');
			}
			
			/********* MEMBER ACCOUNT BUTTONS ******************/

			// Account logout link
			if ($target.hasClass('memberLogout')) {
			
				if(!$target.hasClass('noSpinner')){
					$('.arrow').hide();
					AE.forms.addSpinGear($target);
				}
				// WEBAE3-2167 clear local storage on logout
				try {
					localStorage.clear();
				} catch (err) {
					// no local storage to clear
				}
				$('#account_form .account_form').val($(event.target).attr('data-value'));

				if(APP.props.$isInMemberAccount){
					$('#account_form input[name=form_location]').val('member-account');
				}
				APP.logOutMember();
				//$('#account_form').submit();
			}

			// Member login
			if ($target.is('#account_login_button')) {
				$('form[name=\'account_login_form\']').submit(function(event) {event.preventDefault();});
				//APP.loginUser(); moved to AE.forms.js - WEBAE3-1686
			}

			// Create Account link
			if ($target.hasClass('account_create_link')) {
				thisForm = $('.account_create_link').closest('form')[0];
				localStorage.setItem('memberAccountSection', 'createAccount');
				$(thisForm).submit();
			}

			// Create Account submit
			if ($target.is('#account_create_button')) {
				AE.forms.addSpinGear($target);
				$($target).prop('disabled', true);
				if(APP.checkAccountFormsPreSubmit($target)){
					APP.submitMemberAccountCreateForm($target);
				}
				else{
					$($target).prop('disabled', false);

				}
			}

			if ($target.is('#savecard')) {
				eleSaveCard = $('#savecard').is(':checked');
				APP.setHTML('Member_error_message','');
				
				if(eleSaveCard){	
					APP.setHTML('acct_processing','..... checking accounts');
					thisForm = $target.closest('form')[0];
					var memberEmail = $('#' + thisForm.id).find('input[name=email]').val();
					var exists = '';	
					APP.checkMemberExistsByEmail(memberEmail);	
				}
				else{
					APP.handleCreateAccountFormCheckout(false, false);}		
			}

			if ($target.is('#account_edit_button')) {
				// sets timeout for form to come into view after scrolling
				function editBtnScroll(callback) {
					$('#member_account_information_block')[0].scrollIntoView({behavior:'smooth',block: 'start'});
					setTimeout(function(){
						callback();
					}, 50);
				  }
				  
				editBtnScroll(function() {
					APP.loadAccountUpdateForm();
					APP.showHide('account_update','account_information');
					$('div.required').removeClass('ui-state-valid');
				});
			}

			// Account edit-cancel button
			if ($target.is('#account_edit_cancel_button')) {
				// move the page to put the account information more into view
				APP.loadAccountInformation(true);
				APP.setHTML('dspMemberUpdate', '');
			}

			// Account delete button
			if ($target.is('#account_delete_button') || $target.is('#account_edit_delete_button')) {
				APP.deleteWarning($target);
			}

			// === Added for WEBAE3-4756 === //-
			$('#account_update_button').click(function(){
				setTimeout(
				  function() {			
					const cookieValue = document.cookie
					.split('; ')
					.find(row => row.startsWith('MEMBERAGE'))
					.split('=')[1];
					//
					// Get the existing data
					var existing = localStorage.getItem('aeSearch');
					// convert the localStorage string to an array
					existing = existing ? JSON.parse(existing) : {};
							
					if ($('#member_dob').val().length === 0) {
						existing['searchAge'] = '40';
						localStorage.setItem('aeSearch', JSON.stringify(existing));
						//Set check box
						var boxexisting = localStorage.getItem('aeSearch');
						boxexisting = boxexisting ? JSON.parse(boxexisting) : {};
						boxexisting['searchAgeCheckbox'] = true;
						localStorage.setItem('aeSearch', JSON.stringify(boxexisting));
						//searchAgeCheckbox
						location.reload();
					}
					else {
						existing['searchAge'] = cookieValue;						
						// Save back to localStorage
						localStorage.setItem('aeSearch', JSON.stringify(existing));
						// console.log(cookieValue);
				  
						//Set check box
						var boxexisting = localStorage.getItem('aeSearch');
						boxexisting = boxexisting ? JSON.parse(boxexisting) : {};
						boxexisting['searchAgeCheckbox'] = true;
						localStorage.setItem('aeSearch', JSON.stringify(boxexisting));
						//searchAgeCheckbox
						location.reload();
						}
					},
				700);
			});

			// Account update button
			if ($target.is('#account_update_button')) {
				AE.forms.addSpinGear($target);
				$($target).prop('disabled', true);
				if(APP.checkAccountFormsPreSubmit($target)){
					APP.submitMemberUpdate($target);
				}
				else{
					$($target).prop('disabled', false);
				}
			}

			// Account forgot password lookup button
			if ($target.is('.account_forgot_password')) {
				window.location.replace('/member-accounts');
			}

			// Account send reset password button
			if ($target.is('#account_lookup_button')) {
				AE.forms.addSpinGear($target);
				$($target).prop('disabled', true);
				APP.sendReset($target);
			}

			// Account save reset password button
			if ($target.is('.submit_password_save_button')) {
				var thisForm = $target.closest('form')[0];
				var frm_selector =  'form#' +  thisForm.id;
				var $forms = $(frm_selector);
				AE.forms.applyGuardian($forms);	
				AE.forms.addSpinGear($target);		
				if(APP.checkAccountFormsPreSubmit($target)){
					$($target).prop('disabled', true);
					APP.submitAndCheckresetPassword(thisForm.id,'',$target)
				}
				else{
					$($target).prop('disabled', false);
				}
			
			}

			if ($target.is('#nav_submit_password_cancel')) {
				APP.hideEle('memberPasswordResetNav');
				APP.showEle('memberloginNav');
				thisForm.find("input[type=text], input[type=password], input[type=email]").val("");					
			}			
			// Reset password from member account logged in
			if ($target.is('#account_reset_memberUpdate')) {
				window.jsloginStatus = false;
				$('#resetPasswordMemberUpdate').submit();
			}
			//WEBAE3-4932 my accoun stored payment handlers
			if ($target.is('#addNewCC')) {
				event.preventDefault();
				APP.toggleAddCard();
				APP.getAddCardWidget();
			}
			if ($target.hasClass('deleteCC')) {
				event.preventDefault();
				APP.deleteCCWarning($target[0].dataset.cardid);
			}
		//clear dob field
		if ($target.hasClass('ui-datepicker-clear-input')) { 
				event.preventDefault();
				$('#member_dob').datepicker('setDate', null);
				$('span.ui-datepicker-clear-input').addClass('visuallyhidden');
				$('input#hidden-dob-date').val('');
			}
		}

		if ($target.hasClass('datePickerInput')) {
			APP.showDobClear();
		}

		if($target.hasClass('toggleeMemberPayment')) {
			if($target.hasClass('open')) {
				//opening payment so get cards to display
				APP.getPayOptions();
			} else {
				APP.hideAddCardUI();//make sure AddCard UI gets hidden when closing payment pane
				$("#editCCControl").empty();//empty control area on close
			}
			
		}

		if(APP.props.$isInMemberAccount){
			if ($target.hasClass('toggle_pm_header')){
				_.each($('.toggle_pm_header'),function(el){
					var $el = $(el);
					if($el.data('togglee') !== $target.data('togglee')){
						$el.removeClass('open');
						$($el.data('togglee')).addClass('visuallyhidden');
					}
				});
				
				if($target.attr('id') === 'headerMemberReservations'){
					APP.loadAccountReservations();
				}
			}
		}


	},

	navigateMemberPageLocalStorage: function() {
		APP.navigateMemberPage(localStorage.getItem('memberAccountSection'));
		localStorage.removeItem('memberAccountSection');
	},

	navigateMemberPage:function (section){
		var $sectionToOpen = '#Dummy';
		var $sectionToScrollTo = $('#dummy_block')[0];
		$('.toggle_pm_header').removeClass('open');
		$('.togglee.push--top').addClass('visuallyhidden');

		switch (section) {
			case 'my_reservations':
				$sectionToOpen = '#toggleeMemberReservations';
				$sectionToScrollTo = $('#member_my_reservations_block')[0];
				APP.loadAccountReservations();
				break;
			case 'account_information':
				$sectionToOpen = '#toggleeMemberAccount';
				$sectionToScrollTo = $('#member_account_information_block')[0];
				break;
			case 'payment_information':
				$sectionToOpen = '#toggleeMemberPayment';
				$sectionToScrollTo = $('#member_payment_information_block')[0];
				break;
			case 'promotions':
				$sectionToOpen = '#toggleeMemberPromotions';
				$sectionToScrollTo = $('#member_promotions_block')[0];
				break;
			case 'createAccount': 
				//WEBAE3-3287 - Change the default panel here when member account created
				if(AE.props.chaosSystem == 'GB' || AE.props.chaosSystem == 'EU'){
					$sectionToOpen = '#toggleeMemberPromotions';
					$sectionToScrollTo = $('#member_promotions_block')[0];	
				}
				//WEBAE3-3378 My Account - Remove auto-scroll from post account-creation screen
				else{
					$sectionToOpen = '';
					$sectionToScrollTo = '';	
				}
				break;
			case 'customer_support':
				$sectionToOpen = '#toggleeMemberSupport';
				$sectionToScrollTo = $('#member_customer_support_block')[0];
				break;
			default:
				$sectionToOpen = '#toggleeMemberAccount';
				$sectionToScrollTo = $('#member_account_information_block')[0];
				break;
		}

			if($sectionToOpen == 'account_information' ){APP.loadAccountInformation(false);}
			
			if($sectionToScrollTo != '' && $sectionToOpen != ''){			
				// open up the desired section
				$('[data-togglee="' + $sectionToOpen + '"]').trigger('click');

				// move the page to put the desired section more into view
				//using different scroll to function for my reservations so it will scroll to top.
				$sectionToScrollTo.scrollIntoView({behavior:'smooth',block: 'start'});
				// Since we are already on the member account page, we no longer need this info
			}
	},
	duplicateAccountWarning: function (msg) {
			var oButtons = {}; // Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text

				oButtons[AEdata.account.duplicateModal.btn_reset] = function () {
					window.location.href = '/member-accounts';
					AE.ui.dialog.close();
				};

				oButtons[AEdata.account.duplicateModal.btn_login] = function () {
					window.location.href = '/member-accounts';
					AE.ui.dialog.close();
				};


			var buttonOpts = {
				setClass: 'align-center soft-half--left',
				lastButtonClass: 'push--top',
				firstButtonClass: 'btn--primary push--top'
			};

			AE.ui.dialog.launch({
				titleBar: true,
				id: 'duplicateWarning',
				dialogClass: 'top-dialog',
				content: buildDuplicateAcctMarkup(msg),
				buttons: oButtons,
				applyUI: true,
				buttonOpts: buttonOpts,
				width: ($(window).width() > 600) ? 500 : '70%'
			});

			function buildDuplicateAcctMarkup(msg) {
				var docFrag = $(document.createDocumentFragment());
				docFrag.append($(document.createElement('div')).append(msg));

				return docFrag;
			}
	},
	duplicateAccountWarningUpdate: function ($msg) {
		var oButtons = {}; // Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text
			oButtons[AEdata.account.duplicateModalUpdate.btn_cancel] = function () {
			AE.ui.dialog.close();
			APP.navigateMemberPage('account_information');
		};

		var buttonOpts = {
			setClass: 'align-center soft-half--left',
			lastButtonClass: 'push--top',
			firstButtonClass: 'btn--primary push--top'
		};

		AE.ui.dialog.launch({
			titleBar: true,
			id: 'duplicateWarningUpdate',
			dialogClass: 'top-dialog',
			content: buildDuplicateAcctMarkup($msg),
			buttons: oButtons,
			applyUI: true,
			buttonOpts: buttonOpts,
			width: ($(window).width() > 600) ? 500 : '70%'
		});

		function buildDuplicateAcctMarkup($msg) {
			var docFrag = $(document.createDocumentFragment());
			docFrag.append($(document.createElement('div')).append($msg));

			return docFrag;
		}
	},
	deleteCCWarning:function(cardId) {
		var oButtons = {}; // Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text
		oButtons[AEdata.account.oStoredPaymentLang.button_delete] = function() {
			APP.deletePaymentOption(cardId);
			AE.ui.dialog.close();
		};

		oButtons[AEdata.account.oStoredPaymentLang.button_cancel] = function() {
			AE.ui.dialog.close();
		};

		var buttonOpts = {
			setClass: 'align-center soft-half--left',
			lastButtonClass: 'push--top',
			firstButtonClass: 'btn--primary push--top'
		};

		AE.ui.dialog.launch({
			titleBar: true,
			id: 'deleteWarning',
			dialogClass: 'top-dialog',
			content: buildDeleteWarnMarkup(cardId),
			buttons: oButtons,
			applyUI: true,
			buttonOpts: buttonOpts,
			width: ($(window).width() > 600) ? 500 : '70%'
		});

		function buildDeleteWarnMarkup(cardId) {
			
			var cardDetails = _.findWhere(AEdata.CARDS, {CARDID: cardId});
			cardDetails.cardTypeDisplay = (AEdata.oCClogos[cardDetails.CARDTYPE.toLowerCase()]) ? '<img style="flex:auto;" src="'+AEdata.oCClogos[cardDetails.CARDTYPE.toLowerCase()]+'">' : '<strong>' + cardDetails.CARDTYPE + '</strong> ';
			cardDetails.cardLast4 = '<strong>' + cardDetails.LAST4 + '</strong> ';
			cardDetails.cardExp = '<strong>' + cardDetails.EXP + '</strong> ';
			//show logo if we have one, otherwise card type text
			var modalCardSummary = AEdata.account.oStoredPaymentLang.txt_card_summary.replace('##cardtype##',cardDetails.cardTypeDisplay);
			modalCardSummary = modalCardSummary.replace('##last4##',cardDetails.cardLast4);
			modalCardSummary = modalCardSummary.replace('##expdate##',cardDetails.cardExp);
	
			var docFrag = $(document.createDocumentFragment());
			docFrag.append($(document.createElement('h3')).append(AEdata.account.oStoredPaymentLang.confirm_delete_card_header));
			docFrag.append('<div class="soft--ends text--center">'+modalCardSummary+'</div>');
			docFrag.append($(document.createElement('div')).append(AEdata.account.oStoredPaymentLang.confirm_delete_card_body));
			return docFrag;
		}
	},
	deleteWarning:function($Target) {
		var oButtons = {}; // Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text
		oButtons[AEdata.account.deleteModal.btn_delete] = function() {

			window.jsloginStatus = false;
			try {
				localStorage.clear();
			} catch (err) {
				// no local storage to clear
			}
	
			AE.forms.addSpinGear($Target);
			var $suid = $Target.data('suid');
			APP.deleteSFRecord($suid);
			$('#submitMemberDeleteForm').submit();
			AE.ui.dialog.close();
		};

		oButtons[AEdata.account.deleteModal.btn_cancel] = function() {
			AE.ui.dialog.close();
		};

		var buttonOpts = {
			setClass: 'align-center soft-half--left',
			lastButtonClass: 'push--top',
			firstButtonClass: 'btn--primary push--top'
		};

		AE.ui.dialog.launch({
			titleBar: true,
			id: 'deleteAccountWarning',
			dialogClass: 'top-dialog',
			content: buildDeleteWarnMarkup(),
			buttons: oButtons,
			applyUI: true,
			buttonOpts: buttonOpts,
			width: ($(window).width() > 600) ? 500 : '70%'
		});

		function buildDeleteWarnMarkup() {
			var docFrag = $(document.createDocumentFragment());
			docFrag.append($(document.createElement('h3')).append(AEdata.account.deleteModal.delete_warn_head));
			docFrag.append($(document.createElement('div')).append(AEdata.account.deleteModal.delete_warn));

			return docFrag;
		}
	}
	,addInvalidClass: function ($formId,$ele) {
		var $thisEle = $('#' + $formId + ' input[name=' + $ele + ']');
		var $parent  = $('#' + $formId + ' input[name=' + $ele + ']').parent();
		$parent.removeClass('ui-state-valid');
		$parent.addClass('ui-state-invalid');
	}
	,addValidClass: function ($formId,$ele) {
		var $thisEle = $('#' + $formId + ' input[name=' + $ele + ']');
		var $parent = $('#' + $formId + ' input[name=' + $ele + ']').parent();
		if($parent ){
			$parent.removeClass('ui-state-invalid');
			$parent.addClass('ui-state-valid');
		}
	},
	removeInvalidClass: function ($formId,$ele) {
		var $thisEle = document.querySelector('#' + $formId + ' #' + $ele);

		if($thisEle){
			var $parent  = $($thisEle.parentNode);
			if ($ele == 'all') {
				$('div.required').removeClass('ui-state-invalid');
			} else {
				$parent .removeClass('ui-state-invalid').addClass('ui-state-valid');

			}
		}
	},
	removeValidClass: function ($formId,$ele) {
		var thisEle = document.querySelector('#' + $formId + ' #' + $ele);
		var parent  = $(thisEle.parentNode);
		parent.removeClass('ui-state-valid');		
	},
	removeValidClassByClass: function ($formId, eleClass) {
			var thisEle = document.querySelector('#' + $formId + ' .' + eleClass);		
			var parent  = $(thisEle.parentNode);
			parent.removeClass('ui-state-valid');	
	},
	showGridDiv: function ($ele, $formId) {
		var thisEle = document.querySelector('#' + $ele);
		
		var parent  = $(thisEle.parentNode);
		parent.removeClass('visuallyhidden');
	},
	showGridDivByClass: function ($formId, eleClass) {
			var thisEle = document.querySelector('#' + $formId + ' .' + eleClass);		
			var parent  = $(thisEle.parentNode);
			parent.removeClass('visuallyhidden');
	},
	getWhichReset: function ($ele) {
		var $str = '';
 		if ($($ele).hasClass('nav')) {
			 $str = 'member_reset_password_nav';
		}
 		else if ($($ele).hasClass('signup')) {
			 $str = 'member_signup';
	    }
	    else{$str = 'member_reset_password';}
	    return $str;
	},
	hideGridDiv: function ($formId, $ele) {
		var $thisEle = document.querySelector('#' + $ele);
			if($thisEle ){
				var $parent  = $($thisEle.parentNode);
				$parent.addClass('visuallyhidden');
			}
	},
	hideGridDivByClass: function ($formId, $eleClass) {
		var $thisEle = document.querySelector('#' + $formId + ' .' + $eleClass);	
			if($thisEle){	
				var $parent  = $($thisEle.parentNode);
				$parent.addClass('visuallyhidden');
			}
	},
	SetErrorText: function ($formId, $eleClass, $str) {
			var $ele = $('#' + $formId + ' .' + $eleClass);
			$ele.innerHTML = $str;						
	},
	loadAccountInformation: function (scrollTop) {
		var cfc = APP.props.$ObjMember + '?method=showAccountInformation';
		var $ele = '';
			$.ajax({
        type: 'POST',
        url: cfc,
        dataType: 'json',
       	success: function(result){
         	if(result.trim != ''){
             $ele = document.getElementById('dspAccountInfo');
						if ($ele) {
							$ele.innerHTML = '';
							$ele.innerHTML = result;
							APP.hideShow('account_update', 'account_information');
							// WEBAE3-3426 do not scroll to top when account info is expanded
							//Do need to scroll to member account info block after an edit SL
							if(scrollTop){$('#member_account_information_block')[0].scrollIntoView({behavior:'smooth',block: 'start'});}
						}
					}
		   	},
		    error: function (/*xhr, ajaxOptions, thrownError*/) {
		     // console.log(xhr.status);
		     // console.log(thrownError);
		     }
		  });
	},
	logOutMember: function () {
		var cfc = APP.props.$ObjMember + '?method=memberLogoutRemote';
			$.ajax({
                type: 'POST',
                url: cfc,
               	success: function(){
               		// WEBAE3-1669 - always reload the page after logging out to reflect account status
               		window.location.reload();//keep user on page they logged in on WEBAE3-1662
               	 },
                error: function (xhr, ajaxOptions, thrownError) {
                  // console.log(xhr.status);
                  // console.log(thrownError);
                 }
          });
	},
	submitMemberUpdate:function($target){
		var $checkEmail = $('#member_email').val();
		var $currentemail = $('#member_email_old').val();
		var $hasErrors = document.getElementsByClassName('ui-state-invalid')[0];
		var $inputs  ='';
		var $elemID  = '';
		var $position = '';
		var $thisposition = '';

		if(!$checkEmail){
			$errorFirst = document.getElementsByClassName('ui-state-invalid')[0];
			$errorFirst.scrollIntoView({behavior:'smooth',block: 'start'});
			return false;
		}
	
		if($checkEmail != $currentemail){
			APP.checkMemberExists($checkEmail,$target);
		}
		else{
			$elemID = $target.attr('id');
			$thisForm = $('#' + $elemID).closest('form')[0];
			APP.submitAndCheckMemberAccountForm($thisForm.id, $target,'');
		}
	},
	submitAffiliateForm: function ($target) {
		var $thisForm = $target.closest('form')[0];
		var $forms = $($thisForm );
		AE.forms.applyGuardian($forms);
		$($thisForm).submit();
	},

	loadAccountUpdateForm: function () {
		var cfc = APP.props.$ObjMember + '?method=dspUpdateAccountForm';
		var $frm_selector =  'form#member_update';
		   $.ajax({
	         type: 'POST',
	         url: cfc,
	         dataType: 'json',
	          success: function(result){
	        	if(!result.isEmpty()){
					$('div#dspMemberUpdate').html('');
					$('div#dspMemberUpdate').html(result.markup);
					//WEBAE3-4036 changed how state data is handled
					AEdata.arrstates = JSON.parse(result.states);
					//fixes state select issue with not displaying list options
					AE.ui.applyJQUI($frm_selector);
					AE.ui.selectmenu.init();

					var $forms = $($frm_selector);
					AE.forms.applyGuardian($forms);				
					//APP.navigateMemberPage('account_information');
					$('#member_account_information_block')[0].scrollIntoView({behavior:'smooth',block: 'start'});
        		}
	          },
            error: function (/*xhr, ajaxOptions, thrownError*/) {
              // console.log(xhr.status);
              // console.log(thrownError);
            }
	       });

	 return false;
	},
	getUrlParameter: function (sParam) {
			// utility function
			var sPageURL = decodeURIComponent(window.location.search.substring(1));
			var sURLVariables = sPageURL.split('&');
			var sParameterName;
			var index;

			for (index = 0; index < sURLVariables.length; index++) {
				sParameterName = sURLVariables[index].split('=');
				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined ? true : sParameterName[1];
				}
			}
	},
	resetResetStatus: function (tokenExpired, isReset) {
			var cfc = APP.props.$ObjMember + '?method=setResetStatus';

			$.ajax({
				type: 'POST',
				url: cfc,
				data: {
					tokenExpired: tokenExpired,
					isReset: isReset
				}
			});
	},

	sendResetAff: function ($target) {
		var cfc = APP.props.$ObjAff + '?method=sendPasswordResetAff';
		var $form = $($target).closest('form')[0];
		var $formId  = ($form.length != 0) ?  $($form).attr('id') :'';
		var $messDiv = $("div#msg_reset_response");
		var $frmInstructions = $("div#msg_reset_instr");
		var $resetFormDiv = $("div#form_reset_request");
		var $error_ele = APP.getErrorEle($formId,'email');
		var $atv2 = (APP.getUrlParameter('atv2')) ? 1 :0;
		if($formId ==''){return false;}
		var $hasBlanks = APP.checkBlank($formId);
		// var $memEmail = $("#" + $form.id + " input[name='email']");
		// var $memName = $("#" + $form.id + " input[name='membername']");	
		// var $typex= $("#" + $form.id + " input[name='typex']");
		var $formVals = $('#' + $formId ).serialize();
		$formVals = $formVals + '&atv2=' + encodeURIComponent($atv2);
		var $eleLookup = $("#reset-response");
		var $str = '';
			if(!$hasBlanks){
				//leaving logic in for failed reset send until end users sure of functionality
				$.post(cfc, $formVals, function (result) {
					if(result.RESULT !='invalid'){
						$messDiv.html('');
						$($messDiv).html(result.MESS);

						if(result.RESULT){
							$($resetFormDiv).addClass('visuallyhidden');
							$($frmInstructions).addClass('visuallyhidden');
							$($messDiv).removeClass('visuallyhidden');
							$($messDiv).removeClass('error_message');
							}
						else{
							$($resetFormDiv).removeClass('visuallyhidden');
							$($messDiv).removeClass('visuallyhidden');
							$($messDiv).addClass('error_message');
						}
					}
					AE.forms.removeSpinGear($target);
					$($target).prop('disabled', false);
					
				}, 'json');
			}
			else{
				AE.forms.removeSpinGear($target);
				$($target).prop('disabled', false);
			}
		


			//leaving logic in for failed reset send until end users sure of functionality
			// $.post(cfc, $formVals, function (result) {
			// 	if(result.RESULT =='invalid'){
			// 		AE.forms.removeSpinGear($target);
			// 		$str = '<li class=\'small--errornote\'>' + result.MESS + '</li>';
			// 		$($error_ele).html($str)			
			// 	}
			// 	else if(!result.RESULT && result.MESS.trim == ''){
			// 		return false;
			// 	}
			// 	else{
			// 		AE.forms.removeSpinGear($target);
			// 		APP.hideEle('forgotPasswordContainer');
			// 		APP.hideEle('resetPasswordContainer');							
			// 		APP.setHTML('member-response-right', result.MESS); 
			// 		APP.showGridDiv('member-response-right','');					
			// 	}
			// }, 'json');
			return false;			
	},
	sendReset: function ($target) {
		var cfc = APP.props.$ObjMember + '?method=sendPasswordReset';
		var $form = $($target).closest('form')[0];
		var $formId  = ($form.length != 0) ?  $($form).attr('id') :'';

		if($formId ==''){return false;}

		var $resetFld = $("#" + $form.id + " input[name='member_reset_email']");
		var $error_ele  = APP.getErrorEle($formId, $resetFld.attr('name'));		
		var $formVals = $('#account_lookup_form').serialize();
		var $isMobile = APP.checkIfMobile();
		var $eleLookup = $("#member-response-right");
		var $resetFld = $("#" + $form.id + " input[name='member_reset_email']");
		var hasName = (name === 'true') ? 'Y' :'N';
		var $error_ele = APP.getErrorEle($formId, $resetFld.attr('name'));
		var $str = '';

		if(!$isMobile ){				
			$eleLookup.addClass('full-push--top');
		}
		else{
			$eleLookup.addClass('push--bottom');
		}

		if($("input#member_reset_email").val() ==''){
				APP.addInvalidClass($formId,$("input#member_reset_email").attr('name'));
				AE.forms.removeSpinGear($target);
				return false;
		}
		APP.setHTML('member-response-left', ''); 
		APP.hideGridDiv('account_lookup_form','member-response-left');

		//leaving logic in for failed reset send until end users sure of functionality
		$.post(cfc, $formVals, function (result) {
			if(result.RESULT =='invalid'){
				AE.forms.removeSpinGear($target);
				$str = '<li class=\'small--errornote\'>' + result.MESS + '</li>';
				$($error_ele).html($str)			
			}
			else if(!result.RESULT && result.MESS.trim == ''){
				return false;
			}
			else{
				AE.forms.removeSpinGear($target);
				//APP.hideEle('forgotPasswordContainer');  // DS: WEBAE3-4345
				//APP.hideEle('resetPasswordContainer');   // DS: WEBAE3-4345							
				APP.setHTML('member-response-right', result.MESS); 
				APP.showGridDiv('member-response-right','');					
			}
			$($target).prop('disabled', false);
		}, 'json');
		//return false;			
	},
	checkMemberExistsByEmail: function($email){
		var cfc = APP.props.$ObjMember + '?method=getMemberIDByEmailRemote';
		$.ajax({
			type: 'GET',
			url: cfc,
			data: {
					member_email: $email
				},
			dataType: 'json',
			success: function (result) {
				APP.setHTML('Member_error_message','');
				APP.setHTML('acct_processing','');
				//Invalid Email or Member Exists Show message- uncheck savecard
					if(result.INVALID ||result.RESULT){
							$("div.chkout_acct_container").removeClass('visuallyhidden');
							APP.setHTML('Member_error_message',result.MESSAGE);
						 	$("div#member_response").removeClass('visuallyhidden');
						 	$('#savecard').prop('checked',false);
						 	APP.handleCreateAccountFormCheckout(false, true);
					}			
				 //Good to proceed
					else{
						$("div#member_exists").addClass('visuallyhidden');
						APP.handleCreateAccountFormCheckout(true, false);
					}					
			}
		});
	},
	submitMemberAccountCreateForm: function ($target) {
			var $form = $($target).closest('form')[0];
			var $email= $("#" + $form.id + " input[name='member_email']").val();
			APP.setHTML('duplicateMemberMsg', '');
			APP.hideEle('duplicateMemberError', '');
			//if email not blank - check if member exists first
			if ($email) {
				APP.checkMemberExists($email,$target);
			} else {
				
				APP.submitAndCheckMemberAccountForm($form.name,$target,'');
			}
	},
	checkMemberExists: function (checkEmail,$target) {
			var $elemID = $target.attr('id');
			var $form = $('#' + $elemID).closest('form')[0];
			var cfc = APP.props.$ObjMember + '?method=checkAccountExists';
			var $emailFld = $("#" + $form.id +  " input[data-check='member_email']");

			$.ajax({
				type: 'GET',
				url: cfc,
				data: {
					member_email: $emailFld.val()
				},
				dataType: 'json',
				success: function (result) {
					if (result.RESULT) {
						APP.showEle('duplicateMemberError');
						APP.setHTML('duplicateMemberMsg', result.MESS);
						//re-enable account create
						//AE.forms.removeSpinGear($target);					
						if($form.id == 'member_update'){
							APP.duplicateAccountWarningUpdate(result.MESS);
						}
						else{
							APP.duplicateAccountWarning(result.MESS);
						}
						AE.forms.removeSpinGear($target);	
						$($target).prop('disabled',false);	
						APP.addInvalidClass($form.id,$($emailFld).attr('name'));
					} 
					else {
						APP.submitAndCheckMemberAccountForm($form.id,$target, '');
					}
				}
			});
	},
	deleteSFRecord: function ($suid) {
		var cfc = APP.props.$ObjMember + '?method=deleteSFRecord';
		$.ajax({
			type: 'GET',
			url: cfc,
			data: {
				suid: $suid 
			},
			dataType: 'json',
			success: function (result) {
			}
		});
	},
	checkPassword: function ($formId) {
		var $ele = $('form#' + $formId + ' input.validatePassword');		
		var $fld = $($ele).attr('name');
		var $str  = $ele.val();
		var $match = $($ele).attr('data-match');
		//var $checkOther = $('#' + $formId +  ' input[name=' + $match + ']');
		var $ObjpwdEle = APP.validatePwd($str);
		var $submit = $("#" + $formId).find(':button');

			 jQuery.each($ObjpwdEle, function(name, value) {
			 	$error_item = $('#' + $formId  + ' li.checklist.' + name);

			 	if(!value){
			 		$error_item.removeClass('pwd_valid');	
			 		$error_item.addClass('pwd_error');		 		
			 	}
			 	else{
			 		$error_item.removeClass('pwd_error');
			 		$error_item.addClass('pwd_valid');
				 }		
			 });

			if($ObjpwdEle.validated){
				//$($submit).prop('disabled', false);
				APP.hideGridDivByClass($formId,'memberPasswordChecklist');
				APP.addValidClass($formId,$fld );
			}
			else{
				//$($submit).prop('disabled', true);
				APP.showGridDivByClass($formId,'memberPasswordChecklist');
				APP.addInvalidClass($formId,$fld);
			}
			return $ObjpwdEle.validated;
	},
	checkPasswordLegacy: function ($formId) {
		var $ele = $('form#' + $formId + ' input.validatePassword');		
		var $fld = $($ele).attr('name');
		var $str  = $ele.val();
		var $errorGuardian  = APP.getGuardianErrorEle($formId,$fld);
		var $errorEle_guardian = $("span#" + $errorGuardian + ":visible"); 
		var $messfield  = APP.getErrorEle($formId, $fld);
		var $mess  =  $($ele).attr('data-error-message');
		var $ObjpwdEle = APP.validatePwdLegacy($str);
		$($errorEle_guardian).remove();

			if($ObjpwdEle.validated){
				$($messfield).html('');
				APP.addValidClass($formId,$fld );
			}
			else{
				APP.addInvalidClass($formId,$fld);
				if($errorEle_guardian.length == 0){
					$($messfield).html($mess );				
				}		
			}
			return $ObjpwdEle.validated;
	},

	initCustomMatchVerification:function($ele){
		var $data = {};	
		var $formId = $($ele).parents('form').attr('id');
		var $fldEle = $($ele);
		var $fld = $($fldEle).attr('name');
		var $match = $($ele).attr('data-match'); 
		var $errorMessageEle = $($ele).attr('data-error-mess-ele');

		if(!$errorMessageEle){
			$errorMessageEle = $fld;
		}
		var $data = {formId:$formId, thisEle:$fld,matchEle:$match,errorMessDspEle:$errorMessageEle};
		
		return APP.verifyMatch($data);	
	},
	verifyMatch: function ($data) {
		//{formId: "acct__pswd", thisEle: "passwdver", matchEle: "newpasswd", parentType: "LI", errorMessDspEle: "passwdver"}
		//var $str = '';
		var $formId = $data["formId"];
		var $thisEle =$data["thisEle"];
		var $matchEle = $data["matchEle"];
		var $errorMessDspEle = $data["errorMessDspEle"];
		var $messfield  = APP.getErrorEle($formId, $errorMessDspEle);
		var $current_mess = $($messfield).html(); 	
		var $thisFld = $("#" + $formId + " input[name=" + $thisEle + "]");
		var $matchField = $("#" + $formId + " input[name=" + $matchEle + "]"); 
		var $noCase = false;		
		var $strDspMess = $($thisFld).data("error-message-nomatch");
		var $isValid = false;
		var $submit = $("#" + $formId).find(':button');
		var $isMatch = false;
		var $errorGuardian  = APP.getGuardianErrorEle($formId,$thisEle);
		var $errorEle_guardian = $("span#" + $errorGuardian);


			if(!$thisFld.data('match-nocase')){$noCase == false;}
			else{$noCase = $thisFld.data('match-nocase');}
			if($thisFld.val() && $matchField.val()){
				$isMatch = ($noCase)? $thisFld.val().toUpperCase() === $matchField.val().toUpperCase() : $thisFld.val() === $matchField.val();	
			}

		   if(!$isMatch  && $thisFld.val() !=''){
				//if message already there do not re-add or screen shimmys
				if($thisFld.val() !='' && $errorEle_guardian.length != 0){APP.removeGuardianError($formId,$errorMessDspEle);}
				if(($current_mess != $strDspMess) || $current_mess ==''){
					$($messfield).html('');
					$($messfield).html($strDspMess);
				}				
				APP.addInvalidClass($formId,$errorMessDspEle);
				//$($submit).prop('disabled', true);	
				$isValid = false;		
			}
			else if($isMatch && $thisFld.val() !=''){
				$($messfield).html('');
				APP.addValidClass($formId,$errorMessDspEle);
				$isValid = true;
				//$($submit).prop('disabled', false);
			}
			else if($thisFld.val() =='' && $errorEle_guardian.length != 0){
				$($messfield).html('');
			}
		// }
	return $isValid;
	},
	checkAccountFormsPreSubmit:function($target){
		var $form = $($target).closest('form')[0];
		var $formId = $form.id;
		var $hasBlank = APP.checkBlank($form.id);
		var $isValid = false; 
		var $isValid_pwd = false;
		var $pwdMatch = false;
		var $pwd = $('#' + $formId  + ' input.validatePassword');

		if($pwd.length != 0){
			var $isValid_pwd = APP.checkPassword($formId);
			var $pwdVer = $('#' + $formId  + ' input.validateRepass');
			var $pwdMatch = APP.initCustomMatchVerification($pwdVer);
		}
		else{
			$isValid_pwd =true;
			$pwdMatch =true;
		}

		if(!$hasBlank && $isValid_pwd && $pwdMatch ){$isValid = true;}

		if(!$isValid){
			AE.forms.removeSpinGear($target);
			APP.scrollToErrors($formId,$target);
		}
		return $isValid;
	},
	scrollToErrors:function($formId,$target){
		var $errorflds = document.querySelectorAll('form#' + $formId + ' .ui-state-invalid');
		if($errorflds.length != 0){
			$position = $($errorflds[0]).position().top;
			$thisposition = $($target).position().top;
	
			if($thisposition - $position >= 200){
				$errorflds[0].scrollIntoView({behavior:'smooth',block: 'start'});
			}
		}
	},

	submitAndCheckresetPasswordAff:function($target){
		AE.forms.addSpinGear($target);
		var $thisForm = $target.closest('form')[0];	
		var $formVals = $('#' + $thisForm.id ).serialize();
		var $typex = $('#' + $thisForm.id + ' input[name=typex]').val();
		var $isValidPwd = APP.checkPasswordLegacy($thisForm.id);
		var $ele = $('#' + $thisForm.id + ' input[name=reset_repassword]');
		var $isMatch = APP.initCustomMatchVerification($ele);
		var $hasBlanks = APP.checkBlank($thisForm.id);
		var $errorEleNotFound = APP.getErrorEle($thisForm.id, 'no_match');
		var $errorEleNotFound = $($errorEleNotFound);
		if(!$hasBlanks  && $isValidPwd &&  $isMatch){
			var cfc = APP.props.$ObjMember +  '?method=resetPasswordAff';
			$.ajax({
				type: 'POST',
				url: cfc,
				data: $formVals,
				dataType: 'json',
				success: function(result){
					if(!result.RESULT){
						if(!result.AFF_FOUND){
							$($errorEleNotFound).html(result.MESS);	
							AE.forms.removeSpinGear($target);					
						}
						else{
							$($errorEleNotFound).html('');
							AE.forms.removeSpinGear($target);
						}
						AE.ui.enableClicks();
					}
					else if(result.PWD_CHANGED){
						var $postForm = $("form#aff_reset_password");							
						var $elesuccessMsg = $('form#aff_reset_password input#successMsg');							
						var $elepwdChanged = $('form#aff_reset_password input#pwdChanged');
						$($elesuccessMsg).val(result.MESS);
						$($elepwdChanged).val(true);							
						$($postForm ).submit();											
					}
					$($target).prop('disabled', false);
					AE.ui.enableClicks();
				},
				 error: function (/*xhr, ajaxOptions, thrownError*/) {
                    //console.log(xhr.status);
                    //console.log(thrownError);
                }				
			});
		}
	}
	,

	submitAndCheckresetPassword: function ($formId,$fieldToCheck,$Target) {
		var $cfc = APP.props.$ObjMember + '?method=checkAndSubmitResetFormRemote';
		var $thisForm = $('#' + $formId);
		var $isNav = false;
		var $formVals = $thisForm.serialize();
		var $password_changed = false;
		var $strSingle = '';
		var $error_ele = '';
        var $hasErrors = true;
        var $currEle = '';
		var $currEleVal = '';
		var $currEleErrorClass = '';
		var $currEle_curr_val = '';
		var $checkThis = '';	
		var $do_nothing  = false;	

		AE.forms.addSpinGear($Target);
		
		if($thisForm.hasClass('nav')){$isNav = true;}

		APP.setHTML('member-response-left', '');
		//for single field check,  on blur we only want to check that one field. indicated by non blank formField value
		if($fieldToCheck){$formVals = $formVals + '&fieldToCheck=' + encodeURIComponent($fieldToCheck);}
		else{APP.hideGridDivByClass($formId,'memberPasswordChecklist');}

	 	   $.ajax({
	            type: 'POST',
	            dataType: 'JSON',
	            cache: false, 
	            url: $cfc,
	            data: $formVals,
	            success: function(result){
		            $str = '';
		            $hasErrors = false;
		            $currEle = '';
					$currEleVal = '';
					$currEleErrorClass = '';
					$currEle_curr_val = '';
					$checkThis = '';	
					$do_nothing = false;	
					$password_changed = false;	
					$error_ele = '';

		            for (var i = 0, len = result.length; i < len; i++) {
						$currEle = result[i][0];
					 	$currEleVal = result[i][1];
					 	if(result[i][2]){$currEleErrorClass = result[i][2];}
					 	$currEle_curr_val = '';
					 	$do_nothing  = false;

					// Password successfully changed
						if($currEle == 'passwordChanged'){
							$hasErrors = false;
							if($isNav){	
								APP.hideEle('memberPasswordResetNav');
								APP.showEle('memberloginNav');
								$thisForm.find("input[type=text], input[type=password], input[type=email]").val("");

							}
							else{
								//$hasErrors = false;
								APP.hideEle('resetPasswordContainer');
								APP.showEle('forgotPasswordContainer');
								$password_changed = true;
								//return false;
							}

							APP.setHTML('member-response-right', ''); 
							APP.hideGridDiv($formId,'member-response-right');


							APP.setHTML('member-response-left', $currEleVal); 
							APP.showGridDiv('member-response-left', '');
							$("div.login_container").removeClass('visuallyhidden--palm');
							$("div.login_container").removeClass('visuallyhidden--lap');
							break;
						}
						else{				
								$strSingle = '<p>' + $currEleVal + '</p>';
								$error_ele = APP.getErrorEle($formId, $currEle);
					
								if($error_ele){$currEle_curr_val = $($error_ele).html();}	
						
								//only add error text if not already there. keeps screen from shimmying
								if($currEle_curr_val && $currEle_curr_val.length > 0 && ($currEle_curr_val == $currEleVal)){
									$do_nothing =  true;
								}
								else{
									$do_nothing = false;
								}	
							
								if(!$do_nothing &&  $currEleVal){
										strSingle = '<p>' + $currEleVal + '</p>';
										//APP.setHTML($error_ele, $strSingle);
										$($error_ele).html($strSingle);
										APP.addInvalidClass($formId,$currEle);
								}
									else if(!$do_nothing){
										$($error_ele).html('');
										APP.addValidClass($formId,$currEle);								
								}
							//}
						}
					}//end data loop

					AE.forms.removeSpinGear($Target);
					$($Target).prop('disabled', false);

					if(!$hasErrors && !$fieldToCheck){
					 	//$('#submit_password_save_button').prop('disabled', false);
					 	$("div.login_container").removeClass('visuallyhidden--lap');
					 	$("div.login_container").removeClass('visuallyhidden--palm');
					}
	            },//end success
	             error: function (/*xhr, ajaxOptions, thrownError*/) {
                         //console.log(xhr.status);
                        // console.log(thrownError);
                }
       		});
	},
	addUpdateSalesforce: function (formVals) {
		var cfc = '/plugins/ae3/lib/Member3.cfc?method=handleSalesforce';
			$.ajax({
				type: 'POST',
				url: cfc,
				data: formVals,
				dataType: 'json',
				success: function(result){
							
				 },
				 error: function (/*xhr, ajaxOptions, thrownError*/) {
                    //console.log(xhr.status);
                    //console.log(thrownError);
                }
				
			});
	},

	handleSalesforceLogin:function(){
			var cfc = '/plugins/ae3/lib/Member3.cfc?method=handleSalesforce_Login';
			$.ajax({
				type: 'POST',
				url: cfc,
				success: function(result){
					//console.log('handleSalesforceLogin',result);
				},
				error: function (/*xhr, ajaxOptions, thrownError*/) {
                    // console.log(xhr.status);
                    // console.log(thrownError);
                }
				
			});
	},

	submitAndCheckMemberAccountForm: function ($formId, $target, fieldToCheck) {
			var cfc = APP.props.$ObjMember + '?method=checkAndSubmitAccountFormRemote';
			var $formAction = $('#' + $formId + ' input[name=form_action]').val();
			var $hasErrors = false;
			var $currEle = '';
			var $error_ele = '';
			var $currEleVal = '';
			var $currEle_curr_val = 0;
			var $do_nothing = false;
			var $formVals = $('#' + $formId).serialize();
			var $ele_guardian = '';
			APP.setHTML('duplicateMemberMsg', '');	
			//for single field check,  on blur we only want to check that one field. indicated by non blank formField value
			if(fieldToCheck){$formVals = $formVals + '&fieldToCheck=' + encodeURIComponent(fieldToCheck);}

				$.ajax({
			            type: 'POST',
			            dataType: 'JSON',
			            cache: false,
			            url: cfc,
			            data: $formVals,
			            success: function(result){	
							for (var i = 0, len = result.length; i < len; i++) {
								$currEle = result[i][0];
								$currEleVal = result[i][1];
								$currEle_curr_val = '';	
								$do_nothing = false;
								formvals = $formVals;

								$error_ele = APP.getErrorEle($formId, $currEle);	
								$ele_guardian = APP.getGuardianErrorEle($formId,$currEle);
								$ele_guardian  = $("span#" + $ele_guardian);
								if(!$currEleVal){
									APP.removeInvalidClass($formId,$currEle);
									$($error_ele).html('');
								}
								else{
									$hasErrors = true;
									$currEle_curr_val = $($error_ele).html();
									//only add error text if not already there or different than current messge. keeps screen from shimmying								
									if($currEle_curr_val.length > 0 && ($currEle_curr_val == $currEleVal)){
										$do_nothing =  true;
									}

									if($ele_guardian){
										if($ele_guardian.val() == $currEleVal){
											$do_nothing =  true;
										}
										else{APP.removeGuardianError($formId,$currEle);}
									}															
									if(!$do_nothing){									
										$($error_ele ).html($currEleVal);
										APP.addInvalidClass($formId,$currEle);										
									}
								}							
							}//end for loop

							if($hasErrors ){
								AE.forms.removeSpinGear($target);
								$($target).attr('disabled', false);
								APP.scrollToErrors($formId,$target);
							}
							else{
								if($formAction == 'account_update'){
									if(!fieldToCheck){
										APP.addUpdateSalesforce($formVals);
										APP.loadAccountInformation(true);
										AE.forms.removeSpinGear($target);
										$($target).attr('disabled', false);
										//$($target).prop('disabled', false);
										return true;
									}
								}
								else if($formAction == 'account_save'){
									if(!fieldToCheck){
										//WEBAE3-6285 start
										formvalsDes = APP.deparam(formvals);
										if(typeof formvalsDes.member_emaillist == "undefined"){  
											localStorage.setItem("aeShowSubscribe", true);//trigger New Modal to spawn when unsubscribed user logs in except the following pages
										}
										//WEBAE3-6285 END
										$('#member_signup').submit();
										return true;
									}
									else{
										return false;
									}
								}
							}
						},//end success					

   						error: function (/*xhr, ajaxOptions, thrownError*/) {
                		 	// console.log(xhr.status);
                			// console.log(thrownError);
                 		}
				});//end ajax
			//}					
	},
	showDobClear: function () {
		$('.ui-state-default,.ui-datepicker-title,.ui-datepicker-prev,.ui-datepicker-next').click(function(){
			$('span.ui-datepicker-clear-input').removeClass('visuallyhidden');
		})
	},
	showHide: function (show, hide) {
			$('#' + hide).addClass('visuallyhidden');
			$('#' + show).removeClass('visuallyhidden');
	},
	hideShow: function (hide,show) {
			$('#' + hide).addClass('visuallyhidden');
			$('#' + show).removeClass('visuallyhidden');
	},
	showEle: function (ele) {
			return $('#' + ele).removeClass('visuallyhidden');
	},
	hideEle: function (ele) {
			return $('#' + ele).addClass('visuallyhidden');
	},
	setHTML: function (ele, str) {
		$('#' + ele).html(str);
	},
	checkIfMobile: function () {
		var isMobile = false; //initiate as false
		// device detection
			if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
			|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
			isMobile = true;
		};
		return isMobile
	},
	getErrorEle: function ($formId, $ele) {
		var $error_ele  = 'form#' + $formId + ' span.errorTxt-' + $ele;
		return $error_ele;

	},
	getGuardianErrorEle: function ($formId, $ele) {
		var $eleGuardian = 'error-message-' + $formId + '-' + $ele;
		return $eleGuardian;
	},
	removeGuardianError:function($formId,$ele){
		var $eleGuardian = 'error-message-' + $formId + '-' + $ele;
		$eleGuardian = 'span.ui-error-message#' + $eleGuardian;
		$eleGuardian = $($eleGuardian);
		if($eleGuardian){$($eleGuardian).remove();}
	},
	clearServerError:function($formId,$ele){
		var $clear_ele = 'errorTxt-'  + $ele;
		$clear_ele = 'span.ui-error-message.' + $clear_ele;
		$clear_ele = $($clear_ele);
		if($clear_ele){$($clear_ele).html('');}
	},
	checkBlank:function($formId){
		var empty = false;
		var $form = document.querySelector('#' + $formId);
		var $flds = $form.querySelectorAll('*[required]');

		var i;
		for (i = 0; i < $flds.length; i++) {
	
		 $isVisible = !$flds[i].parentNode.classList.contains('visuallyhidden');

		  if($flds[i].value.trim() == '' && $isVisible ){ 

		  	if(APP.getErrorEle($formId, $flds[i].name) && !$flds[i].classList.contains('validatePassword')){
		  		$ele = $('#' + $formId + ' input[name=' + $flds[i].name  + ']');
		  		$error_ele = $(APP.getErrorEle($formId, $flds[i].name));
		  		$error_ele_guardian = APP.getGuardianErrorEle($formId, $flds[i].name);
		  		$error_ele_guardian  = $('span#' + $error_ele_guardian);
		  		$errorMess1 = $flds[i].getAttribute('data-error-message');
		  		$errorMess2 = $flds[i].getAttribute('data-empty-message');
		  		$errorMess = (!$errorMess2) ? $errorMess1 : $errorMess2;	  	

		  		if($error_ele_guardian.length != 0){
		  			$($error_ele).html('');
		  		}
		  		else if($error_ele.length == 0 && $error_ele_guardian.length == 0 ){
		  			$ele.after('<span class="ui-error-message" id="error-message-'+ $formId + '-'+ $flds[i].name +'">' + $errorMess + '</span>'); 	
		  		 }
		  		// else{
		  		// 	$($error_ele).html($errorMess);		  		
		  		// }
		  	}
		  	$flds[i].parentElement.classList.add('ui-state-invalid');
		  	empty = true;
		  }
		}
		//check if state required
		var $checkState = $('#' + $formId + ' select.state--select:visible').parent().parent('.required');
		if($checkState.length != 0){
			$eleState = $('#' + $formId + ' select.state--select:visible');
			if($($eleState ).val() == ''){
				$($($eleState).parent()).addClass('ui-state-invalid');
			}
		}
				
		return empty;
	},
	isTwoCol: function(){
	    var isTwoCol = false; 
	    if($(window).width() > 1023){isTwoCol = true;}

		return isTwoCol;

	},

	validatePwdLegacy:function($str){
	    var pwd = {
	    	validated: true,
			pwd_length: true		
	      };	
			if ($str.length < 8 ) {
			   pwd.validated = false;
			   pwd.pwd_length = false;
			};
			if ($str.length > 16 ) {
				pwd.validated = false;
				pwd.pwd_length = false;
			 }						
		return pwd;
	},

	validatePwd:function($str){
	    var pwd = {
	    	validated: true,
			pwd_length: true,
			pwd_number: true,
			pwd_special: true,
			pwd_upper: true,
			pwd_lower: true
	      };

	     if($str && $str.length!=0){
			//validate lower
			if (!$str.match(/[a-z]/) ) {
			   pwd.validated = false;
			   pwd.pwd_lower = false;
			}

			//validate capital letter
			if (!$str.match(/[A-Z]/) ) {
			   pwd.validated = false;
			   pwd.pwd_upper = false;
			}

			//validate number
			if (!$str.match(/\d/) ) {
			   pwd.validated = false;
			   pwd.pwd_number = false;
			}
			// validate length greater than 8
			if ($str.length < 8) {
			   pwd.validated = false;
			   pwd.pwd_length = false;
			}
			// validate length less than 16
			if ($str.length > 16) {
				pwd.validated = false;
				pwd.pwd_length = false;
			 }

			if (!$str.match(/[!=@#$%^&*-_\+\(\)?<>\.:;"'`~\|\{\}\[\]\\\/]/) ) {
			   pwd.validated = false;
			   pwd.pwd_special = false;
			}
			if (!$str.match( /[!@#$%^&*()_=\[\]{};':"\\|,.<>\/?+-]/) ) {
			   pwd.validated = false;
			   pwd.pwd_special = false;
			}
		}
		else{

	  		pwd.validated   = false;
			pwd.pwd_lower   = false;
			pwd.pwd_upper   = false;
			pwd.pwd_number  = false;
			pwd.pwd_length  = false;
			pwd.pwd_special = false;
		}

		return pwd;
	},
	readCookie:function($name){
	    var nameEQ = $name + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0;i < ca.length;i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1,c.length);
	        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	    }
	    return null;
	},
	getPayOptions:function(){
		/*
		getPayOptions: GET - returns array of all payment options
		*/ 
		var cfc = APP.props.$ObjMember + '?method=getPayOptions';

		$.ajax({
			type: 'GET',
			url: cfc,
			data: {remoteId: AEdata.myRemoteId},
			dataType: 'json',
			success: function(result){
				if(result.CARDS){
					AEdata.CARDS = [];//make sure array is empty before adding cards
					AEdata.CARDS = result.CARDS;
					APP.showCurrentCards();
				}
			},
			error: function (/*xhr, ajaxOptions, thrownError*/) {
				// console.log(xhr.status);
				// console.log(thrownError);
				}
		});
	},
	getAddCardWidget:function(){
		/*
		getAddCard: GET - Returns URL for hosted checkout widget
		*/ 
		var cfc = APP.props.$ObjMember + '?method=getAddCard';

		if(AEdata.account.ccWidgetUrl && AEdata.account.ccWidgetUrl !== 'expired') {
			//we already requested a widget so use it
			APP.showAddCard(AEdata.account.ccWidgetUrl);

		} else {
			$.ajax({
				type: 'GET',
				url: cfc,
				data: {remoteId: AEdata.myRemoteId},
				dataType: 'json',
				success: function(result){
					if(result.SUCCESS){
						AEdata.account.ccWidgetUrl = result.URL;//save URL in this browser request state for toggling
						APP.showAddCard(AEdata.account.ccWidgetUrl);
					} else {
						APP.showAddCardWidgetFail();
					}
				},
				error: function (/*xhr, ajaxOptions, thrownError*/) {
					// console.log(xhr.status);
					// console.log(thrownError);
					}
			});
		}
	},
	toggleAddCard:function(){
		if ($(".add_card_container").hasClass('visuallyhidden')) {
			APP.showAddCardUI();
		} else { 
			APP.hideAddCardUI();
		}
	},
	showAddCardUI:function(){
		//make for all AddCard UI elements visible
		if($('.add_card_container').hasClass('visuallyhidden')) {
			$(".add_card_container").removeClass('visuallyhidden');
		}
		if($('#mycc_loader').hasClass('visuallyhidden')) {
			$('#mycc_loader').removeClass('visuallyhidden');
		}
		if(!$('#noCCwidget').hasClass('visuallyhidden')) {
			$('#noCCwidget').addClass('visuallyhidden');//only an error retrieving widget will display this id
		}
		$(".addNewCCToggle").text('-');
},
	hideAddCardUI:function(){
		//hide all AddCard UI elements
		if(!$('.add_card_container').hasClass('visuallyhidden')) {
			$(".add_card_container").addClass('visuallyhidden');
		}
		if($('#mycc_loader').hasClass('visuallyhidden')) {
			$('#mycc_loader').removeClass('visuallyhidden');
		}
		if(!$('#noCCwidget').hasClass('visuallyhidden')) {
			$('#noCCwidget').addClass('visuallyhidden');//only an error retrieving widget will display this id
		}
		if(!$('#hp_cc').hasClass('visuallyhidden')) {
			$('#hp_cc').addClass('visuallyhidden');
		}
		$(".addNewCCToggle").text('+');

	},
	hideMyCCLoader:function(){
		$('#mycc_loader').addClass('visuallyhidden');
	},
	showAddCard:function(widgetUrl){
		//make sure iframe is hidden until URL loads (or reloads on toggling of Add New or whole section)
		if(!$('#ccWidget').hasClass('visuallyhidden')) {
			$('#ccWidget').addClass('visuallyhidden');
		}
		if (!$("#noCCwidget").hasClass('visuallyhidden')) {
			//we got widget URL so make sure this message isn't showing
			$("#noCCwidget").addClass('visuallyhidden');
		}
		document.getElementById('ccWidget').src = widgetUrl;
		document.getElementById('ccWidget').addEventListener("load", function() {
			APP.hideMyCCLoader()
			document.getElementById('hp_cc').classList.remove('visuallyhidden');
			document.getElementById('ccWidget').classList.remove('visuallyhidden');
			});
	},
	showAddCardWidgetFail:function(widgetUrl){
		APP.hideMyCCLoader();
		//show a failure message
		document.getElementById('noCCwidget').innerHTML = '<h4>' + AEdata.account.oStoredPaymentLang.payment_added_failed + '</h4>';
		document.getElementById('noCCwidget').classList.remove('visuallyhidden');
	},
	showCurrentCards:function(){
		$("#editCCControl").empty();//clear out any old cards displayed
		if (!$(".add_card_container").hasClass('visuallyhidden')) {
			$(".add_card_container").addClass('visuallyhidden');//hide add card form if it was open
		}
		var newCardId = ( localStorage.getItem('newCardId') && _.isString(localStorage.getItem('newCardId'))) ? localStorage.getItem('newCardId') : 'none';
		//if newCardId isn't 'none' then we have a status message to show
		if(newCardId !== 'none'){
			//clear saved checkout URL from AEdata
			AEdata.account.ccWidgetUrl = 'expired';//this triggers a new checkout if necessary

			//check for duplicate card added
			var isDuplicateCard = false;
			if(localStorage.getItem('isDuplicate') !== null) {
				var isDuplicateCard =  localStorage.getItem('isDuplicate');
				localStorage.removeItem('isDuplicate');//clear so it can be reset
			}
			//clear saved ID from localStorage so message isn't shown again
			localStorage.removeItem('newCardId');

			//determine which message show: if NewCardId = 0, then we'll show failure, default is to show added
			var savePaymentMsg =  (isDuplicateCard === 'true') ? AEdata.account.oStoredPaymentLang.payment_method_exists : AEdata.account.oStoredPaymentLang.payment_added_success;
			var savePaymentMsgClass = '';
			if(newCardId === '0'){
				//no card added but was attempted so set fail message/class
				var savePaymentMsg = AEdata.account.oStoredPaymentLang.payment_added_failed;
				var savePaymentMsgClass = 'class="ui-error-message"';
			}
			var savePaymentMsgDiv = document.createElement("div");
			savePaymentMsgDiv.innerHTML = '<h4 '+ savePaymentMsgClass + '>' + savePaymentMsg + '</h4>';
			$("#editCCControl").append(savePaymentMsgDiv);
		}
		if(AEdata.CARDS.length){
			AEdata.CARDS.forEach(function (item, index) {
				var cardLast4 = '<strong>' + item.LAST4 + '</strong> ';
				var cardExp = '<strong>' + item.EXP + '</strong> ';
				var cardType = item.CARDTYPE;
				var cardId = item.CARDID;
				var carLabelClass = (newCardId === cardId) ? 'current-cc-label-justadded' : 'current-cc-label';

				var cardLogoKey = item.CARDTYPE.toLowerCase();
				//show logo if we have one, otherwise card type text
				var cardTypeDisplay = (AEdata.oCClogos[cardLogoKey]) ? '<img style="flex:auto;" src="'+AEdata.oCClogos[cardLogoKey]+'">' : '<strong>' + cardType + '</strong> ';
				var cardSummary = AEdata.account.oStoredPaymentLang.txt_card_summary.replace('##cardtype##',cardTypeDisplay);
				cardSummary = cardSummary.replace('##last4##',cardLast4);
				cardSummary = cardSummary.replace('##expdate##',cardExp);

				displayHTML =  '<div class="current-cc-label-wrap"><div class="' + carLabelClass + '">';
				displayHTML += '<div>' + cardSummary + '</div></div>';
				displayHTML += '<div class="current-cc-buttons">';
				displayHTML += '<a href="#" name="btn_'+cardId+'" class="deleteCC" data-cardId="'+cardId+'" tabindex="1">' + AEdata.account.oStoredPaymentLang.button_delete + '</a>';
				displayHTML += '</div></div>';
				var newCardBlock = document.createElement("div");
				newCardBlock.id = cardId;
				newCardBlock.classList.add('current-cc-container')
				newCardBlock.innerHTML = displayHTML;
				$("#editCCControl").append(newCardBlock);

			});
		} else {
			var newCardBlock = document.createElement("div");
			newCardBlock.innerHTML = '<p>' + AEdata.account.oStoredPaymentLang.no_saved_payments + '</p>';
			$("#editCCControl").append(newCardBlock);
		}
		$("#editCCControl").removeClass('visuallyhidden');
		//if addcard form is visible, hide it
		if(!$(".add_card_container").hasClass('visuallyhidden')){
			$(".add_card_container").addClass('visuallyhidden');
		}

	},
	deletePaymentOption:function(cardId){
		/*
		deletePaymentOption: GET - returns array of all payment options
		*/ 
		var cfc = APP.props.$ObjMember + '?method=deleteStoredPayment';
		$.ajax({
			type: 'GET',
			url: cfc,
			data: {remoteId: AEdata.myRemoteId, paymentId: cardId},
			dataType: 'json',
			success: function(result){
				if(result.SUCCESS){
					$("#editCCControl").addClass('visuallyhidden');//hide cards before refreshing
					APP.getPayOptions();
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				// console.log(xhr.status);
				// console.log(thrownError);
				}
		});
	},

	/*	LAZY LOADING RESERVATION SECTION FUNCTIONS - WEBAE3-5726	*/
	loadAccountReservations:function() {
		if(APP.props.$isInMemberAccount && APP.props.$isLoggedIn){
			var $resLoadSpinner = $('#loaderMemberReservations');
			if($resLoadSpinner.length){
				if(AEdata.hasOwnProperty('stMemberVoucherInfo') && 
					_.isObject(AEdata.stMemberVoucherInfo) && 
					!_.isEmpty(AEdata.stMemberVoucherInfo)
				){
					APP.renderAccountReservations(AEdata.stMemberVoucherInfo);
				} else {
					AEdata.stMemberVoucherLang = AEdata.stMemberVoucherLang || {};
					var cfc = APP.props.$ObjMember + '?method=showAccountReservations';
					var lookupPage = AEdata.stMemberVoucherLang.LOOKUP_URL || 'LOOKUP_URL';
					$.ajax({
						type: 'POST',
						url: cfc,
						dataType: 'json',
						data: {
							lookupPage
						},
						success: function(result){
							if(_.isObject(result) && !result.isEmpty()){
								APP.renderAccountReservations(result); 
							}
						},
						error: function (/*xhr, ajaxOptions, thrownError*/) {
							APP.renderAccountReservations({voucherError:true});
							// console.log(xhr.status);
							// console.log(thrownError);
						}
					});
				}
			}
		}
	},
	renderAccountReservations:function(objMemberVoucherInfo) {
		AEdata.stMemberVoucherLang = AEdata.stMemberVoucherLang || {};
		var $dfAccountReservations = $(document.createDocumentFragment());
		if(objMemberVoucherInfo.hasOwnProperty('voucherError') &&
			objMemberVoucherInfo.voucherError === true
		){
			$dfAccountReservations.append(APP.renderAccountReservationLookupError());
		} else if(objMemberVoucherInfo.hasOwnProperty('vouchers') && 
			_.isObject(objMemberVoucherInfo.vouchers) && 
			!_.isEmpty(objMemberVoucherInfo.vouchers) &&
			objMemberVoucherInfo.vouchers.hasOwnProperty('current') &&
			objMemberVoucherInfo.vouchers.hasOwnProperty('past') &&
			_.isArray(objMemberVoucherInfo.vouchers.current) &&
			_.isArray(objMemberVoucherInfo.vouchers.past)
		){
			['current','past'].forEach(function(vouchKey) {
				var theseVouchers = objMemberVoucherInfo.vouchers[vouchKey];
				var $thisGrid = $(document.createElement('div')).addClass('grid');
				var $thisGridItem = $(document.createElement('div')).addClass('grid__item one-whole palm-one-whole soft--left');
				var classKey = 'curr';
				var langKey = 'CURRENT';
				if(vouchKey === 'past'){
					$thisGridItem.addClass('push-half--top');
					classKey = 'past';
					langKey = 'PAST';
				} else {
					if(typeof AEdata.stMemberVoucherLang.HEADER_RESERVATIONS_CONTENT === 'string' && AEdata.stMemberVoucherLang.HEADER_RESERVATIONS_CONTENT !== ''){
						$thisGridItem.append(
							$(document.createElement('p'))
							.append(AEdata.stMemberVoucherLang.HEADER_RESERVATIONS_CONTENT)
						);
					}
				}
				$thisGridItem.append(
					$(document.createElement('h3'))
					.append(AEdata.stMemberVoucherLang['HEADER_'+langKey] || 'HEADER_'+langKey)
				);
				if(_.isEmpty(theseVouchers)){
					$thisGridItem.append(
						AEdata.stMemberVoucherLang['NO_'+langKey+'_MSG'] || 'NO_'+langKey+'_MSG'
					);
				}
				var $thisTable = $(document.createElement('table')).addClass('memres--'+classKey+'--reservations table--striped');
				var $labelRow = $(document.createElement('tr')).addClass('cardetails-smallprint memres_row');
				$labelRow.append(
					$(document.createElement('td'))
					.addClass('memres_puCalLabel')
					.append(
						$(document.createElement('label'))
						.append(AEdata.stMemberVoucherLang.PUDATE_LABEL || 'PUDATE_LABEL')
					)
				);
				$labelRow.append(
					$(document.createElement('td'))
					.addClass('memres_vouchLabel')
					.append(
						$(document.createElement('label'))
						.append(AEdata.stMemberVoucherLang.VOUCHER_LABEL || 'VOUCHER_LABEL')
					)
				);
				$labelRow.append(
					$(document.createElement('td'))
					.addClass('memres_puLocLabel visuallyhidden--palm')
					.append(
						$(document.createElement('label'))
						.append(AEdata.stMemberVoucherLang.PULOC_LABEL || 'PULOC_LABEL')
					)
				);
				$labelRow.append(
					$(document.createElement('td'))
					.addClass('memres_statusLabel visuallyhidden--palm')
					.append(
						$(document.createElement('label'))
						.append(AEdata.stMemberVoucherLang.STATUS_LABEL || 'STATUS_LABEL')
					)
				);
				$labelRow.append(
					$(document.createElement('td'))
					.addClass('memres_action_label numerical')
					.append(
						$(document.createElement('label'))
						.append('&nbsp;')
					)
				);
				$thisTable.append($labelRow);
				theseVouchers.forEach(function(thisVouch) {
					var $thisRow = $(document.createElement('tr')).addClass('cardetails-smallprint');
					$thisRow.append(
						$(document.createElement('td'))
						.addClass('memres_puCalLabel')
						.append(thisVouch.DATE)
					);
					$thisRow.append(
						$(document.createElement('td'))
						.addClass('memres_vouchLabel')
						.append(thisVouch.VOUCHNUM)
					);
					$thisRow.append(
						$(document.createElement('td'))
						.addClass('memres_puLocLabel visuallyhidden--palm')
						.append(thisVouch.PICKUP)
					);
					$thisRow.append(
						$(document.createElement('td'))
						.addClass('memres_statusLabel visuallyhidden--palm')
						.append(thisVouch.STATUSDISPLAY)
					);
					
					var $linkCell = $(document.createElement('td')).addClass('memres_action numerical');
					if(vouchKey === 'past'){
						$linkCell.append($(document.createElement('a'))
							.attr('href',thisVouch.URL)
							.append(AEdata.stMemberVoucherLang.VIEW_LINK || 'VIEW_LINK')
						);
					} else if(thisVouch.STATUS === 'D') {
						$linkCell.append($(document.createElement('a'))
							.attr('href',thisVouch.URL)
							.append(AEdata.stMemberVoucherLang.VIEW_LINK || 'VIEW_LINK')
						);
					} else {
						$linkCell.append($(document.createElement('a'))
							.attr('href',thisVouch.URL)
							.append($(document.createElement('span'))
								.addClass('visuallyhidden--desk visuallyhidden--desk-wide visuallyhidden--tablet visuallyhidden--lap')
								.append(AEdata.stMemberVoucherLang.VIEW_LINK || 'VIEW_LINK')
							)
							.append($(document.createElement('span'))
								.addClass('visuallyhidden--palm')
								.append(AEdata.stMemberVoucherLang.VIEW_LINK || 'VIEW_MODIFY_LINK')
							)
						);
					}
					$thisRow.append($linkCell);
					$thisTable.append($thisRow);
				});
				$thisGridItem.append($thisTable);
				$dfAccountReservations.append($thisGrid.append($thisGridItem));
			});
		} else {
			$dfAccountReservations.append(APP.renderAccountReservationLookupError());
		}
		$('#toggleeMemberReservations').html($dfAccountReservations);
	},
	renderAccountReservationLookupError:function(){
		AEdata.stMemberVoucherLang = AEdata.stMemberVoucherLang || {};
		return $(document.createElement('div')).addClass('grid').append(
			$(document.createElement('div'))
			.addClass('grid__item one-whole palm-one-whole soft--left')
			.append(AEdata.stMemberVoucherLang.VOUCHER_LOOKUP_ERROR || 'VOUCHER_LOOKUP_ERROR')
		);
	}
	,
	deparam: function (query) { //WEBAE3-6285 END cool little tool
		var pairs, i, keyValuePair, key, value, map = {};
		// remove leading question mark if its there
		if (query.slice(0, 1) === '?') {
			query = query.slice(1);
		}
		if (query !== '') {
			pairs = query.split('&');
			for (i = 0; i < pairs.length; i += 1) {
				keyValuePair = pairs[i].split('=');
				key = decodeURIComponent(keyValuePair[0]);
				value = (keyValuePair.length > 1) ? decodeURIComponent(keyValuePair[1]) : undefined;
				map[key] = value;
			}
		}
		return map;
	}
};

	return APP;
})();


;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist.  */

AE.modal = AE.modal || (function(){
	/*
	DEPENDENCIES: AE
	*/
		var APP = {
		init:function() {
			APP.props = {
				$modalLink	: $('a.open_modal_page'),
				$devheight 	: $(window).height(),
				$devWidth 	:$(window).width()	
			};

			APP.props.$modalLink.on('click', function(e){
				e.preventDefault();
				var $target = $(e.target);
				var strUrl = $target.attr('data-url');
				APP.openPageModal(strUrl);
			});
			
		}
		,

		openPageModal:function(strUrl) {
			var currFontSize = $("html").css('font-size');
			
			if(APP.props.$devWidth < 701){
					mwidth  = .90*APP.props.$devWidth;
					mheight = .90*APP.props.$devheight;
				}
			else if(APP.props.$devWidth >700  &&  APP.props.$devWidth < 1000 ){
				mwidth = '550';
				mheight= '700';

			}
			else{
					mwidth = '650';
					mheight= '700';
				}

   			 $.post(strUrl, function(data){   
		            $('#dialog-modal-page').html(data);
		            $('#dialog-modal-page').dialog('open');
		       }, "html");

	   	 	$("#dialog-modal-page").dialog({
		        resizable: false,
		        autoOpen: false,
		        modal: true,
		        width:mwidth,
		        height:mheight,
		  		open: function(){
		            jQuery('.ui-widget-overlay').bind('click',function(){
		                jQuery('#dialog-modal-page').dialog('close');
		            })
		        }
		   }).css("font-size",currFontSize );
		
		}
	};
	return APP;
})();
     
;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.customerService = AE.customerService || (function() {
	/* DEPENDENCIES: AE */
	var APP = {
		init: function() {
			APP.props = {
				$customerServiceForm : $('#customerForm'),
				$serviceFormType : $('#customerForm').data('serviceformtype'),
                noEBSites: ['AUS', 'DAU', 'DNZ', 'NZL', 'DAP', 'GCR', 'RAU', 'RNZ', 'PEU'], // WEBAE3-6275 - hide excess refund and breakdown protection from certain customer service forms
                allowExcessBreakdown: true,
				siteList : ['AEM','AOR','AUS','AUT','BEL','BFR','BRA','CHE','CHF','CHI','DAP','DAU','DEU','DNK','DNZ','ESL','ESP','EUR','FIN','FRA','GBR','GCR','HKG','HRV','IRL','ITA','NAL','NLD','NOR','NZL','PEU','POL','RAU','RNZ','RUS','SWE','TUR','TWN','ZAF','US','CA','CAE','KEM','URC','ERC','ATP'],
                formOnVoucher: $('body').is('#mybooking'),
                hasAltERFields: ['EU', 'GB', 'US', 'CA', 'AU', 'NZ'].includes($('#customerForm').data('serviceformorigin')) // Determines if site has special form fields for Excess Refund Inquiry Type
			};

            // WEBAE3-6275 - hide excess refund/breakdown protection fields if site matches
            for(var i=0; i<APP.props.noEBSites.length; i++) {
                if($('body').hasClass('site--'+APP.props.noEBSites[i])) {
                    APP.props.allowExcessBreakdown = false;
                }
            }
            
			// Preload the max counter on the comments form field
			$('#charactersLeft span').text(APP.props.commentsMaxChars);
			
			// Comments text area character count
			$('#comments, .has-max-counter').on('keyup', function() {
				APP.characterCounter($(this).parent());
			});
            
			// Fine Uploader
			if (AEdata.customerservice && AEdata.customerservice.formAction != 'submit') {
                
				if (AEdata.customerservice.showGenericUploadFields) {
					APP.formFineUploaderInstance('file_upload');
					APP.formFineUploaderInstance('file_upload2');
					APP.formFineUploaderInstance('file_upload3');
					APP.formFineUploaderInstance('file_upload4');
				} else {
                    // WEBAE3-5984 initialize fields based on customer service form location
                    //WEBAE3-6275 don't initialize excess refund or breakdown upload fields for AU/NZ to prevent errors
                    if(APP.props.formOnVoucher && APP.props.hasAltERFields) {
                        APP.formFineUploaderInstance('file_accidentReport');
                        APP.formFineUploaderInstance('file_policeReport');
                        APP.formFineUploaderInstance('file_checkInOutReport');
                        APP.formFineUploaderInstance('file_picDamageOne');
                        APP.formFineUploaderInstance('file_picDamageTwo');
                        APP.formFineUploaderInstance('file_picDamageThree');
                        APP.formFineUploaderInstance('file_picDamageFour');
                        APP.formFineUploaderInstance('file_ccStatementER');
                        APP.formFineUploaderInstance('file_suppDocsER');
                        APP.formFineUploaderInstance('file_rentalAgreementER');
                        APP.formFineUploaderInstance('file_finalInvoiceER');
                    } else if(APP.props.allowExcessBreakdown) {
                        APP.formFineUploaderInstance('file_excessRefund');
                    }
                    
                    APP.formFineUploaderInstance('file_picDamage');
                    APP.formFineUploaderInstance('file_ccStatement');
					APP.formFineUploaderInstance('file_origVoucher');
					APP.formFineUploaderInstance('file_fuelReceit');
					APP.formFineUploaderInstance('file_finalInvoice');
					APP.formFineUploaderInstance('file_rentalAgreement');
					APP.formFineUploaderInstance('file_addCharges');
					APP.formFineUploaderInstance('file_addCharges_2');
					APP.formFineUploaderInstance('file_tireRepair');
					APP.formFineUploaderInstance('file_suppDocs');
                    if(APP.props.allowExcessBreakdown) {
                        APP.formFineUploaderInstance('file_breakdownProtection');
                    }
					if (AEdata.customerservice.showOtherUploadFields) {
						APP.formFineUploaderInstance('file_upload');
						APP.formFineUploaderInstance('file_upload2');
						APP.formFineUploaderInstance('file_upload3');
					}
				}
				
				// Use language management for the file upload buttons and background
				$('div.qq-upload-button div').text(AEdata.customerservice.pageText_chooseFile);
				$('div.qq-upload-remove-button').text(AEdata.customerservice.pageText_removeFile);
				$('div.qq-uploader-selector.qq-uploader').attr('qq-drop-area-text', AEdata.customerservice.pageText_dropFile);
                
                if(AEdata.customerservice.formAction == 'haserror' && APP.props.formOnVoucher) {
                    APP.jumpToClaimForm();
                }
			} else if(AEdata.customerservice && AEdata.customerservice.formAction == 'submit' && APP.props.formOnVoucher) {
                APP.jumpToClaimForm();
            }
			
//			if (APP.props.$serviceFormType === 'EUR') {
				$('.fileUP label, .linkUP label').mouseenter(function() {
					$(this).siblings('.uploadHover').show();
				});
				
				$('.fileUP label, .linkUP label').mouseleave(function() {
					$(this).siblings('.uploadHover').hide();
				});
				
				var selLoad = $('#inquiry_type option:selected').attr('upload');
				APP.setInquiryType(selLoad);
				
				// on change
				$('#inquiry_type').on('change', function() {
					var selChange = $('#inquiry_type option:selected').attr('upload');
					APP.setInquiryType(selChange);
				});
//			}
			
			if (APP.props.$serviceFormType === 'AUS') {
				APP.changeCity('both');
			}
			
			/* PAGE CLICK EVENTS */
			$('body').on('click', function (event) {
				var $target = $(event.target);
                
				if ($target.hasClass('qq-upload-remove-button')) {
					// Remove the file image, file name, hidden input value, and change the button back to "Choose File"
					APP.resetFileUploadInput( $target.closest('.file_upload').prev('.file_upload_filename') );
				}

				if ($target.is("#cs_form_submit")) {					
					if (_.contains( APP.props.siteList, AE.props.siteCode )) {
						//client side error handling for attachments
						$('#errorHead').hide();
						$('#suppdocsError').hide();
						$('#addchargesError').hide();
						$('#ccstatementError').hide();
						$('#originalvouchError').hide();
						$('#fuelrefundError').hide();
						$('#excessrefundError').hide();
						$('#breakdownprotectionError').hide();
						$('#tirereceiptError').hide();
						$('#addchargesError').hide();

						if ($('#inquiry_type').val() == 'DC' && $('#file_ccStatement').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#ccstatementError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'DC' && $('#file_suppDocs').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#suppdocsError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'BP' && $('#file_ccStatement').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#ccstatementError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'BP' && $('#file_suppDocs').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#suppdocsError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'BP' && $('#file_breakdownProtection').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#breakdownprotectionError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'TR' && $('#file_tireRepair').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#tirereceiptError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'ND' && $('#file_addCharges').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#addchargesError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}
						
						if ($('#inquiry_type').val() == 'UC' && $('#file_ccStatement').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#ccstatementError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

                        if(!APP.props.hasAltERFields || !APP.props.formOnVoucher) {
                            if ($('#inquiry_type').val() == 'ER' && $('#file_ccStatement').val() == "") {
                                $target.addClass('off');
                                $('#errorHead').show();
                                $('#ccstatementError').show();
                                $('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
                            }

                            if ($('#inquiry_type').val() == 'ER' && $('#file_suppDocs').val() == "") {
                                $target.addClass('off');
                                $('#errorHead').show();
                                $('#suppdocsError').show();
                                $('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
                            }

                            if ($('#inquiry_type').val() == 'ER' && $('#file_excessRefund').val() == "" && APP.props.allowExcessBreakdown) {
                                $target.addClass('off');
                                $('#errorHead').show();
                                $('#excessrefundError').show();
                                $('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
                            }
                        } else {
                            if ($('#inquiry_type').val() == 'ER') {
                                var ererror = false;
                                if($('#police_report_yes').is(':checked') && $('#file_policeReport').val() == "") {
                                    ererror = true;
                                    $('#policeReportError').show();
                                } else {
									$('#policeReportError').hide();
								}
                                
                                if(!$('#customer_consent').is(':checked')) {
                                    ererror = true;
                                    $('#customer_consent').addClass('haserror');
                                    $('#consentError').show();
                                } else {
									$('#customer_consent').removeClass('haserror');
                                    $('#consentError').hide();
								}

                                if(ererror) {
                                    $target.addClass('off');
                                    $('#errorHead').show();
                                    $('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
                                } else {
                                    $('#customer_consent').removeClass('haserror');
                                    $('#policeReportError, #consentError').hide();
                                }
                            } else {
                                $('#policeReportError, #consentError').hide();
                            }
                        }

						if ($('#inquiry_type').val() == 'BD' && $('#file_addCharges').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#addchargesError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}
                        
						if ($('#inquiry_type').val() == 'BD' && $('#file_suppDocs').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#suppdocsError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'DU' && $('#file_ccStatement').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#ccstatementError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'FR' && $('#file_ccStatement').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#ccstatementError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'FR' && $('#file_fuelReceit').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#fuelrefundError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'CI' && $('#file_ccStatement').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#ccstatementError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'CB' && $('#file_origVoucher').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#originalvouchError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						if ($('#inquiry_type').val() == 'CB' && $('#file_ccStatement').val() == "") {
							$target.addClass('off');
							$('#errorHead').show();
							$('#ccstatementError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}

						/*
						if (typeof $('.required .qq-upload-file').html() == 'undefined') {
							// prevent form submit if any required files are missing
							$target.addClass('off');
							$('#errorHead').show();
							$('#missingfileError').show();
							$('#cs_headline')[0].scrollIntoView({behavior:'smooth',block: 'start'});
						}
						*/
					}
					
					event.preventDefault();

					if (! ( $target.hasClass( 'off' )) ) {
						// Disable Submit button	
						$target.prop( 'disabled', true );

						// Submit the form
						APP.props.$customerServiceForm.submit();							
					}

					if ( _.contains( APP.props.siteList, AE.props.siteCode )) {
						//if ($('#inquiry_type').val() == 'BD' && $('#file_addCharges').val() == "") {
							$target.removeClass( 'off' );
							setTimeout ( () => { $target.prop( 'disabled', false );} ,5000 );
						//}
					}
				} else {
					$( "#cs_form_submit" ).prop( 'disabled', false );
				}
			});
            
            /* REFUNDABLE EXCESS SUBSECTION SHOW/HIDE RADIO EVENTS */
            $('body').on('change', '.has-subsection input[type="radio"]', function()
            {
                APP.toggleRESubsection($(this).attr('name'));
            });
		},
        jumpToClaimForm: function() {
            // WEBAE3-5968 Jump to and open customerservice form on claim submit or error, but only on voucher lookup page
            $('#btSubmitClaim').addClass('open').removeClass('closed');
            $('#toggleeClaim').removeClass('visuallyhidden');
            var st = $('#scroll-content').scrollTop() - 20;
            $('#scroll-content').scrollTop($('#bookingSubmitClaim').offset().top + st);
        },
		resetFileUploadInput: function(fileUploadInput) {
			var formfield = fileUploadInput.attr('id'); //get the name of the hidden input form field
			$('input#'+formfield).val(""); //remove the filename from the hidden form input
			$('#upload_block-'+formfield+' .qq-upload-remove-button').hide(); //remove the "Remove" button
			$('#upload_block-'+formfield+' .qq-upload-button').show(); //show the "Upload" button
			fileUploadInput.next('.file_upload').find('li').remove(); //remove the file info
			if (typeof AEdata.customerservice !== 'undefined') {
				fileUploadInput.next('.file_upload').find('.qq-uploader-selector').attr('qq-drop-area-text', AEdata.customerservice.pageText_dropFile); //add back in the text to drop a file
			}
			if (typeof AEdata.beatrate !== 'undefined') {
				fileUploadInput.next('.file_upload').find('.qq-uploader-selector').attr('qq-drop-area-text', AEdata.beatrate.pageText_dropFile); //add back in the text to drop a file
			}	
		},
		setDOCode: function(thispucode) {
			var element = document.getElementById('docode');
				element.value = thispucode;
		},
		characterCounter: function($el) {
			var len = $el.find('textarea').val().length;
            var commentsMaxChars = $el.find('textarea').attr('maxlength') ? parseInt($el.find('textarea').attr('maxlength')) : 500;
			var ch = commentsMaxChars - len;
			if (len > commentsMaxChars) {
				$el.find('.charactersLeft span').text('0');
				$el.find('.charactersLeft').addClass('color9');
				$el.removeClass('ui-state-valid').addClass('ui-state-invalid');
			} else {
				$el.find('.charactersLeft span').text(ch);
				$el.find('.charactersLeft').removeClass('color9');
				$el.removeClass('ui-state-invalid');
			}
		},
		setInquiryType: function(selType) {
            // WEBAE3-6107 display message for UK Refundable Excess inquiry type instead of form
            $('.fileUP, .linkUP, .csfield').addClass('visuallyhidden'); //start by 'visually' hiding all fields
            if(selType == 'ER' && AE.props.chaosSystem == 'GB') {
                $('#ERUKMSG').show();
                $('.inquiry-comments, .sendrequest-btn').hide();
            } else {
                $('#ERUKMSG').hide();
                $('.inquiry-comments, .sendrequest-btn').show();
                $('.fileUP').removeClass('required'); //remove the required class from the parent div of the file upload blocks
                $('.csfield [required]').removeAttr('required'); //remove the required attribute from all form field elements
                if(selType != 'ER' || APP.props.hasAltERFields) {
                    $('.fileUP.'+selType+', .linkUP.'+selType+', .csfield.'+selType).removeClass('visuallyhidden'); //show only the file upload blocks and form fields associated with the chosen "inquiry type"
                    $('.fileUP.'+selType).addClass('required'); //add the required class to all 'chosen' file upload blocks
                    $('.csfield.'+selType+' .required input, .csfield.'+selType+' .required textarea, .csfield.'+selType+' .required select').prop('required', true); //add required attribute to all required 'chosen' form fields
                    $('.fileUP.'+selType+'.notreq').removeClass('required'); //remove the required requirement from those blocks and fields with the class 'notreq'
                }
                
				// WEBAE3-6519 - When the user selects Refundable Excess Rate, the form cannot be completed because it is expecting 2 file uploads that are not requested.
				if(selType == 'ER' && (AE.props.chaosSystem != 'AU' || AE.props.chaosSystem != 'NZ')) {
                    $('.fileUP.'+selType+', .linkUP.'+selType+', .csfield.'+selType).removeClass('visuallyhidden'); //show only the file upload blocks and form fields associated with the chosen "inquiry type"
                    $('.fileUP.'+selType).addClass('required'); //add the required class to all 'chosen' file upload blocks
                    $('.csfield.'+selType+' .required input, .csfield.'+selType+' .required textarea, .csfield.'+selType+' .required select').prop('required', true); //add required attribute to all required 'chosen' form fields
                    $('.fileUP.'+selType+'.notreq').removeClass('required'); //remove the required requirement from those blocks and fields with the class 'notreq'
                }
				
                if(selType == 'ER' && APP.props.hasAltERFields) {
                    if(AE.props.chaosSystem != 'GB') {
                        $('.YES_ER').show();
                        $('.NO_ER').hide();
                    } else {
                        $('.YES_ER').hide();
                        $('.NO_ER').hide();
                    }
                } else {
                    $('.YES_ER').hide();
                    $('.NO_ER').show();
                }
            }
            
			// Bank Account form field
			if (window.location.pathname == '/customerservice/') {
				$('.inquiry_type_option').hide();
				// Check to see if the bank account class exists before trying to use it
				if ($('.inquiry_type_option .bank_number').length) {
					var inquiryTypeOptionsAll = document.querySelector('.inquiry_type_option .bank_number');
					inquiryTypeOptionsAll.required = 0; //remove the required property
					
					if (selType !== undefined) {
						$('.inquiry_type_option.'+selType).show();
						var inquiryTypeOptionSpecific = document.querySelector('.inquiry_type_option.'+selType+' .bank_number');
						if (inquiryTypeOptionSpecific !== null) {
							inquiryTypeOptionSpecific.required = 1; //adds the required property
						}
					}
				}
			}
		},
        toggleRESubsection: function(subsection) {
            if($('.has-subsection [name="'+subsection+'"]:checked').val() == 'YES') {
                $('.form-subsection[data-parent="'+subsection+'"]').css('display', 'none').removeClass('visuallyhidden').slideDown();
                
                if(subsection == 'police_report') {
                    $('#noPoliceReport').hide();
                }
            } else {
                $('.form-subsection[data-parent="'+subsection+'"]').slideUp(function() {
                    $(this).addClass('visuallyhidden');
                });
                
                if(subsection == 'police_report') {
                    $('#noPoliceReport').show();
                }
            }
        },
		changeCity: function(menuType) {
			/*	NEED TO REWORK FUNCTION VARS
			var site = '#request.objSite.getCode()#';
			var lang = '#request.objLang.getLanguageCode()#';
			var pucode = $('##pucode').val();
			var docode = $('##docode').val();
			var pucity =  '#pucity#';
			var docity =  '#docity#';
			var resetpucity = 'true';
			var resetdocity = 'true';
			var puDiv = $('.pucity');
			var doDiv = $('.docity');
			
			if (menuType == 'both'|menuType == 'pu') {
				$.ajax({
					url:"/ajaxsupport/car-citylist_cf.cfm",
					dataType: "html",
					cache:true,
					data:{
						site: site,
						lang: lang,
						pucode: pucode,
						pucity: pucity,
						resetpucity: resetpucity,
						listof: 'pu'
					},
					error: function(){
						puDiv.html('Sorry, there has been an error.');
					},
					beforeSend: function(){
						puDiv.html('<img src="/img/ui/loading.gif">');
					},
					success: function(data){
						puDiv.html(data);
						 //if ($('.rdRepl input').length)
						$('.pucity select').addClass("fullDD"); //adds class to only visible autosuggest list
					}
				})
			}
			
			if (menuType == 'both'|menuType == 'do') {
				$.ajax({
					url:"/ajaxsupport/car-citylist_cf.cfm",
					dataType: "html",
					cache:true,
					data:{
						site: site,
						lang: lang,
						pucode: pucode,
						docode: docode,
						docity: docity,
						resetdocity: resetdocity,
						listof: 'do'
					},
					error: function(){
						doDiv.html('Sorry, there has been an error.');
					},
					beforeSend: function(){
						doDiv.html('<img src="/img/ui/loading.gif">');
					},
					success: function(data){
						doDiv.html(data);
						$('.docity select').addClass("fullDD"); //adds class to only visible autosuggest list
					}
				})
			}
			*/
		},
		formFineUploaderInstance: function(formfield) {
			var fineUploaderFolder = "/plugins/ae3/modules/customerservice/fine_uploader";
			var galleryUploader = new qq.FineUploader({
				//debug: true,
				multiple: false,
				element: document.getElementById("upload_block-"+formfield),
				template: 'qq-simple-thumbnails-template',
				request: {
					endpoint: '/plugins/ae3/modules/customerservice/image-uploader.cfc?method=uploadSingleFile'
				},
				retry: {
					enableAuto: true
				},
				thumbnails: {
					placeholders: {
						//waitingPath: fineUploaderFolder+'/placeholders/waiting-generic.png',
						waitingPath: fineUploaderFolder+'/processing.gif',
						notAvailablePath: fineUploaderFolder+'/placeholders/not_available-generic.png'
					}
				},
				validation: {
					itemLimit: 1,
					sizeLimit: AEdata.customerservice.maxSingleFileSize,
					allowedExtensions: AEdata.customerservice.allowedFileExtensions
				},
				messages: {
					typeError: AEdata.customerservice.errorMessageFileType,
					sizeError: AEdata.customerservice.errorMessageFileSize
				},
				callbacks: {
					onUpload: function(id, name) {
						$('#cs_form_submit').addClass('off');
					},
					onComplete: function(id, name, responseJSON) {
						if (responseJSON.success) {
							$('input#'+formfield).val(responseJSON.server_filename);
							$('#upload_block-'+formfield+' .qq-upload-button').hide();
							$('#upload_block-'+formfield+' .qq-upload-remove-button').show();
							$('#cs_form_submit').removeClass('off');
						}
					}
					//onError: function(id, name, errorReason) {
					//},
				}
			});
		}
	};
	
	return APP;
})();

AE.customerService.init();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
The AE.forms object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.legacy object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.forms = AE.forms || (function () {
    /*
    DEPENDENCIES: AE
    */
    var APP = {
        init: function () {
            // Class identifies forms the need form validation // Whole container click event // age info icon on search form // Group of Checkboxes // Each of Group Checkboxes // Any Checkbox on a form to validate on click // Check if optional payment if CC is filled in require other CC fields // Check if payment is optional // Flag whether checkout form inputs passed AJAX validation
            APP.props = {
                $autoForms: $(".trg__form--AutoPost"),
                $validateForm: $("form.validate"),
                $moreInfoBtn: $(".info-icon"),
                //cannot seem to find syntax for pulling this from search props in search.js
                $ageMin: 25, // The minimum age to rent without additional restrictions or fees
                $ageMax:  69, // The maximum age to rent without additional restrictions or fees
                $ageInfoBtn: $(".age-info-icon"),
                $ageInfoText: $(".age-info-text"),
                $modalCloseBtn: $(".ui-icon-close-modal").parent(".ui-dialog-titlebar-close"),
                $groupCheckboxes: $("form #carcategory"),
                $groupCheckinputs: $('form #carcategory input[type="checkbox"]'),
                $checkboxes: $('form input[type="checkbox"]'),
                $paymentRequire: $("#ae-checkout #cardnumber"),
                $debitRequire: $("#ae-checkout #ddaccount"),
                $payOptional: $("#ae-checkout .payment_form").attr("pay_optional"),
                $formLabels: $("form label"),
                checkoutPassedAjax: true,
                loginInputValid: true,
                $isInMemberAccount:window.location.pathname.split('/')[1] == 'member-accounts'
            };

            // Validate forms with validate class
            APP.applyGuardian(APP.props.$validateForm);

            AE.ui.addBodyClickTask({
                func: APP.onBodyClick
            });

            AE.ui.addBodyChangeTask({
                func: APP.onBodyChange
            });

            // Blanket Ban on labels in info tips focusing their associated input
            APP.props.$formLabels.on("click", function (event) {
                if ($(this).hasClass("more-info-tip")) {
                    event.preventDefault();
                }
            });

            // Initialize fineUploader JS on beatrate file input - WEBAE3-4369
            if($('input#file_compquote').length) {
                APP.formFineUploaderInstance('file_compquote', 'beatrate');
            }

            //validate TBI promo code if provided to be analyzed on submit - WEBAE3-4083
            $( "#tbiPromo" ).blur(function() {
                if ($( "#tbiPromo" ).length !=0) {
                    if ($('input[name="tbiPromo"]').val().length != 0) {
                        jsonToCheck = {
                            "pcode": $('input[name="tbiPromo"]').val()
                        };
                        $("#submitForm").attr("disabled", true);
                        //$("#submitForm").css("opacity", "0.5");
                        $.ajax({
                                url: "/plugins/ae3/lib/BookingAjax.cfc?method=validateTBIPromo",
                                type: 'GET',
                                dataType: "json",
                                data: jsonToCheck
                            })
                            .done(function(data) {
                                isValidTBIPromo = data;
                                $("#submitForm").attr("disabled", false);
                                //$("#submitForm").css("opacity", "1.0");
                                if (data === false) {
                                    $('input[name="tbiPromo"]')
                                                    .parent()
                                                    .removeClass("ui-state-valid")
                                                    .addClass("ui-state-invalid"); 
                                            $("#tbi_promo_error").show();
                                } else {
                                    $("#tbi_promo_error").hide();
                                };
                            })
                            .fail(function() {
                                $("#submitForm").attr("disabled", false);
                                //$("#submitForm").css("opacity", "1.0");
                            });

                    } else {
                        $("#tbi_promo_error").hide();
                    }
                }
            });

            // Info Text Pop Window Placement & hide/show
            APP.props.$moreInfoBtn.on("click", function (event) {
                event.preventDefault(); // So form labels with info buttons do not validate on click/blur of label

                var $targetElement = $(event.target).hasClass("fa") ? $(event.target) : $(event.target).children("i");
                AE.ui.dialog.launch({
                    type: "infoTip",
                    pos: {
                        my: "left bottom",
                        at: "right top",
                        of: $targetElement
                    },
                    selector: $targetElement.parent().siblings(".info-text")
                });
            });

            // Optional Payment when users adds Credit Card Require other payment fields
            if (AEdata.hasOwnProperty('checkout') && AEdata.checkout.hasOwnProperty('rq') && AEdata.checkout.rq === false) {
                APP.props.$paymentRequire.on("change", function (event) {
                    if (APP.props.$paymentRequire.val() !== "") {
                        $("#cardname,#cardnumber,#cvc,#address1,#zip,#cityb")
                            .prop("required", "required")
                            .parent()
                            .addClass("required")
                            .removeClass("ui-state-valid ui-state-invalid");
                        $("#expmonth,#expyear")
                            .prop("required", "required")
                            .parent()
                            .removeClass("ui-state-valid ui-state-invalid");
                        $("#expmonth")
                            .parent()
                            .parent()
                            .addClass("required");
                        $("#country,#state")
                            .parent()
                            .removeClass("ui-state-valid ui-state-invalid")
                            .parent()
                            .addClass("required");
                    } else {
                        $("#cardname,#cardnumber,#cvc,#address1,#zip,#cityb")
                            .prop("required", "")
                            .parent()
                            .removeClass("required")
                            .removeClass("ui-state-valid ui-state-invalid");
                        $("#expmonth,#expyear")
                            .prop("required", "")
                            .parent()
                            .removeClass("ui-state-valid ui-state-invalid");
                        $("#expmonth")
                            .parent()
                            .parent()
                            .removeClass("required");
                        $("#country,#state")
                            .parent()
                            .removeClass("ui-state-valid ui-state-invalid")
                            .parent()
                            .removeClass("required");
                    }
                });
				
                APP.props.$debitRequire.on("change", function (event) {
                    if (APP.props.$debitRequire.val() !== "") {
                        $("#ddaccount,#ddname,#ddbank,#address1,#zip,#cityb")
                            .prop("required", "required")
                            .parent()
                            .addClass("required")
                            .removeClass("ui-state-valid ui-state-invalid");
                        $("#expmonth,#expyear")
                            .prop("required", "required")
                            .parent()
                            .removeClass("ui-state-valid ui-state-invalid");
                        $("#expmonth")
                            .parent()
                            .parent()
                            .addClass("required");
                        $("#country,#state")
                            .parent()
                            .removeClass("ui-state-valid ui-state-invalid")
                            .parent()
                            .addClass("required");
                    } else {
                        $("#ddaccount,#ddname,#ddbank,#address1,#zip,#cityb")
                            .prop("required", "")
                            .parent()
                            .removeClass("required")
                            .removeClass("ui-state-valid ui-state-invalid");
                        $("#expmonth,#expyear")
                            .prop("required", "")
                            .parent()
                            .removeClass("ui-state-valid ui-state-invalid");
                        $("#expmonth")
                            .parent()
                            .parent()
                            .removeClass("required");
                        $("#country,#state")
                            .parent()
                            .removeClass("ui-state-valid ui-state-invalid")
                            .parent()
                            .removeClass("required");
                    }
                });
 
            }

            // checkboxes validate on selection, check correct form (may be multiple forms on page)
            APP.props.$checkboxes.on("click", function (event) {
                var theForm = $(event.target).closest("form")[0];
                // prevent guardian validation on the Search form
                if (theForm.id !== "ae-search") {
                    $(theForm)
                        .guardian()
                        .validateCheckbox($(event.target));
                }
            });

            // Define Spinning Gear Markup for Submit Buttons
            if(AE.props.siteCode === 'FCR') {
                APP.props.$spinGear = $(document.createDocumentFragment()).append('<div class="ui--loading-results indeterminate-circle-sm" aria-hidden="true"><svg version="1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 24 24"><path id="indeterminate" d="M12 3.25A8.75 8.75 0 1 1 3.25 12" fill="none" stroke-width="2.5" stroke-linecap="square" stroke="#ffffff"/></svg></div>');
            } else {
                APP.props.$spinGear = $(document.createDocumentFragment()).append($(document.createElement("i"))
                .addClass("ui--loading-results fa fa-cog fa-spin fa-2x fa-fw")
                .attr("aria-hidden", true));
            }
            
            /* Car class "other" form field */
            $('#br_carclass').change(function () {
                if ($('#br_carclass').val() === "Other") {
                    $("#carother")
                        .prop("required", "required")
                        .parent()
                        .addClass("required")
                        .removeClass("ui-state-valid ui-state-invalid");
                } else {
                    $("#carother")
                        .prop("required", "")
                        .parent()
                        .removeClass("ui-state-valid ui-state-invalid")
                        .parent()
                        .removeClass("required");
                }
            });

			/*
			$('#dp_country').change(function() {
				APP.props.$paymentRequire.on("change", function(event) {
					if (APP.props.$paymentRequire.val() !== "") {
						$("#cardname,#cardnumber,#cvc,#address1,#zip,#cityb")
						.prop("required", "required")
						.parent()
						.addClass("required")
						.removeClass("ui-state-valid ui-state-invalid");
					} else {
						$("#country,#state")
						.parent()
						.removeClass("ui-state-valid ui-state-invalid")
						.parent()
						.removeClass("required");
					}
					.grid.postalCode ==  hide
				});
			}
			*/
			
			$("#gpsTNC--Y").on("click", function () {
				$("#gpsreqbtn").removeClass("visuallyhidden");
				$("#gpsTNCchk")
					.removeClass("fa-square")
					.addClass("fa-check-square");
				$("#rental_termsDialog_Gps").dialog("close");
			});
		},
		// Apply client-side form field validation (datePicker validation can be found in AE.ui.js)
		applyGuardian: function ($forms) {
			// Validation Plugin Function Call
			$forms.each(function () {
				var form = this;
				$(form).guardian({
					// Extend the default Guardian data patterns
					// https://www.petefreitag.com/cheatsheets/regex/
					extend: function () {
                        // Alpha numeric
						this.addPattern({
							alnum: /^[a-zA-Z0-9]+$/
						});

						// Alpha numeric with spaces and dashes
						this.addPattern({
							alnumsp: /^[a-zA-Z0-9\-\s]+$/
						});

                        // Numeric with spaces - WEBAE3-6391 - Skylink: CC number field should accept spaces
						this.addPattern({
							numsp: /^[0-9\s]+$/
						});
						
						// Alpha numeric with spaces, dashes, and dots (periods)
						this.addPattern({
							alnumspdot: /^[a-zA-Z0-9\.\-\s]+$/
						});
						
						// Alpha numeric with spaces and special characters
						this.addPattern({
							alnumspecial: /^[a-zA-Z0-9\s\_\&()`.+,\/'-]*$/
						});
						
						// Alpha with spaces and hyphens
						this.addPattern({
							alphasp: /^[a-z_'& \-]+$/i
						});
						
						// Anything goes (BUT, there needs to be at least one charecter)
						this.addPattern({
							anything: /.+/
						});
						
						// Anything goes (BUT, there needs to be at least one charecter that isn't < > = & ")
						this.addPattern({
							anythingcheckout: /^(?!.*[="<>&]).*$/
						});

                        // email updated for WEBAE3-1204 - broader regex with case insensitivity
						this.addPattern({
							email: /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
						});
						
						// Hex code for color picker
						this.addPattern({
							hexcolor: /#?[a-fA-F0-9]{3,6}/
						});
						
						// There needs to be a leading zero in front of the integer
						this.addPattern({
							lead0num: /^[0-9]+$/
						});
						
						// Anything but blank
						this.addPattern({
							notblank: /^(?!\s*$).+/
						});
						
						//WEBAE3-4934 added < > = & " characters to notblank for checkout page only
						this.addPattern({
							notblankcheckout: /^(?!\s*$)([^="<>&]+)$/
						});
						// European and US phone combinations
						this.addPattern({
                            wphone: /^(?!\s)(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})?(?:\s?\(\d+\))?(?:[-\/\s.]|\d)+$/
                        });
                        
                        // phone number with minimum 8 digits
						this.addPattern({
                            aunzphone: /(?:\+?\)?\(?\s?\-?\d){8,}/
                            //aunzphone: /^(?!\s)(?:\+?)(?:\d){8,}$/
						});
						
						/// URL
						this.addPattern({
							// http://fubar.com, http://www.fubar.com, https://fubar.com, https://www.fubar.com, fubar.com, and www.fubar.com
							url: /^(http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]+\s*$/
						});
						
						/********************************/
						/* AUTOEUROPE SPECIFIC PATTERNS */
						
						// AE affiliate member's passwords can be anything as long as it's between 8 and 16 characters
						this.addPattern({
							ae_affiliatepassword: /^.{8,16}/
						});
						
						// AE generic currency is a 2-decimal floating point number without a currency symbol
						this.addPattern({
							ae_currency: /^(\d+)+(,?\d{3})*(\.\d{2})?$/
						});
						
						// AE member's age
						this.addPattern({
							ae_memberage: /^(1[89]|[2-9]{1}\d{1})$/
						});
						
						// AE member's name
						this.addPattern({
							// a-z, A-Z, 0-9, underscore, must be between 3 and 15 characters, spaces are not allowed
							ae_membername: /^[\w]{3,15}$/
						});
						
						// AE account passwords (both members and affiliates) need to adhere to the following criterea:
						//    * between 8 characters and 16 characters long
						//    * contain at least one lowercased letter
						//    * contain at least one uppercased letter
						//    * contain at least one number
						//    * contain at least one special character
						this.addPattern({
							ae_memberpassword: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^0-9a-zA-Z]).{8,16}$/
						});
						
						// AE numeric date pattern in forms
						var sitesWithReverseDatePattern = ["AUS", "NZL"];
						if (sitesWithReverseDatePattern.indexOf(oSite.siteCode) != -1) {
							// date pattern = dd/mm/yyyy OR dd-mm-yyyy OR dd.mm.yyyy OR ddmmyyyy
							this.addPattern({
								ae_numericdate: /^(0?[1-9]{1}|(1|2)[0-9]|3(0|1))(-|\s|\/|\.)?((0?[1-9]{1})|(10|11|12))(-|\s|\/|\.|,\s)?(19|20)?\d\d$/i
							});
						} else {
							// date pattern = mm/dd/yyyy OR mm-dd-yyyy OR mm.dd.yyyy OR mmddyyyy
							this.addPattern({
								ae_numericdate: /^((0?[1-9]{1})|(10|11|12))(-|\s|\/|\.)?(0?[1-9]|(1|2)[0-9]|3(0|1))(-|\s|\/|\.|,\s)?(19|20)?\d\d$/i
							});
						}
						
						// AE postal code pattern
						// minimum of 4 numbers only (for all sites per WEBAE3-1156 : jOlivier 2018-04-04) & WEBAE3-1324
						this.addPattern({
							ae_postalcode: /^[a-zA-Z0-9\-\s]{4,10}\s*$/
						});
						
						// AE voucher number
						this.addPattern({
							ae_voucher: /^([a-zA-Z]{2,3})?(\d+)(\-.*)?\s*$/
						});

                        //WEBAE3-7104 Checkout form regex for Rev first and last name
						this.addPattern({
							ae_firstname_rev: /^[\.a-zA-Z\u00C0-\u00FF\u0100-\u017F\u0180-\u024F\s'`\u2019-]{1,}$/
						});                        
						this.addPattern({
							ae_lastname_rev: /^[\.a-zA-Z\u00C0-\u00FF\u0100-\u017F\u0180-\u024F\s'`\u2019-]{2,}$/
						});                        
					},
                    before: function (el) {
                        if (this.$groups.carcategory !== undefined) {
                            var addGroup = {};
                            addGroup["carcategory"] = false;
                            _.extend(this.$inputs, addGroup);
                        }

                        /* WEBAE3-4052 
                           More than one checkout button option means the billing info
                           may or may not be required. Determine if it is and adjust
                           form billing inputs required status as needed
                         */
                        if(typeof checkoutSubmitBtn !== 'undefined' && checkoutSubmitBtn.hasOwnProperty('billingrequired')) {
                            if(checkoutSubmitBtn.billingrequired !== 'default') {
                                var aBillingInputs = ['zip','country','cityb','address1','state'];
                                APP.setBillingInputRequiredStatus(aBillingInputs,checkoutSubmitBtn.billingrequired);
                            }
                        }
                    },
                    //Override Guardian's match validation
                    validateMatch: function (el) {// oro?
                        var name = el.attr('name'),
                        val = el.val(),
                        match = $('#' + el.data('match-input')),
                        noCase = ($('#' + el.data('match-nocase')))? true : false;
                        this.$inputs[name] = true;           

                        if (el.attr('required')) {                        
                            var isMatch = (noCase)? val === match.val():val.toUpperCase() === match.val().toUpperCase();
                            if (!isMatch || val == '') {
                                this.$inputs[name] = false;
                           }                              
                        }
                        this.validationHandler(el);

                        return this.$inputs[name];
                    },
                    
                    // Override Guardian's select validation
                    validateSelect: function (el) {
                        var selectValid = "ui-state-valid"; // Default set to valid
                        var addInput = {}; // create object
                        addInput[el[0].name] = true; // Default set to true passes validation
                        // set check if select has a value set
                        if ($(el).attr("required")) {
                            if ($(el).val() === "") {
                                selectValid = "ui-state-invalid";
                                addInput[el[0].name] = false;
                            } else {
                                selectValid = "ui-state-valid";
                            }
                        }
                        // don't set valid on hidden state options lists or if state is blank
                        var state = el[0];
                        if ($(state).hasClass("state--select")) {
                            if ($(el).hasClass("state_dd_hide")) {
                                selectValid = "";
                                if (this.$inputs.state !== undefined) {
                                    delete this.$inputs.state;
                                }
                                delete addInput[el[0].name];
                            }
                            if ($(el).val() === "" && !$(el).hasClass("state_dd_hide")) {
                                // Only move forward with state dropdown required if the container around the markup (hence parent().parent()) has the "required" class or the dropdown itself has the required HTML property
                                if ($(el)
                                    .parent()
                                    .parent()
                                    .hasClass("required") || $(el).prop("required")) {
                                    //WEBAE3-4036, WEBAE3-4052 make sure ui-state-valid is removed in cases where 2 buttons come into play
                                    $(el)
                                    .parent()
                                    .removeClass('ui-state-valid');
                                    selectValid = "ui-state-invalid";
                                    addInput[el[0].name] = false;
                                }
                            }
                        }

                        $(el)
                            .parent()
                            .addClass(selectValid); // Set select validation status
                        _.extend(this.$inputs, addInput); // push inputs valid status to guardian object
                    },
                    // Override Guardian's checkbox validation
                    validateCheckbox: function (el) {
                        // Check that terms has been checked
                        if ($(el).hasClass("terms_conditions")) {
                            var addInput = {}; // create object
                            addInput[el[0].name] = true; // Default set to true passes validation
                            if ($(el).is(":checked")) {
                                $(el)
                                    .parent()
                                    .removeClass("ui-state-invalid");
                            } else {
                                $(el)
                                    .parent()
                                    .addClass("ui-state-invalid");
                                addInput[el[0].name] = false;
                            }
                            _.extend(this.$inputs, addInput); // push inputs valid status to guardian object
                        }
                        if ($(el).data("group") === "carcategory" && $(el).data("group") !== undefined) {
                            $(APP.props.$groupCheckboxes)
                                .removeClass("ui-state-invalid")
                                .removeClass("ui-state-valid");

                            var checkedCount = 0;
                            APP.props.$groupCheckinputs.each(function () {
                                if ($(this).is(":checked")) {
                                    checkedCount = checkedCount + 1;
                                }
                            });
                            this.$groups.carcategory.count = checkedCount;

                            if (this.$groups.carcategory.count > 0) {
                                $(APP.props.$groupCheckboxes).addClass("ui-state-valid");
                                this.$inputs.carcategory = true;
                            } else {
                                $(APP.props.$groupCheckboxes).addClass("ui-state-invalid");
                                this.$inputs.carcategory = false;
                            }
                        }
                        //WEBAE3-7185 validate agency signup form checkbox groups
                        const group = $(el).data("group");

                        if (group && (group === "clientResidency" || group === "bookingMethod") && this.$groups[group]) {
                            const ids = this.$groups[group].members;
                            const checkedIds = new Set();
                            const containerId = group === "clientResidency" ? "clientResidency" : "bookingMethod";
                            const errorId = group === "clientResidency" ? "clientResidencyError" : "bookingMethodError";

                            ids.forEach((targetID) => {
                                const $checkbox = $("div #" + containerId).find(`input[id="${targetID}"]`);
                                if ($checkbox.prop("checked")) {
                                    checkedIds.add(targetID);
                                } else {
                                    checkedIds.delete(targetID);
                                }
                            });

                            // check array length against min required
                            const checkedIdsArray = Array.from(checkedIds);
                            if (checkedIdsArray.length < this.$groups[group].min) {
                                $("div #" + errorId).show();
                            } else {
                                $("div #" + errorId).hide();
                            }
                        }
                    },
                    validateFile: function (el) {
                        // Checks that file upload is required
                        var addInput = {}; // create object
                        addInput[el[0].name] = true; // Default set to true passes validation
                        if ($(el).prop("required") === true) {
                            if ($(el).val() === "") {
                                $(el)
                                    .parent()
                                    .addClass("ui-state-invalid");
                                addInput[el[0].name] = false;
                            } else {
                                $(el)
                                    .parent()
                                    .removeClass("ui-state-invalid");
                            }
                        } else {
                            $(el)
                                .parent()
                                .removeClass("ui-state-invalid");
                        }
                        _.extend(this.$inputs, addInput); // push inputs valid status to guardian object
                    },
                    validateCheckout: function (el, disableSubmit) {
                        var $dfd = $.Deferred();
                        var addInput = {};

                        APP.props.checkoutPassedAjax = true;
                        if($('#ta__block--details .ui-state-invalid').length){
                            $('#ta__block--details .toggle_pm_header.toggler:not(.open)').click();
                            $('#ta__block--details input').change();
                        }
                        //WEBAE3-3718 - only add spin gear to button clicked if more than one button was shown
                        if(typeof checkoutSubmitBtn !== 'undefined') {
                            $(checkoutSubmitBtn.clicked).prop("disabled", disableSubmit || false);
                            $(checkoutSubmitBtn.notclicked).prop("disabled", disableSubmit || false);
                            // replaced code: el.find('button[type="submit"]').prop("disabled", disableSubmit || false);
                            APP.addSpinGear($(checkoutSubmitBtn.clicked));
                        }

                        
                        //validate TBI promo code if provided - WEBAE3-4083
                        if ($(el.find('input[name="tbiPromo"]')).length !=0) {
                            if ($(el.find('input[name="tbiPromo"]')).val().length != 0) {
                                if ( isValidTBIPromo === false) {

                                    $(el.find('input[name="tbiPromo"]'))
                                                    .parent()
                                                    .removeClass("ui-state-valid")
                                                    .addClass("ui-state-invalid"); 
                                            el.guardian().$inputs.tbiPromo = false;
                                            $("#tbi_promo_error").show();

                                }
                            }
                        }

                        $dfd.done(function () {
                            //console.log(['Deferred object done: addInput = ',addInput]);
                            _.extend(el.guardian().$inputs, addInput);
                            //console.log(['Inputs checked',el.guardian().$inputs]);
                            APP.props.checkoutPassedAjax = !_.contains(_.values(el.guardian().$inputs), false);
                            //console.log(APP.props.checkoutPassedAjax);


                            if (el.guardian().$inputs.email === false) {
                                $(el.find('input[name="email"]'))
                                    .parent()
                                    .removeClass("ui-state-valid")
                                    .addClass("ui-state-invalid");
                            }
                            if (el.guardian().$inputs.cardnumber === false) {
                                $(el.find('input[name="cardnumber"]'))
                                    .parent()
                                    .removeClass("ui-state-valid")
                                    .addClass("ui-state-invalid");
                            }                      

                            el.find('button[type="submit"]').prop("disabled", APP.props.checkoutPassedAjax);
                            
                            if (APP.props.checkoutPassedAjax) {

                                //WEBAE3-4058 use device.js instead of CF
                                if(device && device.type == 'tablet'){
                                    $('input#deviceGroup').val('WT');// Pass new voucher type to XBE through hidden field
                                } else if(device && device.type == 'mobile'){
                                    $('input#deviceGroup').val('WP');// Pass new voucher type to XBE through hidden field
                                }
                                
                                el.addClass("ae-checkout--bypassAjax").submit();
                            } else {
                                $(".ui-state-invalid")
                                    .first()
                                    .find("input")
                                    .focus();
                                APP.removeSpinGear(el.find('button[type="submit"]'));
                            }
						});
                       //validate cardnumber if provided
                        if ($(el.find('input[name="cardnumber"]')).length !=0) {
                            if ($(el.find('input[name="cardnumber"]')).val().length != 0) {
                                addInput = {
                                    "cardnumber": APP.validateCreditCard($(el.find('input[name="cardnumber"]')).val())
                                };
                            }
                        }
                        
                        $dfd.resolve();

                        
                        /* ajax call deprecated - WEBAE3-1204
                        $.ajax({
                                url: "/plugins/ae3/lib/BookingAjax.cfc",
                                type: 'POST',
                                dataType: "json",
                                data: el.serialize()
                            })
                            .done(function(data) {
                                // console.log(data);
                                // console.log(el);
                                addInput = data;
                                $dfd.resolve();
                            })
                            .fail(function() {
                                 console.log('Validate Checkout Fail');
                                $dfd.resolve();
                            });
                          */
                    },
                    validateAccountLogin: function (el, disableSubmit) {
                        APP.props.loginInputValid = true;
                        el.find('button[type="submit"]').prop("disabled", disableSubmit || false);
                    	//but if username isn't an email or password is blank, send ajax call to get appropriate return message for display SL
                        //Do not need password field validated on login by Guardian SL
                        //but if username isn't an email or password is blank, don't send Ajax call
                        // if (el.guardian().$inputs.member_username === false || el.guardian().$inputs.member_password === false) {
                        //    APP.props.loginInputValid = false;
                        // }

                         if (APP.props.loginInputValid) {
                            //passed client side checks so fire login call
                            $.ajax({
                                type: "POST",
                                url: '/plugins/ae3/lib/Member3.cfc',
                                data: {
                                    method: 'isValidLogin',
                                    email: $('#account_login_form').find('input[name="member_username"]').val(),
                                    password: $('#account_login_form').find('input[name="member_password"]').val()
                                },
                                dataType: 'json',
                                success: function (result) {

                                    AE.account.setHTML('member-response-right', '');
                                    AE.account.hideGridDiv('account_login_form','member-response-right');

                                    if (result.RESULT) {
                                        AE.account.handleSalesforceLogin(); 
                                        //WEBAE3-2170 - update search form age on log-in if user didn't change age on initial search
                                        if (result.AGE != '') {
                                           APP.handleLoginAge(result.AGE)
                                        }
                                        APP.props.loginInputValid = true;

                                        
                                        if(typeof result.showSubscribe != "undefined" && result.showSubscribe == true
                                            && (window.location.pathname !== '/checkout/' && window.location.pathname !== '/payment/')
                                         ){ //WEBAE3-6285 trigger New Modal to spawn when unsubscribed user logs in except the following pages
                                            localStorage.setItem("aeShowSubscribe", true);//notsignedup 
                                        }


                                        if (AEdata && AEdata.booking && AEdata.booking.state && AEdata.booking.state.step) {
                                            if (AEdata.booking.state.step == 'bookform') {
                                                var $oStored =  JSON.parse(localStorage.getItem('aeSearch'));
                                                if($oStored && $oStored.searchAgeCheckbox && $oStored.searchAge == 40) {
                                                    //WEBAE3-5069 update setItem to include updated search object
                                                    $oStored['showFillAgeCheckout'] = false;
                                                    localStorage.setItem('aeSearch',JSON.stringify($oStored));
                                                }                                          
                                            }
                                            // Entering this requote block on /confirmation/ will send the user to a quote expired page
                                            if (
                                                    window.location.pathname !== '/confirmation/' && 
                                                    AEdata.booking.quote && 
                                                    AEdata.booking.quote.oQuote && 
                                                    ( 
                                                        $('html').hasClass('ua-ios') || 
                                                        (AEdata.booking.quote.oQuote.oRules && AEdata.booking.quote.oQuote.oRules.applyMemberDU)
                                                    )
                                                ){
												// WEBAE3-1669 - always generate a new quote to get member discount
                                                AE.ui.search.autocomplete.setFromQuote({
                                                    loggedInAt:AEdata.booking.state.step,
                                                    searchAge: result.AGE
                                                });
                                                AE.ui.search.formSubmit(true);
                                            } else if (AE.props.useWEBAE3_4453 && window.location.pathname === '/confirmation/') {
                                                // WEBAE3-4453 Logging in on /confirmation/ sends user to member dashboard
                                                window.location.href = '/member-accounts/';
                                            } else if (window.location.pathname === '/results/') {
                                                //WEBAE3-5167 need to resubmit search form to get fresh human sec signals
                                                //otherwise user gets blocked for re-using signals on a generic reload
                                                //WEBAE3-5607 - don't need to worry about human sec signals but this fixes age bug now, too
                                                //so it stays
                                                var $oStored =  JSON.parse(localStorage.getItem('aeSearch'));
                                                var tmpAge = 40;
                                                if( $oStored && !$oStored.searchAgeCheckbox ) {
                                                    tmpAge = $oStored.searchAge;
                                                }else{
                                                    tmpAge = result.AGE;
                                                }
                                                AE.ui.search.autocomplete.setFromQuote({
                                                    loggedInAt:AEdata.booking.state.step,
                                                    searchAge: tmpAge
                                                });
                                                AE.ui.search.formSubmit(true);                                               

                                            } else {
												// Don't trigger login requote for sites that don't offer Member Discount WEBAE3-3230
                                                window.location.reload();//keep user on page they logged in on WEBAE3-1662
                                            }
                                        } else {
                                            if (AE.props.useWEBAE3_4453) {
                                                // WEBAE3-4453 Redirect to /member-accounts/ on login but only if:
                                                // 1. No password change is required
                                                // 2. No active quote in context except /confirmation/ (handled above)
                                                window.location.href = '/member-accounts/';
                                            } else {
                                                window.location.reload();//keep user on page they logged in on WEBAE3-1662  
                                            }
                                        }
                                    } else {
                                        if (result.CHANGEPASSWORD ) {
                                            APP.handleLoginChangePassword(result.MESS, result.UID);
                                            APP.removeSpinGear($('#account_login_button'));
                                            AE.ui.enableClicks();
                                            el.find('button[type="submit"]').prop("disabled",false);
                                        } else {
                                       		APP.props.loginInputValid = false;
                                        	AE.account.showEle('forgotPasswordContainer');
                                            if ($("#member-response-left").html() != result.MESS) { 
                                                AE.account.setHTML('member-response-left', result.MESS);
                                                AE.account.showGridDiv('member-response-left', '');
                                            }
                                        }

                                        APP.removeSpinGear($('#account_login_form').find('button[type="submit"]'));
                                        AE.ui.enableClicks();
                                        el.find('button[type="submit"]').prop("disabled",false);
                                    }
                                },
                                error: function(result) {
                                    console.log('Error Hit');
                                    APP.props.loginInputValid = false;
                                    handleAjaxLoginFail();
                                }
                            });
                        } else {
                            $(".ui-state-invalid")
                                .first()
                                .find("input")
                                .focus();
                            $('#account_login_form')
                                .find('button[type="submit"]')
                                .prop("disabled", false);
                        }
                        function handleAjaxLoginFail() {
                            //console.log('ajaxFails');
                            $('#account_login_form')
                                .find('input[name="member_username"]')
                                .parent()
                                .removeClass("ui-state-valid")
                                .addClass("ui-state-invalid");
                            $('#account_login_form')
                                .find('input[name="member_password"]')
                                .parent().removeClass("ui-state-valid")
                                .addClass("ui-state-invalid");
                            $(".ui-state-invalid")
                                .first()
                                .find("input")
                                .focus();
                            $('#account_login_form')
                                .find('button[type="submit"]')
                                .prop("disabled", false);
                            APP.removeSpinGear($('#account_login_form').find('button[type="submit"]'));
                        }
                    },
                    failure: function () {
                        // Form Failed JS Validation
                        $(".ui-state-invalid")
                            .first()
                            .find("input")
                            .focus();
                        // alert(JSON.stringify(this.$inputs));	// Used for IE8 testing
                        if (this.$el[0].id === "ae-checkout") {
                            this.validateCheckout($(this.$el[0]), false);
                        }
                        if (this.$el[0].id === "frEmailMod") {
                            $("#btEmailModSubmit").prop("disabled", false);
                        }
                        if (this.$el[0].id === "frSimpleMod") {
                            event.preventDefault();
                            $("#btSimpleModSubmit").prop("disabled", false);
                            return true;
                        }
                        if (this.$el[0].id === "frConvert") {
                            event.preventDefault();
                            $("#btConvertSubmit").prop("disabled", false);
                            return true;
                        }
                        if (this.$el[0].id === "frElecPayment") {
                            APP.removeSpinGear($('#btElecPaymentSubmit'));
                            event.preventDefault();
                            $("#btElecPaymentSubmit").prop("disabled", false);
                            return true;
                        }
                        if (this.$el[0].id === "frCancel") {
                            $("#btCancel").prop("disabled", false);
                        }
                        if (this.$el[0].id === "account_login_form") {
                            this.validateAccountLogin($(this.$el[0]), true);// console.log(this.$el);

                            //$("#account_login_button").prop("disabled", false);
                        }
                        return false;
                    },
                    success: function () {
                        if (AE.props.siteCode === 'FCR' && this.$el.find("fcr--btn-anim")) {
                            AE.ui.disableClicks();
                            APP.addSpinGear(this.$el.find("button.fcr--btn-anim"));

                            //WEBAE3-4362 make sure checkout doubleclicks don't fire two voucher requests
                            if(this.$el[0].id === "fcr-checkout"  && !$(this.$el[0]).hasClass("ae-checkout--bypassAjax")){
                                this.validateCheckout($(this.$el[0]), true);
                                return false;
                            } else {
                                return true;
                            }
                        }
                        if (this.$el.hasClass("frmVoucherLookup") ||  this.$el.is("#account_lookup_form") || this.$el.is("#frSimpleMod") || this.$el.is("#frConvert") || this.$el.is("#frElecPayment") || this.$el.is("#customerForm")) {
                            AE.ui.disableClicks();
                            APP.addSpinGear(this.$el.find("button.btn--primary"));
                            return true;
                        }
                        if (this.$el[0].id === "account_login_form") {
                             AE.ui.disableClicks();
                            APP.addSpinGear($(this.$el[0]).find('button[type="submit"]'));
                            this.validateAccountLogin($(this.$el[0]), true);
                            //AE.account.loginUser();
                            return true;
                        }
                        if (this.$el[0].id === "ae-checkout" && !$(this.$el[0]).hasClass("ae-checkout--bypassAjax")) {
                            //WEBAE3-3718 - only add spin gear to button clicked if more than one
                            if(typeof checkoutSubmitBtn !== 'undefined') {
                                //APP.addSpinGear($(this.$el[0]).find('button[type="submit"]'));
                                APP.addSpinGear($(checkoutSubmitBtn.clicked));//WEBAE3-3718 checkoutSubmitBtn defined in AE.booking.js> BOOKFORM section
                            }
                            this.validateCheckout($(this.$el[0]), true);
                            return false;
                        }
                        if (this.$el[0].id === "frEmailMod") {
                            //console.log('frEmailMod submitted');
                            $("#btEmailModSubmit").prop("disabled", true);
                            return true;
                        }
                        if (this.$el[0].id === "frSimpleMod") {
                            //console.log('frSimpleMod submitted');
                            $("#btSimpleModSubmit").prop("disabled", true);
                            return true;
                        }
                        if (this.$el[0].id === "frConvert") {
                            //console.log('frSimpleMod submitted');
                            $("#btConvertSubmit").prop("disabled", true);
                            return true;
                        }
                        if (this.$el[0].id === "frElecPayment") {
                            //console.log('frSimpleMod submitted');
                            $("#btElecPaymentSubmit").prop("disabled", true);
                            return true;
                        }
                        if (this.$el[0].id === "frCancel") {
                            //console.log('frCancel submitted');
                            $("#btCancel").prop("disabled", true);
                            return true;
                        }
                        //NOTE this condition must be last because else statement will apply to all other requests except those above
                        if (this.$el[0].id === "autosurvey") {
                            var $button = $("#autosurvey button.btn--primary").prop("disabled", true);
                            AE.ui.disableClicks();
                            APP.addSpinGear($button);
                            return true;
                        } else {
                            return true;
                        }
                    }
                });
            });
        },
        // Luhn algorithm to match checksum on cardnumber
        validateCreditCard: function (value) {
            // accept only digits, dashes or spaces
            if (/[^0-9-\s]+/.test(value)) return false;
            
            // Use Luhn Algorithm
            var nCheck = 0,
                nDigit = 0,
                bEven = false;
            value = value.replace(/\D/g, "");

            for (var n = value.length - 1; n >= 0; n--) {
                var cDigit = value.charAt(n),
                    nDigit = parseInt(cDigit, 10);

                if (bEven) {
                    if ((nDigit *= 2) > 9) nDigit -= 9;
                }

                nCheck += nDigit;
                bEven = !bEven;
            }
            return (nCheck % 10) == 0;
        },
        // Handle Label and hide/show for State/Province dropdown
        stateMenus: function (selector) {
            // Handles hiding and showing State select menus based on Country selection for old markup generated by request.objCommon.PopulateStateDropdownDropkick() function
            //console.log('LEGACY State Menu Update calling call ' + selector);
        },
        // Voucher Lookup Toggle and display
        handleVoucherLookup: function ($target) {
            if ($target.hasClass("voucherLookupInputToggle")) {
                var $vNumDiv = $("form.frmVoucherLookup div#voucherNumberInput");
                var $vEmailDateDiv = $("form.frmVoucherLookup div#voucherEmailDateInput");
                var $vInputToggleIcon = $("form.frmVoucherLookup label.voucherLookupInputToggle i.fa.voucherLookupInputToggle");

                if ($vNumDiv.hasClass("trulyhidden")) {
                    $vInputToggleIcon
                        .addClass("fa-check-circle")
                        .removeClass("fa-circle");
                    $vNumDiv
                        .removeClass("trulyhidden")
                        .find("input")
                        .prop("required", true);
                    $vEmailDateDiv
                        .addClass("trulyhidden")
                        .find("input")
                        .prop("required", false)
                        .val("");
                } else if ($vEmailDateDiv.hasClass("trulyhidden")) {
                    $vInputToggleIcon
                        .addClass("fa-circle")
                        .removeClass("fa-check-circle");
                    $vEmailDateDiv
                        .removeClass("trulyhidden")
                        .find("input")
                        .prop("required", true);
                    $vNumDiv
                        .addClass("trulyhidden")
                        .find("input")
                        .prop("required", false)
                        .val("");
                }
            }
        },
        // Cleanup email of common errors
        emailClean: function (inputID) {
            // Correct a number of common typos that will always yeild an invalid email address
            var bDebug = false; // Controls whether or not to throw custom errors
            var cleanEmail = $.trim($(inputID).val()); // Start with trimmed raw input value
            if (bDebug) throw "Email Cleanup Step 0: " + $(inputID).val();
            if (bDebug) throw "Email Cleanup Step 1: " + cleanEmail;
            cleanEmail = cleanEmail.split("..").join(".");
            if (bDebug) throw "Email Cleanup Step 2: " + cleanEmail;
            var atPos = cleanEmail.search("@");
            while (cleanEmail.substring(atPos - 1, atPos) == "." || cleanEmail.substring(atPos + 1, atPos + 2) == ".") {
                cleanEmail = cleanEmail.replace(/\.@/g, "@"); // Remove period from position directly before @
                if (bDebug) throw "Email Cleanup Step 3: " + cleanEmail;
                cleanEmail = cleanEmail.replace(/@\./g, "@"); // Remove period from position directly after @
                if (bDebug) throw "Email Cleanup Step 4: " + cleanEmail;
                atPos = cleanEmail.search("@");
            }
            while (cleanEmail.substring(0, 1) == ".") {
                // Remove periods from first position of string
                cleanEmail = cleanEmail.substring(1);
                if (bDebug) throw "Email Cleanup Step 5: " + cleanEmail;
            }
            while (cleanEmail.substring(cleanEmail.length - 1, cleanEmail.length) == ".") {
                // Remove periods from last position of string
                cleanEmail = cleanEmail.substring(0, cleanEmail.length - 1);
                if (bDebug) throw "Email Cleanup Step 6: " + cleanEmail;
            }
            $(inputID).val(cleanEmail); // Replace input value with cleaned string
        },
        // Removes whitespace in voucher number
        cleanWhitespace: function (event, targetID) {
            /* Simari - 01/30/18 - https://autoeurope.jira.com/browse/WEBAE3-886 */
            // var input = document.getElementsByName(targetName)[0];
            var input = document.getElementById(targetID);
            var val = input.value.replace(/\s+/g, "");
            input.value = val;
        },
        // Replace Double Quotes in an Input With Single Quotes to protect XML
        quoteSwap: function (inputID) {
            $(inputID).val($(inputID)
                .val()
                .replace(/"/g, "''"));
        },
        // Apply Spinning Gear Markup to Submit Buttons
        addSpinGear: function ($button) {
            $button = $button || [];

            if ($button[0] && !$($button).hasClass('ui--btn-submit-wait')){
                $button
                    .addClass("ui--btn-submit-wait")
                    .append(APP.props.$spinGear.clone().hide())
                    .ready(function () {
                        $button.find(".ui--loading-results").fadeIn();
                    });
            }
        },
        removeSpinGear: function ($button) {
            $button = $button || [];
            if ($button[0]) {
                $button
                    .removeClass("ui--btn-submit-wait")
                    .find("i.ui--loading-results")
                    .remove();
            }
        },
        // WEBAE3-7185 handle tp signup radio buttons
        tpFormRadioHandler: function (targetID, targetName) {
            var targetClass = '';
            switch (targetName) {
                case 'agencyType':
                    targetClass = '.agency-type-extra';
                    break;
                case 'commPayType':
                    targetClass = '.comm-pay-type-extra';
                    break;
                case 'existingAccount':
                    targetClass = '.other-accounts';
                    break;
            }
            if(targetClass !== ''){
                var $target = $(targetClass);
                var $textInputs = $target.find('input[type="text"]');

                // hide all related extra data items, clear them and set to not required
                // also remove ui-state-valid, ui-state-invalid from text input divs
                $textInputs.closest('div').removeClass('ui-state-valid ui-state-invalid');
                $target.hide();
                $textInputs.val('').prop('required', false);

                // remove required class from all agency-type-extra labels
                $target.find('div').removeClass('required');

                // show the inputs associated with the selected radio and set to required
                var $container = $target.filter('[data-for="' + targetID + '"]');
                $container.show();
                $container.find('div[data-label="' + targetID + '"]').addClass('required');
                $container.find('input[data-input="' + targetID + '"]').prop('required', true);
            }
        },

        // Body Click Watch Tasks
        onBodyClick: function (event, $target) {
            // Toggle Age Info dropdown (search form)
            if (_.contains(APP.props.$ageInfoBtn, $target[0])) {
                // (APP.props.$ageInfoText).show();
                return $target.siblings(APP.props.$ageInfoText).toggleClass("display-inline");
            } else if (!APP.props.$ageInfoText.is($target[0]) && APP.props.$ageInfoText.hasClass("display-inline")){
                // (APP.props.$ageInfoText).hide();
               return APP.props.$ageInfoText.removeClass("display-inline");
            }

            // Modal/dropdown Close Buttons
            if (_.contains(APP.props.$modalCloseBtn, $target[0])) {
                if ($target.attr('data-modal-target') == '.age-info-text') {
                    return APP.props.$ageInfoText.toggleClass("display-inline");
                }
                return $($target.attr('data-modal-target')).toggleClass('visuallyhidden');
            }

            APP.handleVoucherLookup($target);

            if ($target.hasClass("btnGoodDates")){
                _.each($('form.frmGoodDates input.datePickerInput'),function(thisInput){
                    var ogDate = $(thisInput).datepicker('getDate');
                    $(thisInput).val($.datepicker.formatDate("mm-dd-yy", $(thisInput).datepicker('getDate')));
                    $(thisInput).datepicker('setDate', ogDate);
                });
                return true;
            }

            if ($target.hasClass("btn--anim")) {
                APP.addSpinGear($target);
            }

            if ($target.is("button#frChangeCar") || $target.is("#frCancel #btCancel")) {
                APP.addSpinGear($target);
                return true;
            }
        },
        // Body Change Watch Tasks
        onBodyChange: function (event, $target) {
            targetID = event.target.id;
            targetTag = event.target.tagName.toUpperCase();
            targetType = event.target.type.toUpperCase();
            targetName = event.target.name;

            switch (targetTag) {
                case "INPUT":
                    targetID = targetID === "" ? "input[name='" + event.target.name + "']" : "#" + targetID;

                    // if (targetID === "#member_age" || (typeof $target.data("pattern") === "ae_memberage" && $target
                    // Added regex for age validation in guardian (our reqs) Cgoodwin requested to make this a drop-down - WEBAE3-989- 02/21/18 - SIMARI
                    //         .data("pattern")
                    //         .toUpperCase() === "NUMBER")) {
                    //     APP.validateAge(event, targetName);
                    // }

                    // targetID = (targetID === "#vouchnum-lookup") ? event.target.name : targetID;
                    if ((targetName === "vouchnum" || targetName === "vouchernum") || (typeof $target.data("pattern") === "ae_voucher" && $target.data("pattern").toUpperCase() === "TEXT")) {
                        APP.cleanWhitespace(event, targetID.replace('#', ''));
                    }

                    if (targetType === "EMAIL" || (typeof $target.data("pattern") === "string" && $target
                            .data("pattern")
                            .toUpperCase() === "EMAIL")) {
                        APP.emailClean(targetID);
                    }
                    if ($target.hasClass("trg__quoteSwap")) {
                        APP.quoteSwap(targetID);
                    }

                    //WEBAE3-7185 - handle agency type options, 
                    //targetName in func determines what happens, if anyting
                    if(targetType === 'RADIO'){
                        APP.tpFormRadioHandler(event.target.id,targetName);
                    }
                    break;
                case "SELECT":
                    if (targetID.toUpperCase() === "COUNTRY" && $("form .state-select .stateList").length) {
                        APP.stateMenus();
                    } // Legacy
                    if ($target.closest("form").hasClass("validate")) {
                        $target
                            .parent()
                            .removeClass("ui-state-invalid")
                            .removeClass("ui-state-valid");
                    }
                    break;
                case "TEXTAREA":
                    if ($target.hasClass("trg__quoteSwap")) {
                        targetID = targetID === "" ? "textarea[name='" + event.target.name + "']" : "#" + targetID;

                        APP.quoteSwap(targetID);
                    }
                    break;
            }
        },
        postAutoForm: function () {
            if (APP.props.$autoForms[0]) setTimeout(function () {
                if (APP.props.$autoForms.first().attr('id') == 'loadQuote') {
                    /*WEBAE3-5291 change URL for search wait page in  history
                    so if user goes back to search wait via back button, the
                    URL in the address bar will be for the home page. This was to 
                    prevent user from reposting Human Security signals and
                    getting flagged as a bot if they hit refresh on search wait
                    
                    WEBAE3-5607 - leaving this in place even though we're no
                    longer using original HumanSecurity */
                    var histUrl = (document.referrer) ? document.referrer : oSite.sslDomain;
                    APP.props.$autoForms.first().submit();
                    //replace state after submit works properly, before submit not so much
                    window.history.replaceState({}, document.title, histUrl);
                } else {
                    APP.props.$autoForms.first().submit();
                }
            }, 1000);
        },
        handleLoginChangePassword:function(resultMess, uuid) {
            APP.props.loginInputValid = false;
            var resetForm = $('[data-formType="resetPasswordFormForce"]'); 

            if (APP.props.$isInMemberAccount) {
				APP.removeSpinGear($('#account_login_form').find('button[type="submit"]'));
				$("input.uid_reset").val(uuid);

				AE.account.showGridDivByClass('member_reset_password','member_email');
				AE.account.showGridDivByClass('member_reset_password','current_password');
				AE.account.hideGridDivByClass('member_reset_password','memberPasswordChecklist');
				AE.account.hideEle('forgotPasswordContainer');
				AE.account.showEle('resetPasswordContainer');
	
				if (!AE.account.isTwoCol()) {
					AE.account.setHTML('member-response-right', resultMess);
					AE.account.showGridDiv('member-response-right', '');
				} else {
					AE.account.setHTML('member-response-left', resultMess);
					AE.account.showGridDiv('member-response-left', ''); 
				}
				
				$('form#member_reset_password').find('input[name="resetType"]').val('force');
            } else {
                $("div#memberPasswordResetNav").removeClass('visuallyhidden');
                $("div#memberloginNav").addClass('visuallyhidden');
                AE.account.setHTML('resetMessNav', resultMess);
                AE.account.showGridDiv('resetMessNav', '');   
                APP.removeSpinGear($('#account_login_form').find('button[type="submit"]'));
                $("input.uid_reset").val(uuid);
            }
          
            $("div.login_container").addClass('visuallyhidden--palm visuallyhidden--lap');
        },
        handleLoginAge:function(age) {
			/*  Per WEBAE3-2170 and WEBAE3-1686, we want to update search age to member age 
			in search form and local storage but only if they haven't manually entered an age
			prior to logging in
			*/
			var updateSearchFormAge = false;
			var inModifyProcess = false;
			// Don't run any checks if we're in modify process
			if  (
                typeof (AEdata.booking) !== 'undefined' && 
				typeof (AEdata.booking.props) !== 'undefined' &&
				typeof (AEdata.booking.props.ismodify) !== 'undefined'
                ){
    				inModifyProcess = AEdata.booking.props.ismodify;
			}

			if (!inModifyProcess) {
				// set update flag based on AEdata info
				if  (
                        typeof (AEdata.booking) !== 'undefined' && 
                        typeof (AEdata.booking.quote) !== 'undefined' && 
                        typeof (AEdata.booking.oQuote) !== 'undefined' && 
                        typeof (AEdata.booking.oQuote.searchAgeCheckbox) !== 'undefined'
                    ){
                        if (AEdata.booking.quote.oQuote.searchAgeCheckbox) {
                            updateSearchFormAge = true;
                        }
                }
   			}

			// check for local storage and update/set flag if needed
            // === Added for WEBAE3-4756 === //
            if (AE.props.siteCode != 'PEU') {
                if  (
                        AE.ui.search.useStoredSearch() && 
                        localStorage.getItem('aeSearch') && 
                        _.isString(localStorage.getItem('aeSearch')) && 
                        localStorage.getItem('aeSearch') != ''
                    ) {
                        var oStoredSearch = JSON.parse(localStorage.getItem('aeSearch'));
                        //local storage exists so check whether to update it
                        if (oStoredSearch.searchAgeCheckbox && oStoredSearch.searchAge) {
                            if (oStoredSearch.searchAge != age){

                            }else{
                                oStoredSearch.searchAge = age;
                                updateSearchFormAge = true;
                                //updating local storage, so update form
                                var _obj = JSON.stringify(oStoredSearch);
                                localStorage.setItem('aeSearch', _obj);
                            }
                            
                        }
                }

                if (updateSearchFormAge) {
                    AE.ui.search.setAge(age);//only run this once  
                    AE.ui.search.setDefaultAgeOverride(age); 
                    AE.ui.search.init();
                }
            }
		},
        setBillingInputRequiredStatus:function(inputs,status) {
            //WEBAE3-4052: on status turns on required, off status turns off required
            for(i=0; i < inputs.length; ++i) {
                if(status == 'on') {
                    $('#'+inputs[i]).attr('required','required');
                    if(inputs[i] == 'state'){
                        //state parent/parent needs required class added too
                        $('#'+inputs[i])
                                    .parent()
                                    .parent()
                                    .addClass("required");
                        $('#'+inputs[i])
                                    .parent()
                                    .parent()
                                    .removeClass("ui-state-valid ui-state-invalid");
                    } else {
                        // only parent for others
                        $('#'+inputs[i])
                                    .parent()
                                    .addClass("required");
                        $('#'+inputs[i])
                                    .parent()
                                    .removeClass("ui-state-valid ui-state-invalid");
                    }
                } else if(status == 'off') {
                    $('#'+inputs[i]).removeAttr('required');
                    if(inputs[i] == 'state'){
                        //state parent/parent needs required class removed too
                        $('#'+inputs[i])
                                    .parent()
                                    .parent()
                                    .removeClass("required");
                        $('#'+inputs[i])
                                    .parent()
                                    .parent()
                                    .removeClass("ui-state-valid ui-state-invalid");
                    } else {
                            // only parent for others
                            $('#'+inputs[i])
                                    .parent()
                                    .removeClass("required");
                            $('#'+inputs[i])
                                    .parent()
                                    .removeClass("ui-state-valid ui-state-invalid");
                    }
                }
            }

        },
        formFineUploaderInstance: function(formfield, moduleFolder, itemlimit) {
            // Initialize fineUploader JS on file input - WEBAE3-4369
			var fineUploaderFolder = "/plugins/ae3/modules/"+moduleFolder+"/fine_uploader";
            var $form_submit_btn    = $('input#'+formfield).closest('form').find('#form_submit');
            
            uploadlimit = itemlimit ? itemlimit : 1;
            
			var galleryUploader = new qq.FineUploader({
				//debug: true,
				multiple: false,
				element: document.getElementById("upload_block-"+formfield),
				template: 'qq-simple-thumbnails-template',
				request: {
					endpoint: '/plugins/ae3/modules/'+moduleFolder+'/image-uploader.cfc?method=uploadSingleFile'
				},
				retry: {
					enableAuto: true
				},
				thumbnails: {
					placeholders: {
						//waitingPath: fineUploaderFolder+'/placeholders/waiting-generic.png',
						waitingPath: fineUploaderFolder+'/processing.gif',
						notAvailablePath: fineUploaderFolder+'/placeholders/not_available-generic.png'
					}
				},
				validation: {
					itemLimit: uploadlimit
				},
				callbacks: {
					onUpload: function(id, name) {
						$form_submit_btn.addClass('off');
					},
					onComplete: function(id, name, responseJSON) {
						if (responseJSON.success) {
							$('input#'+formfield).val(responseJSON.server_filename);
							$('#upload_block-'+formfield+' .qq-upload-button').hide();
							$('#upload_block-'+formfield+' .qq-upload-remove-button').show();
							$form_submit_btn.removeClass('off');
						}
					}
					//onError: function(id, name, errorReason) {
					//},
				}
			});
		}
    };

    return APP;
})();
;
var AE = AE || {};
/*Currently only targetting IE and augmenting Array.prototype functions as necessary.*/
AE.legacy = AE.legacy || ( function () {
	/*DEPENDENCIES: Calls AE.legacy.polyfill */
	'use strict';
	var POS = {
		init: function () {
			POS.grief = {
				isIE: $( 'html' ).is( '.ua-ie' ),
				whichIE: {
					isIE7: $( 'html' ).is( '.ua-ie-7, .ua-ie-7-0' ),
					isIE8: $( 'html' ).is( '.ua-ie-8, .ua-ie-8-0' ),
					isIE9: $( 'html' ).is( '.ua-ie-9, .ua-ie-9-0' ),
					isIE10: $( 'html' ).is( '.ua-ie-10, .ua-ie-10-0' ),
					isIE11: $( 'html' ).is( '.ua-ie-11, .ua-ie-11-0' )
				},
				isLegacy: POS._isLegacyBrowser,
				versionOfBrowser: POS._getLegacyBrowserVersion
			};
			/* POS.getLegacyBrowserVersion() references the grief object, so this can't just be tossed into grief. */
			/* Checks if browser is on our list of [POS.grief.whichIE] - will return true if any condition (property) is met.*/
			// var legacyBrowser = POS.grief.isLegacy();
			/* Returns a string from the getter [POS.getLegacyBrowserVersion]*/
			// var browserVersion = POS.grief.versionOfBrowser();
		},
		_isLegacyBrowser: function () {
			var i = 0,
				_ops = POS.grief.whichIE;

			for ( i in _ops ) {
				var _isLegacy = _isLegacy = _ops[ i ];
				if ( _isLegacy ) {
					return _isLegacy;
				}
			}
			return false;
		},
		_getLegacyBrowserVersion: function () {
			var _legacyBrowser = {
					IE7: 'isIE7',
					IE8: 'isIE8',
					IE9: 'isIE9',
					IE10: 'isIE10',
					IE11: 'isIE11'
				},
				_browserIsIE = POS.grief.isIE,
				_isLegacy = POS._isLegacyBrowser(),
				_ops = POS.grief.whichIE,
				_currentVersion;

			if ( _isLegacy ) {
				for ( var i in _legacyBrowser ) {
					var _browser = _legacyBrowser[ i ];
					if ( _ops[ _browser ] ) {
						_currentVersion = _browser;
					}
				}
			}
			return _currentVersion;
		}
   };
	return POS;
} )();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
/*  A series of shims for IE*/

AE.legacy.polyfill = AE.legacy.polyfill || ( function () {
	/*DEPENDENCIES: AE.legacy*/
	'use strict';
	var POS = {
		init: function () {
			POS.grief = {
				arrayEvery: POS.polyfill._augmentArrayPrototypeEvery,
				arrayFilter: POS.polyfill._augmentArrayPrototypeFilter,
				arrayForEach: POS.polyfill._augmentArrayPrototypeForEach,
				arrayIndexOf: POS.polyfill._augmentArrayPrototypeIndexOf,
				arrayMap: POS.polyfill._augmentArrayPrototypeMap,
				objectKeys: POS.polyfill._augmentObjectKeys,
				objectCreate: POS.polyfill._augmentObjectCreate,
				stringTrim: POS.polyfill._augmentStringTrim,
				textContent: POS.polyfill._augmentTextContent
			};
			/* Do various things that happen once upon init. */
			POS.polyfill.init();
		},
		polyfill: {
			init: function () {
				var _augmentBrowserFunction = POS.grief;
				var _availablePolyfills = {
					arrayEvery: !Array.prototype.every,
					arrayFilter: !Array.prototype.filter,
					arrayForEach: !Array.prototype.forEach,
					arrayIndexOf: !Array.prototype.indexOf,
					arrayMap: !Array.prototype.map,
					objectKeys: !Object.keys,
					objectCreate: ( typeof Object.create != 'function' ),
					stringTrim: !String.prototype.trim,
					textContent: ( Object.defineProperty && Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor( Element.prototype, "textContent" ) && !Object.getOwnPropertyDescriptor( Element.prototype, "textContent" ).get )
				};

				for ( var i in _augmentBrowserFunction ) {
					var _polyfillBroswerCapabilities = _availablePolyfills[ i ] ? _augmentBrowserFunction[ i ]() : void( 0 );
				}
				return false;
			},

			_augmentArrayPrototypeEvery: function () {
				/*https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every*/
				return Array.prototype.every = function ( callbackfn, thisArg ) {
					var T, k;
					if ( this == null ) {
						throw new TypeError( 'this is null or not defined' );
					}
					var O = Object( this );
					var len = O.length >>> 0;
					if ( typeof callbackfn !== 'function' ) {
						throw new TypeError();
					}
					if ( arguments.length > 1 ) {
						T = thisArg;
					}
					k = 0;
					while ( k < len ) {
						var kValue;
						if ( k in O ) {
							kValue = O[ k ];
							var testResult = callbackfn.call( T, kValue, k, O );
							if ( !testResult ) {
								return false;
							}
						}
						k++;
					}
					return true;
				};
			},

			_augmentArrayPrototypeFilter: function () {
				//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
				return Array.prototype.filter = function ( fun ) {
					if ( this === void 0 || this === null ) {
						throw new TypeError();
					}
					var t = Object( this );
					var len = t.length >>> 0;
					if ( typeof fun !== 'function' ) {
						throw new TypeError();
					}
					var res = [];
					var thisArg = arguments.length >= 2 ? arguments[ 1 ] : void 0;
					for ( var i = 0; i < len; i++ ) {
						if ( i in t ) {
							var val = t[ i ];
							if ( fun.call( thisArg, val, i, t ) ) {
								res.push( val );
							}
						}
					}
					return res;
				};
			},

			_augmentArrayPrototypeForEach: function () {
				/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach */
				return Array.prototype.forEach = function ( callback, thisArg ) {
					var T, k;
					var O = Object( this );
					var len = O.length >>> 0;

					if ( this === null ) throw new TypeError( ' this is null or not defined' );
					if ( typeof callback !== "function" ) throw new TypeError( callback + ' is not a function' );
					if ( arguments.length > 1 ) T = thisArg;

					k = 0;
					while ( k < len ) {
						var kValue;
						if ( k in O ) {
							kValue = O[ k ];
							callback.call( T, kValue, k, O );
						}
						k++;
					}
				};
			},

			_augmentArrayPrototypeIndexOf: function () {
				/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility*/
				return Array.prototype.indexOf = function ( searchElement, fromIndex ) {
					var k;
					if ( this == null ) {
						throw new TypeError( '"this" is null or not defined' );
					}
					var o = Object( this );
					var len = o.length >>> 0;
					if ( len === 0 ) {
						return -1;
					}
					var n = +fromIndex || 0;
					if ( Math.abs( n ) === Infinity ) {
						n = 0;
					}
					if ( n >= len ) {
						return -1;
					}
					k = Math.max( n >= 0 ? n : len - Math.abs( n ), 0 );
					while ( k < len ) {
						if ( k in o && o[ k ] === searchElement ) {
							return k;
						}
						k++;
					}
					return -1;
				};
			},

			_augmentArrayPrototypeMap: function () {
				/*https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map*/
				return Array.prototype.map = function ( callback, thisArg ) {
					var T, A, k;
					var O = Object( this );
					var len = O.length >>> 0;

					if ( this == null ) throw new TypeError( ' this is null or not defined' );
					if ( typeof callback !== 'function' ) throw new TypeError( callback + ' is not a function' );
					if ( arguments.length > 1 ) T = thisArg;

					A = new Array( len );
					k = 0;
					while ( k < len ) {
						var kValue, mappedValue;
						if ( k in O ) {
							kValue = O[ k ];
							mappedValue = callback.call( T, kValue, k, O );
							A[ k ] = mappedValue;
						}
						k++;
					}
					return A;
				};
			},

			_augmentObjectCreate: function () {
				/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create */
				return Object.create = ( function ( undefined ) {
					var Temp = function () {};
					return function ( prototype, propertiesObject ) {
						if ( prototype !== Object( prototype ) && prototype !== null ) {
							throw TypeError( 'Argument must be an object, or null' );
						}
						Temp.prototype = prototype || {};
						var result = new Temp();
						Temp.prototype = null;
						if ( propertiesObject !== undefined ) {
							Object.defineProperties( result, propertiesObject );
						}

						if ( prototype === null ) {
							result.__proto__ = null;
						}
						return result;
					};
				} )();
			},

			_augmentObjectKeys: function () {
				/* From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys*/
				return Object.keys = ( function () {
					var hasOwnProperty = Object.prototype.hasOwnProperty,
						hasDontEnumBug = !( {
							toString: null
						} )
						.propertyIsEnumerable( 'toString' ),
						dontEnums = [
								'toString',
								'toLocaleString',
								'valueOf',
								'hasOwnProperty',
								'isPrototypeOf',
								'propertyIsEnumerable',
								'constructor'
							  ],
						dontEnumsLength = dontEnums.length;
					return function ( obj ) {
						if ( typeof obj !== 'object' && ( typeof obj !== 'function' || obj === null ) ) {
							throw new TypeError( 'Object.keys called on non-object' );
						}
						var result = [],
							prop, i;
						for ( prop in obj ) {
							if ( hasOwnProperty.call( obj, prop ) ) {
								result.push( prop );
							}
						}
						if ( hasDontEnumBug ) {
							for ( i = 0; i < dontEnumsLength; i++ ) {
								if ( hasOwnProperty.call( obj, dontEnums[ i ] ) ) {
									result.push( dontEnums[ i ] );
								}
							}
						}
						return result;
					};
				}() );
			},
			_augmentStringTrim: function () {
				/*https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim*/
				return String.prototype.trim = function () {
					return this.replace( /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '' );
				};
			},

			_augmentTextContent: function () {
				/*https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent*/
				( function () {
					var innerText = Object.getOwnPropertyDescriptor( Element.prototype, "innerText" );
					Object.defineProperty( Element.prototype, "textContent", {
						get: function () {
							return innerText.get.call( this );
						},
						set: function ( s ) {
							return innerText.set.call( this, s );
						}
					} );
				} )();
			}
		}
   };
	return POS.init();
} )();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
The AE.mura object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.mura object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.mura = AE.mura || (function(){
	/*
	DEPENDENCIES: AE
	*/
	var APP = {
		init:function() {
			// MURA Form Post-Processing Hook
			mura.DisplayObject.Form.reopen({
				onAfterRender:function(){ APP.asyncFormsRendered(); }//,
				//onSubmit:function(){ return APP.validateAll(); }
			});
		},
		asyncFormsRendered:function(){
			var frm_selector = 'form.mura-form';
			var $forms = $(frm_selector);
			var $inputs = $(frm_selector+' input,'+frm_selector+' textarea');
			var $requiredInputs = $(frm_selector+' div.mura-control-group.req input,'+frm_selector+' div.mura-control-group.req textarea');
			var $checksAndRadios = $inputs.filter('input[type="radio"],input[type="checkbox"]');
			var $requiredCheckboxes = $(frm_selector+' div.mura-control-group.requiredCheckbox input[type="checkbox"]');
			var $submits = $(frm_selector+' button.form-submit');
			var $stateDropdowns = $(frm_selector+' select.state--select');
			var $countryDropdowns = $(frm_selector+' select.country--select');
			var $motorHomeCountryDropdowns = $(frm_selector+' select.motorhome__select--country');
			var $motorHomeCityDropdowns = $(frm_selector+' select.motorhome__select--city');
			var $chauffeurCountryDropdowns = $(frm_selector+' select.chauffeur__select--country');
			var $chauffeurCityDropdowns = $(frm_selector+' select.chauffeur__select--city');
			$(frm_selector+' select').wrap('<div class="styled--select"></div>');

			// Process Input Data Attributes
			$.each($inputs,function(j) {
				if (typeof this['title'] == 'string') {
					// Collect the data attribute string from MURA input title
					var rawDataAttr = this['title'].match(/--.*--/);
					if (rawDataAttr !== null) {
						// If true, rawDataAttr[0] WILL exist and be a string per match() docs
						var theseDataAttr = rawDataAttr[0].replace(/--/g,'').split(';');
						
						// Remove data attribute string from MURA input title
						this['title'] = $.trim(this['title'].replace(rawDataAttr[0],''));
						for (var dtat=0;dtat<theseDataAttr.length;dtat++) {
							var thisAttr = theseDataAttr[dtat].split('=');
							if (thisAttr.length > 1) {
								$(this).attr('data-'+thisAttr[0],thisAttr[1]);
							}
						}
					}
				}
			});

			// Switch type of inputs with class passwordInput to password
			$($inputs.filter('.passwordInput')).attr('type','password');

			// Actually add the required Attribute to MURA required fields
			$requiredInputs.prop('required',true);

			// Give Required Checkboxes the terms_conditions class to trigger AE checkbox validation
			$requiredCheckboxes.addClass('terms_conditions').prop('required',true);
			
			// Fix Radio and Checkbox Markup
			$.each($checksAndRadios,function(i) {
				var this_selector = '#'+this['id'];
				var this_label = this.closest('label');
				
				// Move Input elements to correct position relative to labels in DOM
				$(this_selector).insertBefore(this_label);
				
				// Make jQueryUI before elements on radio/checkbox labels clickable
				if (this['type'] == 'radio') {
					$(this_label).on('click', function() {
						if (!$(this_selector).prop('checked')) {
							$($(this).siblings('input[type="radio"]')).prop('checked',false);
							$(this_selector).prop('checked',true);
						}
					});
				} else {
					$(this_label).on('click', function() {
						$(this_selector).prop('checked',!$(this_selector).prop('checked'));
					});
				}
			});
			
			// Initialize Radio Groups - First Button Selected By Default
			$.each($('.mura-radio-group'),function(k) {
				$($(this).children('input[type="radio"]')[0]).prop('checked',true);
			});

			// Country/State Dropdown Special Handling
			if ($stateDropdowns.length) {
				$.each($stateDropdowns.children('option'),function(l) {
					// replace entities like &amp; with ASCII characters
					$(this).html($.parseHTML($(this).text())[0]);

					var rawCountryClass = $(this).val().match(/.*__/);
					if (rawCountryClass !== null) {
						// Remove Country Codes from Dropdown values, make them classes
						$(this).addClass(rawCountryClass[0]+'state').val($.trim($(this).val().replace(rawCountryClass[0],'')));
					}
				});
				$stateDropdowns.addClass('state_dd_hide');
				$($stateDropdowns.parents('div.mura-control-group')).addClass('state_dd_hide');
				$($countryDropdowns.children('option[value='+AE.props.countryCode+']')).prop('selected',true);// Default country DD to current site
				AE.forms.handleStateMenus($stateDropdowns.closest('form.mura-form'));
			}
			
			// Motorhome City Dropdown Special Handling
			if ($motorHomeCityDropdowns.length) {
				$.each($motorHomeCityDropdowns.children('option'),function(l) {
					// replace entities like &amp; with ASCII characters
					$(this).html($.parseHTML($(this).text())[0]);

					var rawCountryClass = $(this).val().match(/.*__/);
					if (rawCountryClass !== null) {
						// Remove Country Codes from Dropdown values, make them classes
						$(this).addClass(rawCountryClass[0]+'city').val($.trim($(this).val().replace(rawCountryClass[0],'')));
					}
				});

				// Default country DD to current site
				$($motorHomeCountryDropdowns.children('option[value='+AE.props.countryCode+']')).prop('selected',true);
				
				AE.forms.handleMotorHomeCityMenus($motorHomeCityDropdowns.closest('form.mura-form'));
			}
			
			// Chauffeur City Dropdown Special Handling
			if ($chauffeurCityDropdowns.length) {
				$.each($chauffeurCityDropdowns.children('option'),function(l) {
					// replace entities like &amp; with ASCII characters
					$(this).html($.parseHTML($(this).text())[0]);

					var rawCountryClass = $(this).val().match(/.*__/);
					if (rawCountryClass !== null) {
						// Remove Country Codes from Dropdown values, make them classes
						$(this).addClass(rawCountryClass[0]+'city').val($.trim($(this).val().replace(rawCountryClass[0],'')));
					}
				});

				// Default country DD to current site
				$($chauffeurCountryDropdowns.children('option[value='+AE.props.countryCode+']')).prop('selected',true);

				AE.forms.handleChauffeurCityMenus($chauffeurCityDropdowns.closest('form.mura-form'));
			}
			
			// Apply Button Styles
			var arrBtns = ['primary', 'secondary', 'tertiary', 'modify'];
			$.each(arrBtns,function(){
				$(frm_selector+'btn--'+this+' button.form-submit').addClass('btn--'+this);
				$(frm_selector+'bk--'+this+' button.form-nav:first-of-type').addClass('btn--'+this);
				$(frm_selector+'nxt--'+this+' button.form-nav:last-of-type').addClass('btn--'+this);
				$(frm_selector+'nxt--'+this+' button.form-nav:only-of-type').addClass('btn--'+this);
			});

			/*$(frm_selector+' button.form-nav:not(:only-of-type):first-of-type').css('padding': '0.7em');
			$(frm_selector+' button.form-nav:not(:only-of-type):first-of-type:before').css(
				{'float':'left','margin-right':'0.7em','right':'0px','content':'\f053'}
			);*///Need Proper selector syntax for that NOT clause
			
			/* WEBAE3-3578 : 2020-04-20 : remove AE form validation styling from all Mura-built forms */
			// Finishing Touches
			//AE.ui.applyJQUI(frm_selector);
			//$forms.addClass('validate');
			//if (AE.forms) { AE.forms.applyGuardian($forms); }
		},
		validateAll:function(){
			var validInputs = false;
			
			// Run Validation
			if (false) {
				// All Inputs Pass Validation
				validInputs = true;
			}

			return validInputs;
		}
	}
	return APP;
})();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */


/*
The AE.mainnav object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.mainnav object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.nav = AE.nav || (function(){
	/*
	DEPENDENCIES: AE, AE.ui
	*/
	var APP = {
		init:function() {
			// Check for the existance of the variable jsloginStatus since it doesn't always exist
			if (typeof jsloginStatus != 'undefined') {
				var temp_loginStatus = jsloginStatus || window.jsloginStatus;
			} else {
				var temp_loginStatus = false;
			}
			
			APP.props = {
				$primnav 		: $('.primnav'),
				$primnavList	: $('#primnav--list'),
				$primnavTop 	: $('#primnav--list > li'),
				$primDropLinks	: $('#primnav--list > li > a'),
				$primDropDowns	: $('#primnav--list').find('.has-dropdown'),
				$primnavAcct 	: $('#primnav--acct'),
				$primnavMember 	: $('#primnav--acct .member_account'),
				$primnavModify 	: $('#primnav--acct .modify'),
				$primnavManage	: $('#navManageBooking'),
				
				$secnav 		: $('.secnav'),
				$altnavToggler 	: $('.altnav__toggler'),
				$altnavAcct 	: $('.altnav__account'),
				$altnavContact 	: $('.altnav__contact'),
				
				$altnav			: $('#altnav'),
				$altnavList		: $('.altnav__list'),
				$altDropDowns	: $('#altnav').find('.has-dropdown'),
				
				$selCountry		: $('#secnav__country .sel-country'),
				$countryDD		: $('.sitepicker'),
				$countryDDclose	: $('.sitepicker-close'),
				$selLanguage	: $('#secnav__country .sel-language'),
				$languageDD		: $('.langpicker'),
				$selCtryMobile	: $('#altnav .sitepicker-mobile'),
				$spContMobile	: $('#sitepicker-mobile'),
				$acctContDesk	: $('.account-signinform'),
				$acctContMobile	: $('#account-signinform-mobile'),
				$modContDesk	: $('.modify-signinform'),
				$modContMobile	: $('#modify-signinform-mobile'),
				$contactMobile	: $('.contact-mobile'),
				$memberLoginStatus: temp_loginStatus
			};

			APP.props.$memberLoginStatus = APP.props.$memberLoginStatus == 'true';

			var currentSize = AE.getSiteViewType();
			APP.props.$allDropDowns = APP.props.$primDropDowns.add( APP.props.$altDropDowns );
			APP.props.$allSubmenus = APP.props.$allDropDowns.find('.submenu-dropdown');
			
			/*
				Until we find a way to add this through Mura's nav display function (or some other method) we'll
				just add the chevrons and their containers to the dropdown items in our primary and alternate navs.
			*/
			APP.props.$primDropDowns.children('a').append('<div class="drop-toggler-container"><span class="drop-toggler"><i class="fa fa-chevron-down"></i></span></div>');
			APP.props.$altDropDowns.children('a').append('<div class="drop-toggler-container"><span class="drop-toggler"><i class="fa fa-chevron-circle-down fa-lg"></i></span></div>');
			
			AE.ui.addBodyClickTask({func: APP.onBodyClick});
			
			APP.props.$primDropDowns.on({
				'touchstart touchmove': function(event) {
					// Handle click...
					event.preventDefault();
				},
				'touchend': function(event) {
					// Handle click...
					event.preventDefault();
					if ( $('html').hasClass('ua-mobile') ) {
						event.preventDefault();

						if ( $(this).closest('li').hasClass('open') ) {
							window.location.href = $(this).attr('href');
						} else {
							APP.closeAllMenus();
							$(this).closest('li').addClass('open');
						}
					}
				}
			}, "a.parent-link");
			
			APP.props.$altnavList.on({
				'click': function(event) {
					var $target = $(this).closest('li');
					// Handle click event
					event.preventDefault();

					APP.toggleSubMenus($target);
				}
			}, ".drop-toggler");
			
			/* ALTNAV - Mobile and lap version of navigation */
			APP.props.$secnav.on('click', function(event){
				var $target = $(event.target);
				
				if ( $target.hasClass('altnav__toggler') ) { // NAVIGATION WINDOW - Mobile
					// Toggle View state of alt nav
					AE.ui.handleToggle( $target ); //, APP.props.$altnav
					
					// Close member form AND Close Contact info
					//if (APP.props.$acctContMobile.hasClass('open')) { APP.mobileAccountForm(); APP.props.$altnavAcct.removeClass('open'); }
					//if (!APP.props.$contactMobile.hasClass('visuallyhidden--palm')) { APP.props.$contactMobile.addClass('visuallyhidden--palm'); APP.props.$altnavContact.removeClass('open'); }
				}
			});
			
			var toggleClickEvent = function(event){
				//VM
				event.stopImmediatePropagation();
				//event.preventDefault();

				return $(this).click();
			}

			var toggleClassSwap = function(event){
				//VM
				event.stopImmediatePropagation();
				//event.preventDefault();
				return $(this).addClass('visuallyhidden');
			}

			if (APP.props.$memberLoginStatus) {
				APP.props.$primnavMember.find('.dropdown-toggle').on('mouseenter', toggleClickEvent);
				
				APP.props.$primnavMember.find('.menu-dropdown').on('mouseleave', toggleClassSwap);
			} else {
				APP.props.$primnavMember.find('.dropdown-toggle').off('mouseenter');
				
				APP.props.$primnavMember.find('.menu-dropdown').off('mouseleave');

				if (AE.props.useWEBAE3_4453) {
					// WEBAE3-4453 Remove drop down from manage MY booking
					APP.props.$primnavModify.find('.dropdown-toggle').removeClass('dropdown-toggle');
				}
			}
			
			/* RESERVATION LOOKUP WINDOW - Non Mobile
				mouse up as click seems to be to fast on the first hit and does not place the window correctly */
			APP.props.$primnavModify.find('.dropdown-toggle').on('click', function(event){
				event.preventDefault();
				
				APP.props.$primnavList.find('.has-dropdown').addClass('closed');
				APP.props.$acctContDesk.addClass('visuallyhidden');
				APP.props.$modContDesk.position({
					my: "right-12 top+2",
					at: "right bottom",
					of: $(event.target)
				}).toggleClass('visuallyhidden');
			});
			
			/* FLEX NAV HEIGHT ADJUST */
			if($('.flexNav')[0]){
				var flexNavHeight = $('img.site-logo').height();
				$('.flexNav').css('minHeight',(flexNavHeight+12)+'px');
			}

			/* SITE PICKER - Non Mobile */
			APP.props.$selCountry.on('click', function(event){
				var offsetLeft = 0, offsetTop = 0;
				APP.props.$altnav.slideUp();
				if ( AE.getSiteViewType() !== 'palm' ) {
					offsetLeft =  $(event.target).closest('.sel-country').offset().left;
					offsetTop =  $(event.target).closest('.sel-country').offset().top + 20;
				}
				
				$('.sitepicker').css({ left: offsetLeft, top: offsetTop });
				
				APP.props.$countryDD.toggle();
				if ( APP.props.$languageDD.is(':visible') ) {
					APP.props.$languageDD.hide();
				}

				setTimeout( function(){
					 APP.props.$altnav.addClass('visuallyhidden'); 
				}, 300);
				
			});
			
			/* SITE PICKER - Mobile */
			APP.props.$selCtryMobile.on('click', function(event){
				var $contentDesk = $('#sitepicker .sitepicker-container');
				var $contentMobile = $('#sitepicker-mobile .sitepicker-container');
				
				if ( !APP.props.$spContMobile.parent('has-dropdown').hasClass('open') ) {
					APP.props.$spContMobile.parent('has-dropdown').addClass('open');
					APP.props.$spContMobile.append($contentDesk);
				} else {
					APP.props.$spContMobile.parent('has-dropdown').removeClass('open');
				}
			});
			
			/*	SITE PICKER - Close */
			APP.props.$countryDDclose.on('click', function(event){
				APP.props.$countryDD.hide();
			});
			
			/* LANGUAGE PICKER */
			APP.props.$selLanguage.on('click', function(event){
				var $offset = $(event.target).closest('.sel-language').offset();
				var leftPos = $offset.left;
				//WEBAE3-3116 lang picker selector caret is on right for TP sites so position menu to right edge
				if (AE.props.bIsTpDomain) {
					var pickerNavWidth = $(event.target).closest('.sel-language').innerWidth();
					var pickerMenuWidth = $('#langpicker').innerWidth();
					var leftPos = $offset.left + (pickerNavWidth - pickerMenuWidth - 10);
				}
				$('.langpicker').css( { left: leftPos, top: ($offset.top + 30) } );
				APP.props.$languageDD.toggle();
				AE.ui.hide( APP.props.$allSubmenus );
				if ( APP.props.$countryDD.is(':visible') ) {
					APP.props.$countryDD.hide();
				}
			});
			
			AE.addResizeTask({
				func:function() {
					APP.manageResize();
				},
				args:[]
			});
			AE.addTransitionTask({
				func:function() {
					/* HANDLES CONTENT MOVED BY APPEND:
						ARGUMENTS: 'Palm View', 'Desk Container', 'Mobile Container', 'Content Appended' */
					APP.palmTransition(arguments[0], '.account-signinform', '#account-signinform-mobile', '.login-form');  // Member account login
					APP.palmTransition(arguments[0], '#sitepicker', '#sitepicker-mobile', '.sitepicker-container');  // Sitepicker list
				}
			});
		},
		palmTransition : function() {
			var palmContent = $('' + arguments[2] + ' ' + arguments[3] + '')[0];

			// Moves content back to original container if not in mobile view
			if ( !arguments[0] ) {
				$(''+ arguments[1] + '').append(palmContent);
			}

			// remove open states when switching to non mobile view
			if ( APP.currentSize !== 'palm' ) {
				APP.props.$acctContMobile.addClass('closed');
				APP.props.$spContMobile.parent().addClass('closed');
				APP.props.$altnavContact.addClass('closed');
				APP.props.$altnavAcct.addClass('closed');
				APP.props.$altnavToggler.addClass('closed');
			}
		},
		manageResize : function() {
			// Anything that this module may need to do upon resize.
			if ( APP.currentSize !== 'palm' && APP.currentSize !== 'lap' ) {
				AE.ui.hide( APP.props.$altnav );
				//AE.ui.hide( APP.props.$allSubmenus );
				APP.props.$altDropDowns.find('.submenu-dropdown').hide();
			}
			APP.props.$countryDD.hide();
			APP.props.$languageDD.hide();
			APP.props.$acctContDesk.add(APP.props.$modContDesk).addClass('visuallyhidden');

			//APP.props.$primnavTop.addClass('closed');
		},
		onBodyClick:function(event, $target){

			// WEBAE3-5460 on TP logout, clear aeSearch from local storage
			if($target.hasClass('tpLogout') || $($target.parent()).hasClass('tpLogout')){					
				localStorage.removeItem('aeSearch');		
			}

			if ($target.hasClass('my-account-dropdown')) {
				if (!APP.props.$memberLoginStatus) {
					event.preventDefault();
				}
			
				APP.props.$primnavTop.find('.has-dropdown').hide('closed');
				APP.props.$modContDesk.addClass('visuallyhidden');
				APP.props.$acctContDesk.position({
					my: "right-12 top+2",
					at: "right bottom",
					of: $(event.target)
				}).toggleClass('visuallyhidden');
			}

			if ( !$target.closest('ul').hasClass('primnav--list' ) ) {
				APP.props.$primnavList.find('li.open').removeClass('open');
			}

			// Close the "My Account" sign-in form modal when the user clicks on the x
			if($($target).data('modal-target') == '.account-signinform'){
				APP.props.$acctContDesk.removeClass('open').addClass('closed');
			}

			if($($target).data('modal-target') == '.modify-signinform'){
				APP.props.$modContDesk.removeClass('open').addClass('closed');
			}		
			
			// Close the "My Account" sign-in form modal when the user clicks anywhere on the page (outside of the modal)
			if ( ($(APP.props.$primnavMember[0]).has($target).length == 0) && (!$(APP.props.$acctContDesk[0]).hasClass('visuallyhidden')) ) {
				APP.props.$acctContDesk.addClass('visuallyhidden');
			}
			
			// Close the "Manage My Booking" modal when the user clicks anywhere on the page (outside of the modal)
			if ( ($(APP.props.$primnavModify[0]).has($target).length == 0) && (!$(APP.props.$modContDesk[0]).hasClass('visuallyhidden')) ) {
				// Only close the modal if the datepicker calendar is not open
				if ($('#ui-datepicker-div').is(':hidden')) {
					APP.props.$modContDesk.addClass('visuallyhidden');
				}
			}

			if($target.hasClass('trg__drop-toggler')) $target.find('.drop-toggler').click();
			
			if(!$target.closest("#sitepicker").length && !$target.closest(APP.props.$selCountry).length) {
				if($("#sitepicker").is(":visible")){
					$("#sitepicker").hide();
				}
			}
		},

		mobileAccountForm: function () {
			var $contentDesk = $('.account-signinform .login-form');
			var $contentMobile = $('#account-signinform-mobile .login-form');

			if (!APP.props.$acctContMobile.hasClass('open') ) {
				APP.props.$acctContMobile.addClass('open');
				APP.props.$acctContMobile.append($contentDesk);
			} else {
				APP.props.$acctContMobile.removeClass('open');
				$('#primnav--acct .account-signinform').append($contentMobile);
			}
		},
		handleNavDropdown: function(event) {
			/* 	Targets a link in the primary nav, which is inside an element with the "has-dropdown" class.
				Adds and removes the "visuallyhidden" class to avoid using display:none, thereby maintaining
				accessibility for screen readers.
				
				This will toggle the dropdown menu for the primary bar and the account menu on the right. */
			var $dropdown = $(event.target).closest('.has-dropdown');
			var $submenu = $dropdown.find('.menu-dropdown');
			
			if ( $submenu.hasClass('visuallyhidden') ) {
				AE.ui.hide( APP.props.$allSubmenus );
				AE.ui.show( $submenu );
				//$submenu.removeClass('visuallyhidden');
			} else {
				//AE.ui.hide( $submenu );
				$submenu.addClass('visuallyhidden');
			}
			APP.props.$countryDD.hide();
			APP.props.$languageDD.hide();
		},
		closeAllMenus: function(event) {
			APP.props.$primDropDowns.removeClass('open').addClass('closed');
			APP.props.$altDropDowns.removeClass('open').addClass('closed');
			//APP.props.$countryDD.hide();
			//APP.props.$languageDD.hide();
		},
		toggleSubMenus: function (target) {
			var $submenu = target.find('.submenu-dropdown');
			if ( $submenu.is(':visible') ) {
				target.find('.drop-toggler > i').removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
				$submenu.slideUp();
			} else {
				target.find('.drop-toggler > i').removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up');
				$submenu.slideDown();
			}
		}

	}
	return APP;
})();
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods 
for use by other modules while protecting some variables in a closure. If the object is already 
defined then it's not altered. This prevents us from running the entire function each time one of its 
internal methods are called.
*/
AE.newsletter = AE.newsletter || (function(){
	/*
	DEPENDENCIES: AE
	*/

	var APP = {
		init:function() {
			APP.props = {};
			AE.ui.addBodyClickTask({func: APP.onBodyClick});
		},
		footerSubscribe:function($target) {
			var fromPromo = ($target.hasClass('promo'))? true : false;
			var $input = (fromPromo)? $('#newsletter__footer--input--promo') : $('#newsletter__footer--input');
			var inputContainerSelector = (fromPromo)? '#newsletter__footer--container--promo' : '#newsletter__footer--container';
			$(inputContainerSelector).removeClass('ui-state-invalid');
			if(AE.forms){ AE.forms.emailClean($input); }
			$input.addClass('trulyhidden');
			$target.addClass('trulyhidden');
			AE.ui.addSpinner(inputContainerSelector,{size:'2x',color:'black'});

			APP.genericSubscribe($target,$input,inputContainerSelector);
		},
		diagSubscribe:function($target) {
			var $input = $('#newsletter__diag--input');
			var inputContainerSelector = '#newsletter__diag--container';
			$(inputContainerSelector).removeClass('ui-state-invalid');
			if(AE.forms){ AE.forms.emailClean($input); }
			$input.addClass('trulyhidden');
			$target.addClass('trulyhidden');
			AE.ui.addSpinner(inputContainerSelector,{size:'2x',color:'black'});

			APP.genericSubscribe($target,$input,inputContainerSelector);
		},
		genericSubscribe:function($target,$input,inputContainerSelector){
			$.ajax({
				url:'/plugins/ae3/lib/BookingAjax.cfc',
				dataType:'json',
				data:{
					method 			: 'emailQuoteNewsletterSignup',
					email 			: $input.val(),
					subsource 		: 'FTR'
				}
			}).done(function(data){
				AE.ui.removeSpinner(inputContainerSelector);
				if(!data.SUCCESS){
					$(inputContainerSelector).addClass('ui-state-invalid');
					$target.removeClass('trulyhidden');
					$input.removeClass('trulyhidden').val('').attr('placeholder',data.MSG);
				} else {
					$input.prop('disabled',true).removeClass('trulyhidden').val(data.MSG);
				}
			}).fail(function(){
				AE.ui.removeSpinner(inputContainerSelector);
				$(inputContainerSelector).addClass('ui-state-invalid');
				$target.removeClass('trulyhidden');
				$input.removeClass('trulyhidden').val('').attr('placeholder', AE.props.oLang.TXT_TRY_AGAIN);
			});
		},
		showSubscribePopup:function(){
			var aeSubTrg = 'aeShowSubscribe';
			var aeNLPopupID = 'newsletterPopupDiag';
			var aeShowSubscription =  localStorage.getItem(aeSubTrg);
			if(aeShowSubscription) {
				//console.log('showSubscription', localStorage.getItem(aeSubTrg));
				$.ajax({
					type: "GET",
					url: '/plugins/ae3/lib/newsletterpopup.cfc',
					data: {
						method: 'getModalContent'
					},
					success: function (result) {
						returned = JSON.parse(result);
						AE.ui.dialog.launch({
							id: aeNLPopupID,
							title: returned.title,
							content: returned.content,
							width: ( $( window ).width() > 400 ) ? 350 : '80%'
							,inline: true
						});
						AE.ui.dialog.update(true);
						localStorage.removeItem(aeSubTrg);
					},
					error: function(result) {
					}
				});
			}else{
				// console.log(localStorage.getItem(aeSubTrg));
				// console.log('nothing showSubscription');
			}
		},
		onBodyClick:function(event,$target){
			if($target.hasClass('newsletter__footer--button')) {
				APP.footerSubscribe($target);
			}
			if($target.hasClass('newsletter__diag--button')) {
				APP.diagSubscribe($target);
			}
		}
	}
	return APP;
})();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
/* GOOGLE CUSTOM DIMENSIONS */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods 
for use by other modules while protecting some variables in a closure. If the object is already 
defined then it's not altered. This prevents us from running the entire function each time one of its 
internal methods are called.
*/
AE.cd = AE.cd || (function(){
	/*
	DEPENDENCIES: 
	
	ESTABLISHED DIMENSIONS IN GOOGLE ANALYTICS
		dimension1		// Optimizely active? (Currently not used)
		dimension2		// Form Path Tracking
		dimension3		// User ID
		dimension4		// Number of Visits at Checkout
		dimension5		// Round Trip of One Way
		dimension6		// Pickup Location
		dimension7		// Drop off Location
		dimension8		// Search Locations
		dimension9		// Credit Card Used?
		dimension10		// Number of Matrix Interactions
		dimension11		// Affilate Name (Removed for lack of reliability)
		dimension12		// Dynamic Remarketing Item ID
		dimension13		// Dynamic Remarketing Item ID2
		dimension14		// Dynamic Remarketing Page Type
	*/

	var APP = {
		init:function() {
			APP.props = {
				$page_type 		: AECustomDimension.props.$page_type								// Set the funnel value as property
			};

			var Session_Cookie_Value = AECustomDimension.getCookieValue('SessionStarted');
			if (!Session_Cookie_Value){
				AECustomDimension.setCookieValue('SessionStarted', 'true', 0);

				var user_id = AECustomDimension.makeid();
				AECustomDimension.updateSingleValueCookie(AECustomDimension.props.$cn_user_id, AECustomDimension.props.$user_id, 365*10);
				// Start of Session
				AECustomDimension.incrementNumberOfVisits();
				if (AECustomDimension.props.$visitsIncreased) {
					AE.ga.gaArrayProcess([{GACATEGORY: 'NumberOfVisits', GAACTION: 'New Session', GALABEL: 'Increment Number Of Visits - '+AECustomDimension.props.$numVisits }]);
				}
			}
			
			// SET SEARCH CUSTOM DIMENSIONS
			// ============================
			
			// ROUND TRIP OR ONE WAY RENTAL
			if (typeof AECustomDimension.props.$direction !== 'undefined') {
				AE.ga.gaArrayProcess([{GACATEGORY: 'carSearch', GAACTION: 'direction', GALABEL: AECustomDimension.props.$direction }]);
			}

			// PICKUP COUNTRY CODE
			if (typeof AECustomDimension.props.$pickup !== 'undefined') {
				AE.ga.gaArrayProcess([{GACATEGORY: 'carSearch', GAACTION: 'pickup', GALABEL: AECustomDimension.props.$pickup }]);
			}

			// DROP OFF COUNTRY CODE
			if (typeof AECustomDimension.props.$dropoff !== 'undefined') {
				AE.ga.gaArrayProcess([{GACATEGORY: 'carSearch', GAACTION: 'dropoff', GALABEL: AECustomDimension.props.$dropoff }]);
			}

			// LOCATION TYPE
			if (typeof AECustomDimension.props.$loctype !== 'undefined') {
				AE.ga.gaArrayProcess([{GACATEGORY: 'carSearchLocType', GAACTION: 'locationType', GALABEL: AECustomDimension.props.$loctype }]);
			}


			// SET CUSTOM DIMENSIONS BY PAGE - NOT ALL STEPS HAVE TRACKING
			// ===========================================================
			
			// ROOT OR HOME
			if (APP.props.$page_type === "/"){ } 
			
			// SEARCH WAIT SCREEN
			else if ( APP.props.$page_type === "/search/" ) { } 
			
			// GET RATES MATRIX RESULTS
			else if ( APP.props.$page_type === "/results/" ) {

				var i = 0;
				i = AECustomDimension.zeroPad(i, 2);
				var getrates_Cookie_Value = AECustomDimension.getCurrentCookieValue('getrates_count');

				//Set get rates view count
				if(Session_Cookie_Value !== "") {
					getrates_Cookie_Value++;
					AECustomDimension.setCookieValue('getrates_count', getrates_Cookie_Value, 0);
				}

				//Add preceding zero to low value numbers
				getrates_Cookie_Value = AECustomDimension.zeroPad(getrates_Cookie_Value, 2);
				AECustomDimension.setDimension('dimension10',i+' Matrix Clicks');
				AE.ga.gaArrayProcess([{GACATEGORY: 'matrixClicksCount', GAACTION: 'Get Rates View - ' + getrates_Cookie_Value, GALABEL: i+' Matrix Clicks' }]);

				$('#matrix__wrapper').on('click', function(event){

					var $target = $(event.target),
						$targetLI = $target.closest('li');

					// Make sure that there's a list item, becaus the user could have clicked on empty space or something with no list item parent.
					var rate = ( $targetLI[0] && !$targetLI.hasClass('no-rate') ) ? true : false;

					if (rate) {
						var tempData = $targetLI.data() || {},cat = _.has(tempData,'category'),sup = _.has(tempData,'supplier');

						//Add preceding zero to low value numbers
						i++; i = AECustomDimension.zeroPad(i, 2);
						AECustomDimension.setDimension('dimension10',i+' Matrix Clicks');
						
						AE.ga.gaArrayProcess([{GACATEGORY: 'matrixClicksCount', GAACTION: 'Get Rates View - ' + getrates_Cookie_Value, GALABEL: i+' Matrix Clicks' }]);
					}
				});
			} 
			
			// INSURANCE UPGRADE AND OPTIONAL EQUIPTMENT
			else if ( APP.props.$page_type === "/options/" ) { } 
			
			// CAR CLASS UPGRADE
			else if ( APP.props.$page_type === "/upgrade/" ) { } 
			
			// CHECKOUT OR BOOKFORM
			else if ( APP.props.$page_type === "/checkout/" ) {

				//Build Credit Card Used Cookie
				AECustomDimension.updateSingleValueCookie(AECustomDimension.props.$cn_cc_used, 'no', 365);

				//If the credit card field is used, update a cookie
				$('#cardnumber').on('change', function(event){
					var value = $(this).val();
					if (value !== "") {
						AECustomDimension.updateSingleValueCookie(AECustomDimension.props.$cn_cc_used, 'yes', 365);
					} else {
						AECustomDimension.updateSingleValueCookie(AECustomDimension.props.$cn_cc_used, 'no', 365);
					}
				});
				AE.ga.gaArrayProcess([{GACATEGORY: 'bookform field tracking', GAACTION: 'form load', GALABEL: '00 - Form Load', GAVALUE: 1}]);
			} 
			
			// CONFIRMATION OR MAKEBOOKING
			else if ( APP.props.$page_type === "/confirmation/" ) { 
				if (AECustomDimension.props.$ccUsed) {
					AE.ga.gaArrayProcess([{GACATEGORY: AECustomDimension.props.$cn_cc_used, GAACTION: AECustomDimension.props.$cn_cc_used, GALABEL: AECustomDimension.props.$ccValue }]);
				}
			}
		}
	}
	return APP;
})();
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/* GOOGLE ANALYTICS SCRIPTING */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.ga = AE.ga || (function(){
	/*
	DEPENDENCIES: AE



	GOOGLE ANALYTICS to define ga - The following is expected in the head:
	(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
		(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
		m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
		})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
		ga('create', '#variables.GoogleAccount#', 'auto');
		ga('create', 'UA-66348978-1', 'auto', {'name': 'master', 'allowLinker': true}); // master analytics account

	The data-gaarray attribute this code operatres on is expected to be a valid JSON array of structs, thus:
		[
			{'GACATEGORY':'required','GAACTION':'required','GALABEL':'optional','GAVALUE':[INTEGER ONLY (optional)],},
			{'GACATEGORY':'required','GAACTION':'required'},...
		]
	In ColdFusion, build an array of structs. The structs MUST include the Keys GACATEGORY AND GAACTION, at least,
	AND all key names must match the spec above. Then, prepare the CF array for extraction as JSON:
		gaArray = urlencodedFormat(serializeJSON(CFArray),'utf-8')
	*/
	var APP = {
		init:function() {
			/*	This is where we set variables and things that will only live inside the closure. */
			APP.props = {
				/* jQuery Collections of Objects with Our Google Analytics trigger classes	*/
				$gaClick 	: $('.trg__ga--Click'),/* Objects we want to report to Google Analytics when they are clicked
				Example: <button class="any others trg__ga--Click" data-gaarray="#gaArray#">...</button> */
				$gaAuto		: $('.trg__ga--Auto'),/* Objects we want to report to Google Analytics as soon as the page loads
				Example: <div class="any others trg__ga--Auto" data-gaarray="#gaArray#">...</div> */
				$gaChange 	: $('.trg__ga--Change'),		// change event used for selects
				$gaChild	: $('.trg__ga--Child'),			// child element where array is stored on parent usually multiple childs
				$gaCheck	: $('.trg__ga--Checkbox'),		// checkbox clicks used when need to know checked state
				$gaTime		: $('.trg__ga--Time')			// measure time on page but only on initial visit
			};

			// Adjusted Bounce for AUS and NZL sites
			if (AE.props.isAUNZ) {
				setTimeout(function(){
					APP.gaArrayProcess([{GACATEGORY: '15_seconds', GAACTION: 'read'}]);
				},15000);
			}

			// Page load auto events
			$.each(APP.props.$gaAuto,function(i){// Send data to Google Analytics from each object with trg-gaAuto class
				var gaArray = [];
				if(APP.props.$gaAuto[i].attributes['data-gaarray']){
					gaArray = JSON.parse(decodeURIComponent(APP.props.$gaAuto[i].attributes['data-gaarray'].value));
					APP.gaArrayProcess(gaArray);
				}
			});
			// Timer event
			$.each(APP.props.$gaTime,function(i){// Send data to Google Analytics from each object with trg--Time class
				APP.timeOnPage();
			});
			AE.ui.addBodyClickTask({func: APP.onBodyClick});
			AE.ui.addBodyChangeTask({func: APP.onBodyChange});
		},
		gaArrayProcess:function(gaArray){// Loop Through gaArray JSON object, tracking as you go
			if(gaArray !== null){
				$.each(gaArray,function(j){
					APP.gaLogEvent(gaArray[j].GACATEGORY, gaArray[j].GAACTION, gaArray[j].GALABEL, gaArray[j].GAVALUE);
					// if(typeof ga !== 'undefined') checks that the Google Analytics dependency has loaded
					if(typeof ga !== 'undefined') APP.gaTrackEvent(gaArray[j].GACATEGORY, gaArray[j].GAACTION, gaArray[j].GALABEL, gaArray[j].GAVALUE);
				});
			}
		},
		gaLogEvent:function(gaCategory, gaAction, gaLabel, gaValue) {// Write the Event Fields to the console for debugging
			// ga('send', 'event', {'eventCategory': '" + gaCategory + "','eventAction': '" + gaAction+ "','eventLabel': '" + gaLabel + "','eventValue': " + gaValue + "});
		},
		gaTrackEvent:function(gaCategory, gaAction, gaLabel, gaValue) {// Sends Data to Google Analytics
			//	NEW Tag Manager setup push variables to predefined GTM object
			//	Site Account: ga('send', 'event', Category, Action, Label, Value);
			aeDataLayer.push({
			  'event' : 'gaEvent',				// gaEvent is the custom trigger in GTM for an event Tag
			  'eventCategory' : gaCategory,		// Required - category
			  'eventAction' : gaAction,			// Required - action
			  'eventLabel' : gaLabel,			// Not Required - label
			  'eventValue' : gaValue			// Not Required - value NUMERIC
			});
			//	Master account handled in GTM
		},
		onBodyClick:function(event,$target){

			/*SITEPICKER TRACKING*/
			// if ( $target.hasClass('trg__ga--Click-inner') && typeof $target.parent().data('gaarray') !== 'undefined' ) {
			// 	var item  = ( $target.hasClass('matrix__cell') && $target.closest('li').hasClass('no-rate') ) ? false : true;
			// 	if (item) { APP.gaArrayProcess(JSON.parse(decodeURIComponent($target.parent().data('gaarray')))); }
			// }else
			if ( $target.hasClass('trg__ga--Click') && typeof $target.data('gaarray') !== 'undefined' ) {
				var item  = ( $target.hasClass('matrix__cell') && $target.closest('li').hasClass('no-rate') ) ? false : true;
				if (item) { APP.gaArrayProcess(JSON.parse(decodeURIComponent($target.data('gaarray')))); }
			}

			if ( $target.hasClass('trg__ga--Child') && typeof $target.parent().data('gaarray') !== 'undefined' ) {
				var gaObject = JSON.parse(decodeURIComponent($target.parent().data('gaarray')));

				if ($target.hasClass('dropdown-toggle')) {
					if ($target.parent().hasClass('open')) { APP.gaArrayProcess(gaObject); }
				} else {
					APP.gaArrayProcess(gaObject);
				}
			}
			if ( $target.hasClass('trg__ga--Nav') && typeof $target.data('gaarray') !== 'undefined' ) {
				var gaObject = JSON.parse(decodeURIComponent($target.data('gaarray')));

				if ($target.parent().hasClass('has-dropdown')) {
					if ($target.parent().hasClass('open')) { APP.gaArrayProcess(gaObject); }
				} else {
					APP.gaArrayProcess(gaObject);
				}
			}
			if ( $target.hasClass('trg__ga--Checkbox') && typeof $target.data('gaarray') !== 'undefined' ) {
				var gaObject = JSON.parse(decodeURIComponent($target.data('gaarray')));
				var cbStatus = ($target.is(':checked')) ? 'checked' : 'unchecked';		// set action
				// Limit injecting check status on case by case basis as placement can vary
				if( $target.hasClass('matrix_filter') || $target.hasClass('map_filter') ) {
					var addStatus = {'GAACTION' : cbStatus};								// extend and add to gaObject
					_.extend(gaObject[0], addStatus);
				}
				if( $target.hasClass('saveQuote-newsletter') ) {
					var addStatus = {'GALABEL' : cbStatus};									// extend and add to gaObject
					_.extend(gaObject[0], addStatus);
				}
				APP.gaArrayProcess(gaObject);
			}
		},
		onBodyChange:function(event,$target){

			if ( $target.hasClass('trg__ga--Change') && typeof $target.data('gaarray') !== 'undefined' ) {
				var gaObject = JSON.parse(decodeURIComponent($target.data('gaarray')));
				var selectVal = $target.val();
				if ( $target.hasClass('optionalEquip') ) {
                    gaObject[0].GALABEL += ' ' + selectVal;
				}
				APP.gaArrayProcess(gaObject);
			}
		},
		timeOnPage:function(){
			// Used in affiliate header to track visitors initial time on page
			if (document.referrer.split('/')[2] != document.location.hostname) { // Initial page visit only
				setTimeout(function() { // One second.
					APP.gaArrayProcess([{"GACATEGORY":"TimeOnPage","GAACTION":"1 sec"}]);
				}, 1000);
				setTimeout(function() { // Two seconds.
					APP.gaArrayProcess([{"GACATEGORY":"TimeOnPage","GAACTION":"2 sec"}]);
				}, 2000);
				setTimeout(function() { // Five seconds.
					APP.gaArrayProcess([{"GACATEGORY":"TimeOnPage","GAACTION":"5 sec"}]);
				}, 5000);
				setTimeout(function() { // Ten seconds.
					APP.gaArrayProcess([{"GACATEGORY":"TimeOnPage","GAACTION":"10 sec"}]);
				}, 10000);
				setTimeout(function() { // Twenty seconds.
					APP.gaArrayProcess([{"GACATEGORY":"TimeOnPage","GAACTION":"20 sec"}]);
				}, 20000);
				setTimeout(function() { // Thirty seconds.
					APP.gaArrayProcess([{"GACATEGORY":"TimeOnPage","GAACTION":"30 sec"}]);
				}, 30000);
				setTimeout(function() { // Sixty seconds.
					APP.gaArrayProcess([{"GACATEGORY":"TimeOnPage","GAACTION":"60 sec"}]);
				}, 60000);
			}
		}
	}
	return APP;
})();

;var AE = AE || {};

AE.utils = AE.utils || ( function () {
	/*
	DEPENDENCIES: Any other modules that this one will call.
	*/
	'use strict';
	var UI = {
		init: function () {
			// UI.props = {
			//   $myProp     : $('#someID'),
			//   $myOtherProp  : $('.someClass'),
			// };
		},
		_groupItemsByPropsInArray: function ( _array, f ) {
			/***
			 * Will document use later - simari
			 ***/
			var groups = {};
			_array.forEach( function ( o ) {
				var group = JSON.stringify( f( o ) );
				groups[ group ] = groups[ group ] || [];
				groups[ group ].push( o );
			} );
			return Object.keys( groups ).map( function ( group ) {
				return groups[ group ];
			} );
		},
		_findMatchingPropsInArray: function ( _array, checkProp ) {
			/***
			 * Will document use later - simari
			 ***/
			return _array.filter( function ( entry ) {
				return Object.keys( checkProp ).every( function ( key ) {
					return entry[ key ] === checkProp[ key ];
				} );
			} );
		},
		_deleteEmptyObjsByValFromArray: function ( _array, deleteValue ) {
			/***
			 * Will document use later - simari
			 ***/
			for ( var i = 0; i < _array.length; i++ ) {
				if ( _array[ i ] == deleteValue ) {
					_array.splice( i, 1 );
					i--;
				}
			}
			return _array;
		},
		_sortPropByAlphaInArray: function ( _array, sortProp ) {
			/***
			 * Will document use later - simari
			 ***/
			return _array.sort( function ( a, b ) {
				if ( a[ sortProp ] < b[ sortProp ] ) {
					return -1;
				}
				if ( a[ sortProp ] > b[ sortProp ] ) {
					return 1;
				}
				return 0;
			} );
		},
		_removeDuplicateObjectsFromArray: function ( _array, filterProp ) {
			/***
			 * Will document use later - simari
			 ***/
			var _tempArr = new Array();
			var _matchLocTitle = {};
			for ( var i in _array ) {
				( typeof _array[ i ] != 'function' ) ? _matchLocTitle[ _array[ i ][ filterProp ] ] = _array[ i ] : void(0);
			}
			for ( var i in _matchLocTitle ) {
				_tempArr.push( ( typeof _array[ i ] != 'function' ) ?  _matchLocTitle[ i ] : void(0));
			}
			return _tempArr;
		},
		_checkValueAlreadyExistsInArray: function ( _array, value ) {
			/***
			 * Will document use later - simari
			 ***/
			return _array.indexOf( value ) > -1;
			}
			// ,
			// manageResize : function() {
			//   /* Anything that this module may need to do upon resize. */
			// }
		};
		return UI;
	} )();

;
var AE = AE || {};
/*Specifically for Safari Private Browsing mode.*/
AE.privateBrowsing = AE.privateBrowsing || (function () {
    /*DEPENDENCIES: AE.js*/
    'use strict';




    var UI = {
        init: function () {

             var cookieCheck = AECookie.props.cookiesEnabled();

            UI.props = {
                _localStorage: '',
                _sessionStorage: '',
                checkCookies: cookieCheck,
                privateSessionPolyfill: UI._checkLocalStorageAvailability,
                usePolyfill: UI._localStoragePolyfill,
                requireCookieNotification: true,
                cookieNotificationShown: (cookieCheck && (AECookie != undefined && AECookie.read('cookieNotificationShown'))) ? true : false,
                userEngagedNotification: (cookieCheck && (AECookie != undefined && AECookie.read('userEngagedNotification'))) ? true : false,
                cookieExpires: 60,
                activeNotification: '',
                messaging: {
                    // defaultCookieMessage: AE.props.cookie_support.DEFAULT_COOKIE_USE,
                    defaultCookieMessage: AE.props.cookie_support.DEFAULT_FROM_AE2,
                    defaultCloseButton: AE.props.cookie_support.CLOSE_BUTTON,
                    noCookieSupportTitle: AE.props.cookie_support.WARNING_TITLE,
                    noCookieSupportMessage: AE.props.cookie_support.WARNING_TEXT,
                    moreInfoMessage: AE.props.cookie_support.INFO_LINK, // privacy text
                    moreInfoLink: location.origin + '/' + AE.props.cookie_support.INFO_LINK_URL, // link to privacy
                    confirmCookieSupportMessage: AE.props.cookie_support.DEFAULT_COOKIE_USE
                }
            };
            if ($('.whitelabel-if')[0]) {// WEBAE3-4006 Suppress cookie alert for iframes
                UI.props.cookieNotificationShown = true;
            }
            AE.ui.addBodyClickTask({
                func: UI.onBodyClick
            });

            /*
             * Pass: var $obj = {'title':…,'message':…}; into UI._tryLaunch();
             */
            UI.mainSearch();
        },
        mainSearch: function () {
            /* Check for cookie support before augmenting localStorage polyfill. */
            if (UI.props.checkCookies) {
                if (AE.props.bWhiteLabel || AE.props.bIsTpDomain) {//WEBAE3-2442 - no cookie notice on TP sites
                    UI.props.cookieNotificationShown = true;
                } else {
                    UI._cookiesEnabled();
                }
            } else {
                UI._cookiesDisabled();
            }
        },
        _cookiesEnabled: function () {
                UI._tryLaunch({
                    'title': '',
                    'message': UI.props.messaging.defaultCookieMessage
                });
                /* Cookies are enabled, check for localStorage support. Augment as necessary.*/
                return UI.props.privateSessionPolyfill() ? UI.props.usePolyfill() : false;
        },

        _cookiesDisabled: function () {
            UI._tryLaunch({
                    'title': UI.props.messaging.noCookieSupportTitle,
                    'message': UI.props.messaging.noCookieSupportMessage
                }, false);

                return false;
        },

        _tryLaunch: function (obj, cookieSupport) {
            var _title = obj.title || false;
            var _message = obj.message || false;
            var hasCookieSupport = cookieSupport || true;


           // WEBAE3-4907 -  Remove the setting of "cookieNotificationShown" & "userEngagedNotification" cookies
           /*
                if (!UI.props.cookieNotificationShown) {    //  || !UI.props.userEngagedNotification

                        if (!UI.props.cookieNotificationShown) {
                            UI.props.cookieNotificationShown = true;
                            AECookie.new({
                                name: 'cookieNotificationShown',
                                value: 'true',
                                encodeValue: 'true',
                                daysToLive: 0,
                                minutesToLive: UI.props.cookieExpires
                            });
                        }

                    // WEBAE3-4868 Remove existing cookie consent bar
                        UI._showCookieNotification({
                            'title': _title,
                            'message': _message
                        }, hasCookieSupport);
                    
                }
            */

        },
        _showCookieNotification: function (obj, cookieSupport) {
            
            var _title = obj.title || false;
            var _message = obj.message || false;


            var hasCookieSupport = cookieSupport || true;
            var $warningTitleHolder = '';
            var $warningTitle = '';
            var notificationHtml='';
            var $warningMessage = $('<p/>', {
                'html': _message
            });

            if (_title) {
                /*
                 * This is a default cookie notification with a title…
                 */
                $warningTitleHolder = $('<div/>', {
                    class: 'ui-cookie-support-wrap--inner ui-cookie-support-title'
                });
                $warningTitle = $('<h2/>', {
                    'html': _title
                });
            }else{
                $warningMessage.addClass('valign--middle');
            }

            var $cookieSupportNotificationWindow = $('<div/>', {
                id: 'ui-cookie-support-notification',
                role: 'alertdialog'
            });
            var $warningMsgWrapper = $('<div/>', {
                class: 'ui-cookie-support-message-wrap'
            });
            var $warningTitleHolder = $('<div/>', {
                class: 'ui-cookie-support-wrap--inner ui-cookie-support-title'
            });
            var $warningMessageHolder = $('<div/>', {
                class: 'ui-cookie-support-wrap--inner ui-cookie-support-message message-flex-start'
            });
            var _notificationRef = $cookieSupportNotificationWindow.attr('id');

            UI.props.activeNotification = _notificationRef;

        /*WEBAE3-4470
          1-  Replace "ok" button in current Cookie Notification with "Accept", "Decline" & "Customize 
          2- Settings" buttons
          3- When "customize Settings" button is clicked, launch new “Cookie Preference” modal
        */
// change to say accept 
            var $dismissNotificationBtn = $('<button/>', {
                class: 'ui-cookie-support-dismiss-button ui-cookie-support-dismiss-link ui-warn-flag-close-btn ui-top-notification-close-btn',
                html: UI.props.messaging.defaultCloseButton,
                for: UI.props.activeNotification
            });
//add decline btn need to fix border so it fits 
           var $dismissNotificationBtnDecline = $('<button/>', {
                class: 'ui-cookie-support-dismiss-button ui-cookie-support-dismiss-link ui-warn-flag-close-btn ui-top-notification-close-btn declineBtn',
                html: "decline"
                //for: UI.props.activeNotification
            });
            //customize btn
             var $dismissNotificationBtnCustSet = $('<button/>', {
                class: 'ui-cookie-support-dismiss-button ui-cookie-support-dismiss-link ui-warn-flag-close-btn ui-top-notification-close-btn custSetBtn',
                html: "customize Settings "
                //for: UI.props.activeNotification
            });






            if(_message == UI.props.messaging.defaultCookieMessage){
                notificationHtml = '';
            }else{
                notificationHtml = '<small><a class="ui-cookie-support-dismiss-link" for="' + UI.props.activeNotification + '" href="' + UI.props.messaging.moreInfoLink + '"> ' + UI.props.messaging.moreInfoMessage + '</a></small>';
            }

            var $moreInfoLink = $('<span/>', {
                'html': notificationHtml
            });

            var $btnWrap = $('<div/>', {
                'class': 'message-flex-end'
            });

            var $moreInfoWrapper = $('<div/>', {
                'class': 'more-info-wrapper'
            });

            $warningTitleHolder.append($warningTitle);
            $btnWrap.append($dismissNotificationBtn);
//4470 add new btn to container 
            $btnWrap.append($dismissNotificationBtnDecline);
            $btnWrap.append($dismissNotificationBtnCustSet);
//          

            $warningMsgWrapper.append($warningTitleHolder, $moreInfoWrapper
                              .append($warningMessageHolder
                              .append($warningMessage, $moreInfoLink), $btnWrap));

            if (!_title) {
                
                $warningTitleHolder.remove();
            }
            $cookieSupportNotificationWindow.prepend($warningMsgWrapper);

            return (AE.props.$scrollContent.has('#' + UI.props.activeNotification).length == 0) ? UI._fn_launchNotification($dismissNotificationBtn, $cookieSupportNotificationWindow, hasCookieSupport) : false;
        },

        _hideCookieNotification: function (trigger, dialog) {

            var $trigger = trigger;
            var $notification = dialog;
            $trigger.addClass('ui-warn--out').removeClass('ui-warn--in');

            return $notification.slideUp('slow');
        },

        _fn_launchNotification: function (trigger, dialog, hasCookieSupport) {

            if (!hasCookieSupport) {
                AE.ga.gaArrayProcess([{
                    GACATEGORY: 'cookieSupport',
                    GAACTION: 'noCookieSupport',
                    GALABEL: 'noCookieSupportMessage'
                }]);
            }

            AE.props.$scrollContent.prepend(dialog.hide());

            return dialog.slideDown('slow');
        },

        _checkLocalStorageAvailability: function () {
            var _reqPolyfill;
            try {
                if (!window.localStorage || !window.sessionStorage) throw "exception";
                localStorage.setItem('storage_test', 1);
                localStorage.removeItem('storage_test');
                _reqPolyfill = false;
            } catch (e) {
                _reqPolyfill = true;
            }
            return _reqPolyfill;
        },

        _localStoragePolyfill: function () {
            /*HAD TO MOVE FUNCTION INTO AE.JS AS I'M CURRENTLY UNABLE TO OVERWRITE WINDOW.LOCALSTORAGE FROM THIS MODULE, WILL INVESTIGATE FURTHER*/
            return AE._augmentPrivateBrowsingLocalStorage();
        },
        onBodyClick: function (event, target) {

            var $target = $(target);
            var shouldCloseNotification = $target.hasClass('ui-cookie-support-dismiss-link');
            var $notification = $('#' + $target.attr('for'));
            var isCloseBtn = $target.hasClass('ui-cookie-support-dismiss-button');
            var $getCloseBtn = isCloseBtn ? $target : $notification.find('.ui-cookie-support-dismiss-button');


//WEBAE-4470
//var testcontent = AEdata.booking.quote.oLang.CANCELINS_MODAL;   
//this is for local testing puposes for demo and placement 
var ModalTextTest ="<h4>Privacy Preference Center</h4><p>In order for websites to provide relevant information to its visitors, and cater their experience, websites may store and retrieve data from your web browser. This action is done in the form of cookies. Cookies are generally installed on your browser to be used by the same website at a later date to enhance your overall experience. Cookies may contain information about you, your device, your technical hardware, your preferences, and any other relevant information that will help in providing visitors with a more personalized visit. <br/><br/>The use of cookies is optional, and as Auto Europe takes privacy seriously, we provide you with an option not to use these during your visit. You can pick and choose what cookie types to accept and reject â€“ however, by restricting some cookies, we may not be able to provide you with the full website experience, offer certain services and can even stop the website from working properly. Following is a more in-depth explanation of the cookies we use on our site.</p> <a href='/privacy#agb8'>[More Information]</a><p></p>";
// mocked up here  
/*var accordion ="<div class='AccContainer'> <div class='openShut'> <div class='plus-minus'></div><h4>Header 1 </h4> </div><div class='Acontent'> <div> this is content 1 </div></div></div><div class='AccContainer'> <div class='openShut'> <div class='plus-minus'></div><h4>Header 2 </h4> </div><div class='Acontent'> <div class='inline-block pos-l'> this is content 3 </div><div class='inline-block pos-r'> <label class='switch'> <input type='checkbox'> <span class='slider round'></span> </label> </div></div></div><div class='AccContainer'> <div class='openShut'> <div class='plus-minus'></div><h4>Header 3 </h4> </div><div class='Acontent'> <div class='inline-block pos-l'> this is content 3 </div><div class='inline-block pos-r'> <label class='switch'> <input type='checkbox'> <span class='slider round'></span> </label> </div></div></div><div class='AccContainer'> <div class='openShut'> <div class='plus-minus'></div><h4>Header 4 </h4> </div><div class='Acontent'> <div class='inline-block pos-l'> this is content 4 </div><div class='inline-block pos-r'> <label class='switch'> <input type='checkbox'> <span class='slider round'></span> </label> </div></div></div>" ;

*/

var accordion="<div class='AccContainer'><div class='openShut'><div class='pos-l'><div class='plus-minus'></div><h4>Functional cookies </h4></div><div class='pos-r allways_txt'>Always Active</div></div><div class='Acontent'><div>this is content 1 </div></div></div><div class='AccContainer'><div class='openShut'><div class='pos-l'><div class='plus-minus'></div><h4>Analytical cookies </h4></div><div class='pos-r w_switch'><label class='switch'> <input type='checkbox'> <span class='slider round'></span></label></div></div><div class='Acontent'><div>this is content 1 </div></div></div><div class='AccContainer'><div class='openShut'><div class='pos-l'><div class='plus-minus'></div><h4>Marketing cookies </h4></div><div class='pos-r w_switch'><label class='switch'> <input type='checkbox'> <span class='slider round'></span></label></div></div><div class='Acontent'><div>this is content 1 </div></div></div>"
//

          //this is behaving wonky

//var openFirst =false;
            //$(".Acontent").hide();
            /*if(openFirst){
                 $(".Acontent").first().show();
                $(".plus-minus").first().addClass("minus");
                        }*/
        
            $('.openShut').click(function(){
               // $(this).children('.plus-minus').toggleClass('minus');
                
                if($(this).next().is(':visible')){
                    $(this).next().hide();
                    $(this).parent().removeClass('AccContainerActive');

                }else{
                    $(this).next().show();
                    $(this).parent().addClass('AccContainerActive');
                }
            });

//to do: see if all UI elements shown in description exist or I need to create them 
//does decline have any functionality 
//display these button in line with eachother not stacked 
   if($target.hasClass('custSetBtn')){
  
      AE.ui.dialog.launch("#save-quote", { content:"" } );
      AE.ui.dialog.addContent( ModalTextTest + accordion );
     }
//

//// function for ok/accept btn-------
            if (shouldCloseNotification) {
//console.log("shouldCloseNotification");
                // WEBAE3-4907 -  Remove the setting of "cookieNotificationShown" & "userEngagedNotification" cookies
                /*
                if (!UI.props.userEngagedNotification) {
                    UI.props.userEngagedNotification = true;
                    AECookie.new({
                        name: 'userEngagedNotification',
                        value: 'true',
                        encodeValue: 'true',
                        daysToLive: 0,
                        minutesToLive: UI.props.cookieExpires
                    });
                }
                */

                if (isCloseBtn) {
                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                }

                return UI._hideCookieNotification($getCloseBtn, $notification);
            }///end function for ok/accept btn-----
        }
    };
    return UI;


})();
function initMap() {
 //console.log('Here')
   };

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
*/
AE.maps = AE.maps || (function(){
	/*
	DEPENDENCIES: AE, AE.ui
	*/
	var APP = {
		init:function() {
			APP.props = {
				$mapAPILoaded		: false,		// is Map API currently loaded
				$dfd_api			: $.Deferred(),	// Deferred API script
				$dfd_markers		: $.Deferred()	// Deferred Markers with labels script
			};

			// Map pins image locations should be moved to a global folder
			// probably need to refresh look after it's all working.
			APP.pin_image = {
				D: {//city
					icon: AE.props.muraThemePath+'/images/map/city_green.png',
					none: AE.props.muraThemePath+'/images/map/city_red.png',
					pickup: AE.props.muraThemePath+'/images/map/city_blue.png',
					chosen: AE.props.muraThemePath+'/images/map/chosen.png'
				},
				O: {//other (given city icon)
					icon: AE.props.muraThemePath+'/images/map/city_green.png',
					none: AE.props.muraThemePath+'/images/map/city_red.png',
					pickup: AE.props.muraThemePath+'/images/map/city_blue.png',
					chosen: AE.props.muraThemePath+'/images/map/chosen.png'
				},
				R: {//rail
					icon: AE.props.muraThemePath+'/images/map/rail_green.png',
					selected: AE.props.muraThemePath+'/images/map/rail_green.png',
					none: AE.props.muraThemePath+'/images/map/rail_red.png',
					pickup: AE.props.muraThemePath+'/images/map/rail_blue.png',
					chosen: AE.props.muraThemePath+'/images/map/chosen.png'
				},
				A: {//air
					icon: AE.props.muraThemePath+'/images/map/air_green.png',
					none: AE.props.muraThemePath+'/images/map/air_red.png',
					pickup: AE.props.muraThemePath+'/images/map/air_blue.png',
					chosen: AE.props.muraThemePath+'/images/map/chosen.png'
				},
				chosen: AE.props.muraThemePath+'/images/map/chosen.png'
			};
		},

	/* SHARED & GENERAL MAP FUNCTIONS */
	/* ================================== */

		// FUNCTION: Prevent map from loading until ui slide down is complete
		runDrawMap : function($target, dfd_myDeferred) {
			// toggle has finished opening run map functions
			if ( $target.hasClass('open') ) {
				dfd_myDeferred.resolve();
			}
		},

		// FUNCTION: Load Google Maps API and Marker label script
		loadGoogleMapsAPI : function() {
			// OPTIONAL API KEY
			// - if global variable has a key add it to API string call otherwise use free blank version
			// - also if a key is present it must be an allowed URL set in map admin account
			var stringAPI = (AE.props.googleMapsAPIKey != '') ? '?key=' + AE.props.googleMapsAPIKey + '' : '';
			//stringAPI += '&v=3.57';//WEBAEW3-6668 opt out of new version til we can handle it
			// CALL GOOGLE MAPS API
			$.getScript("https://maps.google.com/maps/api/js"+stringAPI+"&callback=initMap", function( data, textStatus, jqxhr ) {
				APP.props.$dfd_api.resolve(); // resolve api function
				
				// AJAX call to load marker label script after the api is finished loading
				if (textStatus === 'success') {
					$.ajax({
						type: "GET",
						url: ''+AE.props.muraThemePath+'/assets/markerwithlabel/markerwithlabel.min.js',
						cache: true,
						success: function () {
							APP.props.$mapAPILoaded = true; // set flag that API and Labels have been loaded
							APP.props.$dfd_markers.resolve(); // resolve markers function
						}
					});
				}
			});
		},


	/* DISPLAY OBJECT MAP FUNCTIONS */
	/* ================================== */

		// FUNCTION: Call Search Controller to load locations based on City and Country Code parameters
		loadDisplayObjectMap : function (cityName, cntryCode, container, suppName) {
			suppName = suppName || '';
			// Call location data from New location build data
			$.ajax({
				url: '/plugins/ae3/lib/searchController.cfc',
				dataType: "json",
				data: {
					method: 'getCityLocations',
					ccc: cntryCode,
					ccn: cityName,
					csn: suppName
				},
				success: function( data ) {
					// Search controller retured valid location data
					//if (!window.google && typeof !window.google === 'object' && typeof window.google.maps === 'object')
					if (!window.google || window.google !== 'object') {
						APP.buildRichSnippetJSON(data, cityName, cntryCode);	// Build Rich Snippets JSON file

						APP.loadGoogleMapsAPI();	// Call the function to load maps API

						// When both API and custom markers are done loading draw the map
						$.when( APP.props.$dfd_api, APP.props.$dfd_markers ).then(function() {
							AE.maps.drawLandingLocationMap( data, container, cityName, cntryCode );
						});
					} else {
						// This is for editing purposes when adjusting the map size and position
						// resizing the map does not work and only applies when editing display object
						AE.maps.drawLandingLocationMap( data, container, cityName, cntryCode );
					}
				}
			});
		},

		// FUNCTION: draw maps on landing pages, this is a display object include
		drawLandingLocationMap : function (json, container, city, country) {
			if(typeof(muraInlineEditor) !== 'undefined'){
				$(container).append('Mura Admin Note: Map content will be provided by Google Maps API on live page.');
				return false;
			}
			var mapOptions = {
				mapTypeControl: false,
				streetViewControl: false,
				scrollwheel: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};
			var map = new google.maps.Map( $(container)[0], mapOptions);
			var bounds = new google.maps.LatLngBounds();
			var markers = [];
			var infowindow = '';
			var locationPoints = [];

			$.each(json, function(index, item) {

				var thisLatLng = new google.maps.LatLng(item.latitude, item.longitude);	// Add geo coordinates for each location
				var pin = setMarkerType(item.hubtype_id);
				locationPoints.push({ geo: {lat: item.latitude, lng: item.longitude}, item: item, marker: pin });	// push coordinates to array
				bounds.extend(thisLatLng);	// add marker to larger bounds object
			});
			map.fitBounds(bounds);	// set bounds to encompass all map markers
			drop();	// drop markers function

			/* Add function if change map object to be a size that is not a fixed width
			// Reset map pins to be contained by bounding box on resize
			AE.addResizeTask({
				func:function() {
					map.fitBounds(bounds);
				}
			});
			*/

			// Set hubtype to correct marker image
			function setMarkerType(hub) {
				var pin = 'D';
				switch(hub){
					case 1:
						pin = 'A';
						break;
					case 2:
						pin = 'R';
						break;
					case 3,4,5:
						pin = 'D';
						break;
				}
				return pin
			}

			function drop() {
				// loop through each location from location array
				for (var i = 0; i < locationPoints.length; i++) {
					// drop all markers in two sets
					addMarkerWithTimeout(locationPoints[i], (i % 2) ? 1000 : 2000);
				}
			}

			// Drop Marker based on time out
			function addMarkerWithTimeout(items, timeout) {
				window.setTimeout(function() {
					var marker = new google.maps.Marker({
						icon: APP.pin_image[items.marker].icon,
						position: items.geo,
						map: map,
						animation: google.maps.Animation.BOUNCE,
						optimized: false
					});
					markers.push(marker);

					// Bounce once then stop animation
					setTimeout(function(){ marker.setAnimation(null); }, 750);

					var addressa = (items.item.locationlabela !== '') ? items.item.locationlabela+'<br/>' : '';
					var addressb = (items.item.locationlabelb !== '') ? items.item.locationlabelb+'<br/>' : '';
					var addressc = (items.item.locationlabelc !== '') ? items.item.locationlabelc+'<br/>' : '';

					// LISENTER EVENT: Marker Click
					google.maps.event.addListener(marker, 'click', function() {
						if (infowindow) {
							infowindow.close(); // Close all infowindows before opening a new one
						}
						// Create infowindow for current marker
						infowindow = new google.maps.InfoWindow();
						var infowindow_markup =
							'<h6 class="push-half--bottom">'+addressa+addressb+addressc+city+', '+country+'</h6>'+
							'<div><b>lat: </b>'+items.geo.lat+'&deg;, &nbsp;&nbsp;<b>long: </b>'+items.geo.lng+'&deg;</div>';

						infowindow.setContent(infowindow_markup);
						infowindow.open(map, marker);

						// sets marker and brings it to front
						this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
					});
				}, timeout);
			}
		},

		// FUNCTION: Build Rich Snippet markup JSON file so all map markers show up as a place
		buildRichSnippetJSON : function (json, city, country) {
			var jsonLD = [];	// create object
			// loop through each item build up in rich snippet format
			$.each(json, function(index, item) {
				// if third address is not blank add it to the address string
				var address = (item.locationlabelc !== '') ? item.locationlabelb+' '+item.locationlabelc : item.locationlabelb;
				// build JSON item with specific rich snippet markup
				var json_item = {
					"@context" : "http://schema.org",
					"@type"	: "Place",
					"name" : item.locationlabelb,
					"address":
						[{
							"@type" : "PostalAddress",
							"addressLocality" : city,
							"addressRegion" : country,
							"streetAddress" : address,
						}],
					"geo" :
						[{
							"@type" :"GeoCoordinates",
							"latitude" : item.latitude,
							"longitude" : item.longitude
						}]
				};
				jsonLD.push(json_item); // push each item to one array
			});
			// append json+ld file to head of document so rich snippets are loaded
			// $('head').append('<script type="application/ld+json">'+JSON.stringify(jsonLD)+'<\/script>');

			// WEBAE3-1427
			// Now appending to body so that Google's Structured Data Tool may pick it up
			// Vanilla JS seems to fail here, jQuery method is working?

			var code = JSON.stringify(jsonLD);
			var script = document.createElement('script');
			script.setAttribute('type', 'application/ld+json');

			script.appendChild(document.createTextNode(code));
			document.body.appendChild(script);

			// $('body').append('<script type="application/ld+json">'+JSON.stringify(jsonLD)+'<\/script>');
		}
	}
	return APP;
})();
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
/*
This object will be the returned result of a self-invoked function. This allows us to expose methods 
for use by other modules while protecting some variables in a closure. If the object is already 
defined then it's not altered. This prevents us from running the entire function each time one of its 
internal methods are called.
*/
AE.affiliate = AE.affiliate || (function(){
	/*
	DEPENDENCIES: AE.ui, AE.ui.dialog
	*/
	var APP = {
		init:function() {
			APP.props = {
				$checkBox		: 		$('#afftools__signup #terms'),
				$termsLink		: 		$('#afftools__signup label[for="terms"] a'),
				termsAccepted	:		false
			};
			
			// Affiliate navigation tabs
			AE.ui.contentGroup( $('.aff__nav-link'), $('.aff__content'), {visual:true, willSlide:false} );

			AE.ui.addBodyClickTask({func: APP.onBodyClick});
			AE.ui.addBodyChangeTask({func:function(event){APP.onBodyChange(event);}});

			// Affiliate Terms and Conditions Checkbox
			APP.props.$checkBox.on('click',function(event){
				if(!APP.props.termsAccepted) {
					APP.props.$termsLink.click();
				}
			});
			
			// Affiliate Terms and Conditions Terms Link
			APP.props.$termsLink.on('click',function(event){
				APP.affTerms(event);
			});

			if(AEdata.affiliate && AEdata.affiliate.props){
				if(AEdata.affiliate.selectedTab && AEdata.affiliate.selectedTab !== ''){
					$('.aff__nav-link[data-content="'+AEdata.affiliate.selectedTab+'"]').click();
				} else {
					// Travel Partner accounts default to account view
					if(AEdata.affiliate.props.isTP && AEdata.affiliate.props.isTP == true) {
						$('#acct').removeClass('visuallyhidden');
					} else {
						$('#settings').removeClass('visuallyhidden');
					}
				}
				if(AEdata.affiliate.props.loadColors){
					// Color Changer Utility Docs: https://github.com/nathanielwiley/conpigurator
					/*new Conpigurator('color1',true).addTarget('color1','backgroundColor').update();
					new Conpigurator('color2',true).addTarget('color2','backgroundColor').update();
					new Conpigurator('color3',true).addTarget('color3','backgroundColor').update();
					new Conpigurator('color4',true).addTarget('color4','backgroundColor').update();*/
					// Color Changer Utility Docs: https://bgrins.github.io/spectrum/
					$('input.input--spectrum').spectrum({
						preferredFormat:'hex',
						showInput:true,
						showButtons:true,
						chooseText:AEdata.affiliate.oLang.colors.choose,
						cancelText:AEdata.affiliate.oLang.colors.cancel
					});
				}
			}
		},
		
		affTerms:function(event){	
			var haveTerms = (APP.props.$termsLink.data('aff-terms') && APP.props.$termsLink.data('aff-terms').length) ? true : false;
			var showBtns = true;

			// Prevent link for bubbling and also register as a checkbox click
			event.preventDefault();
			
			// Don't show accept and decline if terms have been checked
			if(APP.props.termsAccepted) { showBtns = false;	}
			
			if (haveTerms) {
				var termsData = JSON.parse(decodeURIComponent(APP.props.$termsLink.data('aff-terms')));
				var buttonOptions = {};
				
				// If terms checkbox is not checked show accept and decline buttons
				if(showBtns) {
					var oButtons = {};// Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text
					oButtons[termsData.ACCEPT] = function() {// Accept Button
						APP.props.$checkBox.prop('checked',true);
						APP.props.termsAccepted = true;
						APP.props.$checkBox.parent().removeClass('ui-state-invalid');
						AE.ui.dialog.close();
					}
					oButtons[termsData.DECLINE] = function() {// Decline Button
						APP.props.$checkBox.prop('checked',false);
						APP.props.$checkBox.parent().addClass('ui-state-invalid');
						AE.ui.dialog.close();
					}
					
					// Accept and Decline Terms
					AE.ui.dialog.launch({
						id:'aff-terms',
						dialogClass: 'top-dialog',
						title: termsData.HEAD,
						type:'standard',
						content: termsData.BODY,
						buttons: oButtons,
						buttonOpts: {
							setClass: 'align-center',
							lastButtonClass: 'btn--base',
							firstButtonClass: 'btn--primary',
							exclusiveClose: true
						},
						width: ($(window).width() > 900) ? 850 : '80%'
					});
				} else {
					// No Buttons as terms already accepted
					AE.ui.dialog.launch({
						id:'aff-terms',
						dialogClass: 'top-dialog',
						title: termsData.HEAD,
						type:'standard',
						content: termsData.BODY,
						width: ($(window).width() > 900) ? 850 : '80%'
					});
				}
			}
		},

		onBodyChange: function(event,$target){
			if(event.target.id === 'affLogo' && event.target.type === 'file'){
				if(event.target.value !== ''){
					$('button.trg--affSiteLogo').attr('type','submit')
						.addClass('btn--primary btn--affOp')
						.removeClass('btn--cancel btn--disabled');
				} else {
					$('button.trg--affSiteLogo').attr('type','button')
						.removeClass('btn--primary btn--affOp')
						.addClass('btn--cancel btn--disabled');
				}
			}
		},
		onBodyClick: function(event,$target){
			if($target.hasClass('btn--affOp')){
				AE.ui.disableClicks();
				AE.forms.addSpinGear( $target );
				if($target.hasClass('trg--affSiteColors')){
					$('input.sp-input').change();
				}
				setTimeout(function(){
					if($('.ui-state-invalid').length > 0){
						AE.ui.enableClicks();
						AE.forms.removeSpinGear( $target );
						$('.ui-state-invalid').first().focus();
					}
				},250);
			}
		}
	}
	return APP;
})();
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.feeds = AE.feeds || (function() {
	/*
	DEPENDENCIES: AE
	*/
	var APP = {
		init:function() {
			APP.props = {
				$keywords: $('.feedkeywordSearch:visible'),
				$bttnfeedSearch: $('.btnFeedSearch:visible'),
				storageAvailable: true
			},

			AE.ui.addBodyClickTask({
				func: APP.onBodyClick
			});

						try { sessionStorage; }
			catch (err) { APP.props.storageAvailable = false; }

			if (!$('div#blog_posts').length) {
				if (APP.props.storageAvailable) {
					sessionStorage.removeItem("keywords");
					sessionStorage.removeItem("isSearch");
					sessionStorage.removeItem("feedListing");
					sessionStorage.removeItem("isFromPost");
					sessionStorage.removeItem("pageNo");
					sessionStorage.removeItem("remoteID");
				}
			} else {
				if (APP.props.storageAvailable) {
					if (!sessionStorage.getItem("pageNo")) { sessionStorage.setItem("pageNo", '1'); }

					if (!sessionStorage.getItem("keywords")) {
						sessionStorage.setItem("isSearch", false);
						sessionStorage.setItem("keywords", '');
					}

					if (APP.props.$bttnfeedSearch.hasClass('blog_post')) {
						sessionStorage.setItem("isFromPost",false);
						sessionStorage.setItem("feedListing",false);
					} else {
						sessionStorage.setItem("feedListing",true);
						sessionStorage.setItem("remoteID",$("#feedRemoteID").val());
					}

					if (sessionStorage.getItem("keywords")) {
						$("input#keywords").val(decodeURI(sessionStorage.getItem("keywords")));
					}
				}

				$("#feedResultsBykeyword").html('');
				$("#feedResults").addClass('visuallyhidden');
				$("#feedResultsBykeyword").addClass('visuallyhidden');

				if (APP.props.storageAvailable) {
					if (sessionStorage.getItem("feedListing") && sessionStorage.getItem("feedListing")=='true' && sessionStorage.getItem("isSearch") == 'true') {
						APP.loadCustomFeed(false,APP.props.$bttnfeedSearch);
						$("div#feedResults").addClass('visuallyhidden');
					} else {
						$("div#feedResults").removeClass('visuallyhidden');
					}
				}

				$('#keywords,.btnFeedSearch').keydown(function(e) {
					var key = e.which;
					if (key == 13) {
						if (e.which == 13) {
							jQuery(this).blur();
							jQuery('.btnFeedSearch').focus().click();
							return false;
						}
					}
				});
			}
		},
		onBodyClick: function (event, $target) {
			if (event.which !== 13) {
				if ($target.attr('id') == 'category_select' && $target.val() != '') {
					if (APP.props.storageAvailable) {
						sessionStorage.removeItem("keywords");
						sessionStorage.removeItem("isSearch");
						sessionStorage.setItem("feedListing", false);
						sessionStorage.setItem("isFromPost", false);
						sessionStorage.setItem("pageNo", 1);
					}
					var pathname = window.location.pathname;
					if	(pathname != $target.val())	{
						APP.changeCategories($target.val());
					}
				}

				if (APP.props.storageAvailable) {
					if ($target.parent().hasClass('readmore')) {
						sessionStorage.setItem("feedListing", false);
						sessionStorage.setItem("keywords", '');
						sessionStorage.setItem("isSearch", false);
					} else {
						sessionStorage.setItem("feedListing", true);
					}
				}

				if ($target.hasClass("btnFeedSearch")) {
					event.preventDefault() ;
					if (APP.props.storageAvailable) { sessionStorage.setItem("feedListing",true); }
					var currentSearch = sessionStorage.getItem("keywords");

					var keywords = encodeURIComponent($(".feedkeywordSearch:visible").val());
					var baseURL  = $($target).data("url");

					if (APP.props.storageAvailable) {
						if ($($target).hasClass("blog_post")) {
							sessionStorage.setItem("isFromPost", true);
							AE.forms.addSpinGear($target);
						} else {
							sessionStorage.setItem("isFromPost", false);
						}
					}

					if (keywords.length != 0) {
						if (APP.props.storageAvailable) {
							sessionStorage.setItem("keywords", keywords);
							sessionStorage.setItem("isSearch", true);
							if (sessionStorage.getItem("keywords") != currentSearch) {
								sessionStorage.setItem("pageNo", 1);
							}
							if (sessionStorage.getItem("isFromPost") == 'true') {
								window.location.href = baseURL;
							} else {
								APP.loadCustomFeed(false,$target);
							}
						}
					} else {
						$("#currentSearch").val('');
						$("#currentPage").val('');
						if (APP.props.storageAvailable) {
							sessionStorage.setItem("keywords", '');
							sessionStorage.setItem("pageNo", '1');
							sessionStorage.setItem("isSearch", false);
							if (sessionStorage.getItem("isFromPost") == 'true') {
								window.location.href = baseURL;
							} else {
								$("#feedResultsBykeyword").addClass('visuallyhidden');
								$("#feedResults").removeClass('visuallyhidden');
							}
						}
					}
				}

				if ($target.is("#blog-page-number")) {
					event.preventDefault() ;
					if (APP.props.storageAvailable) { sessionStorage.setItem("pageNo", $(event.target).attr('data-page')); }
					var str = $target.attr("href");
					APP.loadCustomFeed(true,'');
				}
			}
		},
		loadCustomFeed:function(scrollTop,$target) {
			var cfc = '/plugins/ae3/lib/customFeeds.cfc?method=searchFeed';
			var remoteID = (APP.props.storageAvailable) ? sessionStorage.getItem('remoteID') : "";
			var keywords = (APP.props.storageAvailable) ? sessionStorage.getItem('keywords') : "";
			var pageNo = (APP.props.storageAvailable) ? sessionStorage.getItem('pageNo') : "";

			/*WEBAE3-3504: hide so that the searching blog shows up in content_blog.cfm $("#search_wait_mess").html('');	*/
			$("div#search_wait_mess").removeClass('visuallyhidden');

			if ($target && $target.hasClass("btnFeedSearch")) {
				AE.forms.addSpinGear($target);
				/*WEBAE3-3504: set empty $("#feedResultsBykeyword").html('<h4>Searching Blogs.....</h4>');*/
				$("#feedResultsBykeyword").html('');
			}
			
			$.ajax({
				type: "POST",
				url: cfc,
				dataType: 'json',
				data: { remoteID:remoteID, keywords:keywords, pageNo:pageNo },
				success: function(result) {
					$("div#search_wait_mess").addClass('visuallyhidden');
					$("#feedResultsBykeyword").html('');
					$("#feedResultsBykeyword").html(result);
					APP.showHide('feedResultsBykeyword','feedResults');
					AE.forms.removeSpinGear($target);
					if (scrollTop) {
						$('#blog-scroll')[0].scrollIntoView({behavior:'smooth',block: 'start'});
					}
				},
				error: function (xhr, ajaxOptions, thrownError) {
				}
			});
		},
		showHide:function(show,hide) {
			$("#" + hide).addClass('visuallyhidden');
			$("#" + show).removeClass('visuallyhidden');
		},
		getUrlParameter:function(name,str) {
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
			var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
			var results = regex.exec(str);

			return (results === null) ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
		},
		changeCategories:function(url) {
			document.location.href = url;
		}
	};

	return APP;
})();

/*
AE.init.general: Resolves the deferred object for the general list of modules.
*/
objDFD.general.resolve();